/* eslint-disable import/no-cycle */
/* eslint-disable no-case-declarations */
/* eslint-disable no-continue */
/* eslint-disable array-callback-return */
/* eslint-disable no-new-func */
/* eslint-disable camelcase */
/* eslint-disable one-var */
/* eslint-disable default-case */
/* eslint-disable no-else-return */
/* eslint-disable no-unused-vars */
/* eslint-disable no-plusplus */
/* eslint-disable no-const-assign */
/* eslint-disable guard-for-in */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-use-before-define */
import { useDispatch } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { Tag, Modal, message } from 'antd';
import { ExclamationCircleOutlined, CloseOutlined } from '@ant-design/icons';
import * as moment from 'moment';
import $ from 'jquery';
import _, { template } from 'lodash';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { useParams } from 'react-router-dom';
import axios from 'axios'; // Make sure to import axios or a similar HTTP library
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { SESSION_KEYS } from './constants/index';
import useObjectDiff from './object-diff';
import { getAngularURL, getEnvironmentHost, getGoogleAPIKey } from '../config/env-config';
import { Message } from '../components/cp-messages/cp-message';
import {
  form,
  activityConstant,
  templates,
  accountsConstant,
  colorsPalette,
  txnForm,
  dashboardConstant,
} from '../constants';
import useBizAccountObjPermissions from '../components/cp-biz-account-permission';
import { getSession, removeSession, setSession } from '../services/storage-service';
import { getBizCode, getBusinessDetails, setBizCode } from '../services/business-details-service';
import currency from '../data/currency.json';
import {
  getHideFieldsArray,
  getLoginAccessToken,
  getLoginBusinessId,
  getLoginRes,
  getPaccessId,
  getSelectedLookupFormData,
  getSourceTxnData,
  getTxnFormData,
  setAttachmentsData,
  setHideFieldsArray,
  setSelectedLookupFormData,
  setSourceTxnData,
  setSubFormAttachmentsData,
  setTxnFormData,
} from '../services/auth-details-service';
// eslint-disable-next-line import/no-cycle
import {
  addTableBulkRows,
  getLookupData,
  getLookupTxnData,
  getTableRowsById,
  getTxnDetailsByTxnID,
  removeTableBulkRows,
  removeTableRow,
} from '../actions/api-actions';
// eslint-disable-next-line import/no-cycle
import ScriptLogicWrapperService from '../services/scriptLogic-wrapper-service';
// eslint-disable-next-line import/no-named-as-default
import ApiService from '../config/api/api-service';
import { ApiLibrary } from '../config/api/api-library';
import logger from '../services/logger';

/**
 * Return ellipsis of a given string
 * @param {string} text
 * @param {number} size
 */
const ellipsis = (text, size) => {
  return `${text.split(' ').slice(0, size).join(' ')}...`;
};

const { confirm } = Modal;
const objectDiff = useObjectDiff();


const basePath = () => {
  const { bizCode } = useParams();
  setBizCode(bizCode);
  return `/home/${bizCode}`;
};

const getBizCodeFromUtill = () => {
  const { bizCode } = useParams();
  return bizCode;
};

const dispatchAction = (actionType, data) => async () => {
  const dispatch = useDispatch();
  dispatch({ type: actionType, payload: data });
};

const dispatchBizData = (payload) => {
  const dispatch = useDispatch();
  dispatch({ type: 'BIZ_DATA', payload });
};

const getDefaultDateRange = (currentMonth, laterMonths) => {
  const currentDate = currentMonth ? moment(currentMonth).startOf('month') : moment().startOf('month');
  const endDate = laterMonths ? moment(laterMonths).endOf('month') : moment().add(6, 'months').endOf('month');

  const disabledDate = (current) => {
    // Disable dates before the start date and after the end date
    return current && (current < currentDate || current > endDate);
  };

  return { startDate: currentDate, endDate, disabledDate };
};

const getPerspectObjFields = (pId, serviceType, txnId, businessId) => {
  businessId = getLoginBusinessId();
  const bizAccountObjPermissions = useBizAccountObjPermissions(businessId);
  if (serviceType && bizAccountObjPermissions?.objPermissions[serviceType]) {
    let fields = {};
    const accessObjs = bizAccountObjPermissions?.objPermissions[serviceType];

    Object.keys(accessObjs)?.forEach((key) => {
      const accessObj = accessObjs[key];
      if (accessObj && accessObj.perspectiveId === pId && accessObj.view) {
        const obj = accessObj || {};
        fields = txnId ? obj.view.details.fields : obj.view.create.fields;
      }
    });
    return fields;
  }
};

const readFieldPermission = (refId, pId, serviceType, txnId) => {
  const businessId = getLoginBusinessId();
  const fields = getPerspectObjFields(pId, serviceType, txnId, businessId) || {};

  let permission;
  // Checking * permission or not
  if (fields['*'] === '*') {
    // eslint-disable-next-line no-const-assign
    permission = false;
  } else {
    // eslint-disable-next-line no-unneeded-ternary
    permission = fields[refId] === 'SHOW' ? true : false;
  }
  return permission;
};

// Define a global function to calculate font size based on the input value.
// If the value is provided, return the value with "px" appended.
// Otherwise, return the default font size of "15px".
const getFontSizeValue = (val) => {
  if (val) {
    return `${val}px`;
  }
  return '15px';
};

// text field validations.
// Define a global function to get validation rules based on the input field properties.
const getTextFieldValidationRules = (fieldData) => {
  const textRules = [];
  if (!fieldData?.isSkippable && !fieldData?.value) {
    textRules.push({
      required: !fieldData?.isSkippable,
      message: `${form.DYNAMIC_FORM.MANDATORY} : ${fieldData?.label}`,
    });
  }
  if (!fieldData?.isSkippable && fieldData?.value?.length > 0) {
    textRules.push(
      {
        min: fieldData?.minChars, // Minimum character length validation
        message: `${form.DYNAMIC_FORM.PLEASE_ENTER} ${fieldData?.minChars} ${form.DYNAMIC_FORM.CHARACTERS} : ${fieldData?.label}`,
      },
      {
        max: fieldData?.maxChars, // Maximum character length validation
        message: `${form.DYNAMIC_FORM.SHOULD_NOT} ${fieldData?.maxChars} ${form.DYNAMIC_FORM.CHARACTERS} : ${fieldData?.label}`,
      },
    );
  }
  return textRules;
};

// number field validations.
// Define a global function to get validation rules based on the input field properties.
const getNumberFieldValidationRules = (fieldData) => {
  const numberRules = [];
  if (!fieldData?.isSkippable && !fieldData?.value) {
    numberRules.push({
      required: !fieldData?.isSkippable,
      message: `${form.DYNAMIC_FORM.MANDATORY} : ${fieldData?.label}`,
    });
  }
  if (!fieldData?.isSkippable && fieldData?.value) {
    numberRules.push(
      {
        min: fieldData?.minDigits, // Minimum character length validation
        message: `${form.DYNAMIC_FORM.PLEASE_PROVIDE} ${fieldData?.minDigits} ${form.DYNAMIC_FORM.DIGITS} : ${fieldData?.label}`,
      },
      {
        max: fieldData?.maxDigits, // Maximum character length validation
        message: `${form.DYNAMIC_FORM.SHOULD_NOT} ${fieldData?.maxDigits} ${form.DYNAMIC_FORM.DIGITS} : ${fieldData?.label}`,
      },
    );
  }
  return numberRules;
};

// text field validations.
// Define a global function to get validation rules based on the input field properties.
const getTextAreaFieldValidationRules = (fieldData) => {
  if (!fieldData.isSkippable && !fieldData?.value) {
    return [
      {
        required: !fieldData.isSkippable,
        message: `${form.DYNAMIC_FORM.MANDATORY} : ${fieldData?.label}`,
      },
    ];
  }
};

// Custom validation function for mobile number
const validateMobileNumber = (value, fieldData) => {
  if (value && typeof value === 'string' && !value.includes('+')) {
    value = `+91${value}`;
  } else if (!value && value !== '') {
    value = '+91';
  }
  const phoneNum = parsePhoneNumberFromString(value);

  if (phoneNum === undefined || Object.keys(phoneNum).length === 0) {
    delete fieldData.code;
    delete fieldData.normalNum;
    fieldData.value = value;
    if (value && value !== '') fieldData.isValid = false;
    else fieldData.isValid = !!fieldData.isSkippable;
  } else if (phoneNum !== undefined && Object.keys(phoneNum).length !== 0) {
    fieldData.value = phoneNum.format('INTERNATIONAL');
    fieldData.code = phoneNum.countryCallingCode;
    fieldData.normalNum = phoneNum.nationalNumber;
    fieldData.isValid = phoneNum.isValid();
  }
};

// Custom validation function for email
const validateEmail = (rule, value, callback) => {
  // Regular expression to check if the value is a valid email
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  logger.debug('EMAIL VALIDATION {} ', rule, value);
  if (rule?.required && !value) {
    callback(`${rule.field} is required`);
  } else if (value && !emailRegex.test(value)) {
    callback(`${form.DYNAMIC_FORM.EMAIL_VALIDATION_MSG} ${rule?.field}`);
  } else {
    callback();
  }
};

const getEmailFieldValidationRules = (fieldData) => {
  const emailValidationRules = [
    {
      validator: validateEmail,
    },
  ];

  // Add additional validation rule for comma-separated emails if v.allowCsv is true
  if (fieldData?.allowCsv) {
    emailValidationRules.push({
      validator: (rule, value, callback) => {
        // Custom validation function for comma-separated emails
        const regExp = /^(\s?[^\s,]+@[^\s,]+\.[^\s,]+\s?,)*(\s?[^\s,]+@[^\s,]+\.[^\s,]+)$/;
        const result = regExp.test(value);

        if (!result) {
          callback(`${form.DYNAMIC_FORM.EMAIL_VALIDATION_MSG} : ${fieldData?.label}`);
        } else {
          callback();
        }
      },
    });
  }

  return emailValidationRules;
};

const getCurrencySymbol = (businessData) => {
  const bizData = businessData || getBusinessDetails();
  const currencyObj = currency[bizData?.generalInfo?.currency];
  const currencyData = currencyObj?.symbol_native ? currencyObj?.symbol_native : '';
  setSession(`${bizData?.id}_biz_currency_symbol`, currencyData);
  return currencyData;
};

/**
 * The function randomColor generates a random hexadecimal color code.
 * @returns The function `randomColor` returns a randomly generated color in hexadecimal format.
 */
const randomColor = (string) => {
  let strToUse = string || '';

  if (strToUse.length > 0) {
    strToUse = strToUse.substr(0, 2);
  }
  strToUse = strToUse.toUpperCase();
  const charIndex = strToUse.charCodeAt(0);
  const colorIndex = charIndex % colorsPalette.length;
  const bgColor = colorsPalette[colorIndex];
  return bgColor;
};

function convertToObj(a, b) {
  if (a.length !== b.length || a.length === 0 || b.length === 0) {
    return null;
  }
  const obj = {};

  // Using the foreach method
  a.forEach((k, i) => {
    obj[k] = b[i];
  });
  return obj;
}

const processLookupOptions = (res, currentFieldObj) => {
  if (!currentFieldObj) return '';
  if (typeof res.data !== 'undefined') {
    const options = [];

    res?.data?.data?.content.forEach((val) => {
      let str = '';
      const obj = {};

      currentFieldObj?.displayFields?.forEach((fieldKey) => {
        let preparedValue = '';
        let resObj = null;

        if (fieldKey.includes('fields.')) {
          resObj = val.fields[fieldKey.replace('fields.', '')];

          if (resObj && resObj.type === templates.UI_TEMPLATES.MOBILE_NUMBER_UI_TEMPLATE) {
            preparedValue = `+${resObj.code} ${resObj.value}`;
          } else if (resObj && resObj.type === templates.UI_TEMPLATES.DATE_PICKER_UI_TEMPLATE) {
            preparedValue = resObj.value;
            //  $filter('date')(resObj.value); // Make sure you have a date filter function
          } else {
            preparedValue = resObj ? resObj.value : '';
          }

          if (resObj && resObj.type !== templates.UI_TEMPLATES.IMAGE_UPLOAD_UI_TEMPLATE) {
            str = preparedValue;
          }
        } else {
          preparedValue = val[fieldKey];
          str = preparedValue;
        }

        obj[fieldKey] = {
          value: preparedValue,
          type: resObj ? resObj.type : '',
        };
      });

      if (str && str !== '') options.push(str);
    });

    logger.debug(options);

    if (typeof currentFieldObj !== 'undefined') {
      const uniqueOptions = [...currentFieldObj.options, ...options];
      currentFieldObj.options = [...new Set(uniqueOptions)];
    }

    currentFieldObj.pageIndex = res?.data?.data?.nextPageIndex;
  }
};

const gotoLoginPage = (isTrue) => {
  const code = getBizCode();
  const businessId = getLoginBusinessId();
  removeSession(`${code}${SESSION_KEYS.LOGIN_RES}`);
  removeSession(`${code}${SESSION_KEYS.DEFAULT_BIZ_CODE}`);
  removeSession(`${SESSION_KEYS.DEFAULT_BIZ_CODE}`);
  removeSession(`${businessId}_biz_Accocunt_user_obj`);
  removeSession(`${businessId}_biz_currency_symbol`);
  removeSession(`${businessId}_biz_accocunt_user_consumer_list`);
  removeSession(`${businessId}_biz_accocunt_user_service_list`);
  removeSession(`_msalloginBizcode`);
  removeSession(`_google_loginBizcode`);
  removeSession(`${code}_${SESSION_KEYS.KIOSK_MODE}`, true);
  if (isTrue) {
    return;
  }
  window.location.href = `${window.location.origin}/${code}/login`;
};

// This function handleActivityImage will handle the activity platform types and return image icons based on platform types
const handleActivityImage = (platformTags) => {
  switch (platformTags) {
    case activityConstant.ACTIVITY_PLATFORM_TYPES.USR_STAFF:
      return activityConstant.ICONS.ICON_STAFF;

    case activityConstant.ACTIVITY_PLATFORM_TYPES.USR_INDIVIDUAL:
      return activityConstant.ICONS.ICON_CUSTOMERS;

    case activityConstant.ACTIVITY_PLATFORM_TYPES.USR_GROUP:
      return activityConstant.ICONS.ICON_GROUP;

    case activityConstant.ACTIVITY_PLATFORM_TYPES.TXN_BOOKING:
      return activityConstant.ICONS.ICON_BOOKINGS;

    case activityConstant.ACTIVITY_PLATFORM_TYPES.TXN_BUYING:
      return activityConstant.ICONS.ICON_BUYING;

    case activityConstant.ACTIVITY_PLATFORM_TYPES.TXN_FORM:
      return activityConstant.ICONS.ICON_SERVICES;

    case activityConstant.ACTIVITY_PLATFORM_TYPES.TASK:
      return activityConstant.ICONS.TASK_ICON;

    case activityConstant.ACTIVITY_PLATFORM_TYPES.PRODUCT:
      return activityConstant.ICONS.ICON_PRODUCTS;

    case activityConstant.ACTIVITY_PLATFORM_TYPES.RESOURCE:
      return activityConstant.ICONS.ICON_TIME_RESOURCE;

    case activityConstant.ACTIVITY_PLATFORM_TYPES.INVITATION:
      return activityConstant.ICONS.ICON_INVITATION_SENT;

    case activityConstant.ACTIVITY_PLATFORM_TYPES.BUSINESS_TEAM:
      return activityConstant.ICONS.ICON_BUSINESS_TEAM;

    case activityConstant.ACTIVITY_PLATFORM_TYPES.USER_STATE_CHANGE:
      return activityConstant.ICONS.ICON_USER_STATE_CHANGE;

    case activityConstant.ACTIVITY_PLATFORM_TYPES.PPT_ACCESS:
      return activityConstant.ICONS.ICON_RATE_PLANS;

    case activityConstant.ACTIVITY_PLATFORM_TYPES.DATA_FLOW:
      return activityConstant.ICONS.ICON_CONNECTORS;

    case activityConstant.ACTIVITY_PLATFORM_TYPES.SERVICE:
      return activityConstant.ICONS.ICON_SERVICES;

    case activityConstant.ACTIVITY_PLATFORM_TYPES.BUSINESS_ACCOUNT:
      return activityConstant.ICONS.ICON_STAFF;

    case activityConstant.ACTIVITY_PLATFORM_TYPES.TABLE:
      return activityConstant.ICONS.ICON_TABLE;

    case activityConstant.ACTIVITY_PLATFORM_TYPES.SUB_FORM:
      return activityConstant.ICONS.ICON_SUB_FORM;

    case activityConstant.ACTIVITY_PLATFORM_TYPES.CLIENT_REGISTRY:
      return activityConstant.ICONS.ICON_CLIENT_REGISTRY;

    case 'ACTION_FLOW':
      return activityConstant.ICONS.ICON_SERVICES;

    default:
      return activityConstant.ICONS.ICON_STAFF;
  }
};

// Debounce function
function debounce(func, delay) {
  let timeoutId;

  return function (...args) {
    const context = this;

    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func.apply(context, args), delay);
  };
}

/**
 * The function `handleTags` takes a type as input and returns a corresponding tag element based on the
 * type.
 * @param type - The `type` parameter is a string that represents the status of a process. It can have
 * one of the following values: "IN_PROCESS", "COMPLETED", or "FAILED".
 * @returns The function `handleTags` returns a JSX element based on the value of the `type` parameter.
 * If `type` is equal to 'IN_PROCESS', it returns a `<Tag>` component with a gold color. If `type` is
 * equal to 'COMPLETED', it returns a `<Tag>` component with a blue color. If `type` is equal to
 * 'FAILED', it returns a
 */
const handleTags = (type, className) => {
  switch (type) {
    case 'IN_PROCESS': {
      return (
        <Tag color="gold" size="large" className={className}>
          IN PROGRESS
        </Tag>
      );
    }
    case 'COMPLETED': {
      return (
        <Tag color="#108ee9" size="large" className={className}>
          {type.replace(/_/g, ' ')}
        </Tag>
      );
    }
    case 'FAILED': {
      return (
        <Tag color="#f50" size="large" className={className}>
          {type.replace(/_/g, ' ')}
        </Tag>
      );
    }
    case 'IN_PROGRESS': {
      return (
        <Tag color="gold" size="large" className={className}>
          IN PROGRESS
        </Tag>
      );
    }
    default: {
      break;
    }
  }
};
const formatDate = (dateString) => {
  const months = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];

  const dateObj = new Date(dateString);
  const day = dateObj.getDate();
  const month = months[dateObj.getMonth()];
  const year = dateObj.getFullYear();

  return `${day} ${month} ${year}`;
};

const getgoogleMapsEmbedURL = (lat, lng, mode = 'place') => {
  const embedURL = `https://www.google.com/maps/embed/v1/${mode}?key=${getGoogleAPIKey()}&q=${lat},${lng}&zoom=15`;
  return embedURL;
};

const getDisplayFields = (displayfields, keyword, lookupType) => {
  const numberDisplayFields = []; // Replace this with the actual array of number display fields
  // eslint-disable-next-line no-use-before-define
  const lookupServiceData = getServiceData(lookupType);
  if (keyword) {
    displayfields?.forEach((fieldKey) => {
      let resObj = null;
      if (fieldKey?.includes('fields.')) {
        const displayFieldKey = fieldKey?.replace('fields.', '');
        resObj = lookupServiceData.fields[displayFieldKey];
        if (
          resObj &&
          (resObj.type === templates.UI_TEMPLATES?.CURRENCY_UI_TEMPLATE ||
            resObj.type === templates.UI_TEMPLATES?.NUMBER_UI_TEMPLATE)
        ) {
          numberDisplayFields.push(fieldKey);
        }
      }
    });
  }
  const currentDisplayFields = displayfields.filter((disKey) => {
    return !_.includes(numberDisplayFields, disKey);
  });

  return currentDisplayFields;
};

// getting the apps or consumer data based on the type.
const getServiceData = (type, businessId) => {
  businessId = getLoginBusinessId();
  const bizAccountServiceList = getSession(`${businessId}_biz_accocunt_user_service_list`, true);
  const bizAccountConsumersList = getSession(`${businessId}_biz_accocunt_user_consumer_list`, true);
  let data = {};
  if (type && type?.includes('USR_TYPE')) {
    data = bizAccountConsumersList?.bizAccountConsumersList[type];
  } else if (type && bizAccountServiceList && bizAccountServiceList?.bizAccountServiceList) {
    data = bizAccountServiceList?.bizAccountServiceList[type];
  }
  return data;
};

const processOptions = (content, lookupType, displayFields, businessId, currentFieldObj) => {
  businessId = getLoginBusinessId();
  const lookuptypeService = getServiceData(lookupType, businessId);

  const options = [];
  const numberDisplayFields = [];
  const currencySymbol = getSession(`${businessId}_biz_currency_symbol`);
  let normalFields = currentFieldObj?.displayFields?.slice();

  content?.forEach((val) => {
    const str = [];
    const obj = {};
    let imgUrl = null;

    displayFields.forEach((fieldKey) => {
      let preparedValue = '';
      let resObj = null;

      if (fieldKey.includes('fields.') && val.fields) {
        resObj = val.fields[fieldKey.replace('fields.', '')];

        if (resObj && resObj.type === templates.UI_TEMPLATES.MOBILE_NUMBER_UI_TEMPLATE) {
          preparedValue = `+${resObj.code} ${resObj.value}`;
        } else if (resObj && resObj.type === templates.UI_TEMPLATES.DATE_PICKER_UI_TEMPLATE) {
          preparedValue = moment(resObj.value).format('MMM DD, YYYY');
        } else if (resObj && resObj.type === templates.UI_TEMPLATES.CURRENCY_UI_TEMPLATE) {
          const fieldName = fieldKey.replace('fields.', '');
          const precision = lookuptypeService.fields?.[fieldName]?.decimalPositions;
          preparedValue =
            currencySymbol === '₹'
              ? `₹ ${resObj.value.toFixed(precision)}`
              : `${currencySymbol} ${resObj.value.toFixed(precision)}`;
        } else {
          preparedValue = resObj ? resObj.value : '';
        }

        if (
          resObj &&
          resObj.type !== templates.UI_TEMPLATES.IMAGE_UPLOAD_UI_TEMPLATE &&
          preparedValue &&
          preparedValue !== ''
        ) {
          str.push(preparedValue);
        }

        if (
          resObj &&
          resObj.type === templates.UI_TEMPLATES.IMAGE_UPLOAD_UI_TEMPLATE &&
          preparedValue &&
          preparedValue !== ''
        ) {
          imgUrl = preparedValue;
          normalFields = _.without(normalFields, fieldKey);
        }

        if (
          resObj &&
          (resObj.type === templates.UI_TEMPLATES?.CURRENCY_UI_TEMPLATE ||
            resObj.type === templates.UI_TEMPLATES?.NUMBER_UI_TEMPLATE)
        ) {
          numberDisplayFields.push(fieldKey);
          // numberDisplayFields = _.uniq(numberDisplayFields);
          // numberDisplayFields = [...new Set(numberDisplayFields)];
        }
      } else {
        preparedValue = val[fieldKey];
        str.push(preparedValue);
      }

      obj[fieldKey] = {
        value: preparedValue,
        type: resObj ? resObj.type : '',
      };
    });

    obj.id = val?.id;
    obj.valueArr = str;
    obj.value = str?.join('');
    obj.lookupType = lookupType;
    obj.imgUrl = imgUrl;
    options.push(obj);
  });

  if (typeof currentFieldObj !== 'undefined') {
    currentFieldObj.normalFields = normalFields;
    // Use Set to remove duplicates based on id property
    const uniqueOptionsSet = new Set([...currentFieldObj.options, ...options].map((item) => item.id));
    currentFieldObj.options = Array.from(uniqueOptionsSet).map((id) => {
      return [...currentFieldObj.options, ...options].find((item) => item.id === id);
    });
  }
};

// getting the field col width dynamically.
const getFieldWidth = (columnWidth) => {
  let width = 24;

  if (columnWidth === 'col-3 col-sm-3') {
    width = 6;
  }
  if (columnWidth === 'col-4 col-sm-4') {
    width = 8;
  }
  if (columnWidth === 'col-6 col-sm-6') {
    width = 12;
  }
  if (columnWidth === 'col-8 col-sm-8') {
    width = 16;
  }
  if (columnWidth === 'col-9 col-sm-9') {
    width = 18;
  }
  if (columnWidth === 'col-12 col-sm-12') {
    width = 24;
  }

  return width;
};

// getting the field col width dynamically.
const getFieldStyle = (fieldData) => {

  // getting the kiosk mode status
  const bizCode = getBizCode();
  const kioskKey = `${bizCode}_${SESSION_KEYS.KIOSK_MODE}`;
  const isKioskMode = getSession(`${kioskKey}`, true); 

  let columnWidth = fieldData?.columnWidth;
  const deviceType = getSession('DEVICE_TYPE');

  if(fieldData.hasOwnProperty('profileSize')){
    columnWidth = fieldData?.profileSize;
  }
 
  // let columnSpan = "auto/span 1";
  // let rowSpan = "auto/span 1";
  let rowWidth = "100%";

  if (columnWidth === 'col-3 col-sm-3') {
    // columnSpan = "span 1";
    rowWidth = "25%";
  }
  if (columnWidth === 'col-4 col-sm-4') {
    // columnSpan = "span 2";
    rowWidth = "33.33333333%";
  }
  if (columnWidth === 'col-6 col-sm-6') {
    // columnSpan = "span 3";
    rowWidth = "50%";
  }
  if (columnWidth === 'col-8 col-sm-8') {
    // columnSpan = "span 4";
    rowWidth = "66.66666666%";
  }
  if (columnWidth === 'col-9 col-sm-9') {
    // columnSpan = "span 5";
    rowWidth = "75%";
  }
  if (columnWidth === 'col-12 col-sm-12') {
    // columnSpan = "1/-1";
    rowWidth = "100%";
  }

  if(fieldData?.type === "sectionUiTemplate"){
    rowWidth = "100%";
  }
  const style = {
    // gridColumn:columnSpan,
    width: (deviceType === 'MOBILE' || isKioskMode?.mode) ? '100%' : (deviceType === 'TABLET' ? '50%' : rowWidth)
  }
  // if(fieldData.hasOwnProperty('isProfile')){
  //   rowSpan = "span 3";
  //   style.gridRow = rowSpan
  // }

  return style;
};

const dateFormat = (date, format = 'DD MMM YYYY') => {
  return moment(date).format(format);
};

const indexOfDates = (index, date, format = 'DD MMM YYYY') => {
  return moment(date)[index]('month').format(format);
};

const indexOfYear = (index, date, format = 'DD MMM YYYY') => {
  return moment(date)[index]('year').format(format);
};

const getCategoryWiseServices = (appData, serviceName = '') => {
  const tempServiceCategoryList = [];
  const tempCategoryWiseServices = {};

  if (!appData) return;

  Object.keys(appData).forEach((key) => {
    const svcType = appData[key];

    if (svcType.refCats && svcType.refCats.length > 0) {
      svcType.refCats.forEach((catObj) => {
        const isExists = tempServiceCategoryList.some((item) => item.refId === catObj.refId);
        if (!isExists) {
          tempServiceCategoryList.push(catObj);
        }

        if (tempCategoryWiseServices[catObj.title]) {
          if (
            !serviceName ||
            (serviceName && svcType.title && svcType.title.toLowerCase().includes(serviceName.toLowerCase()))
          ) {
            tempCategoryWiseServices[catObj.title].push(svcType);
          }
        } else {
          tempCategoryWiseServices[catObj.title] =
            !serviceName ||
            (serviceName && svcType.title && svcType.title.toLowerCase().includes(serviceName.toLowerCase()))
              ? [svcType]
              : [];
        }
      });
    }
  });

  return tempCategoryWiseServices;
};
const getCategoryWiseServicesWithJobsFun = (appData, serviceName = '', selectedTab) => {
  const tempServiceCategoryList = [];
  const tempCategoryWiseServices = {};

  if (!appData) return;

  Object.keys(appData).forEach((key) => {
    const svcType = appData[key];
    if (svcType.refCats && svcType.refCats.length > 0) {
      svcType.refCats.forEach((catObj) => {
        const isExists = tempServiceCategoryList.some((item) => item.refId === catObj.refId);
        if (!isExists) {
          tempServiceCategoryList.push(catObj);
        }
        // Check if refJobFuns array exists and contains an object with title "Masters"
        if (svcType.refJobFun && svcType.refJobFun.some(item => item.title === selectedTab)) {
          if (tempCategoryWiseServices[catObj.title]) {
            if (!serviceName || (serviceName && svcType.title && svcType.title.toLowerCase().includes(serviceName.toLowerCase()))) {
              tempCategoryWiseServices[catObj.title].push(svcType);
            }
          } else {
            tempCategoryWiseServices[catObj.title] = !serviceName || (serviceName && svcType.title && svcType.title.toLowerCase().includes(serviceName.toLowerCase())) ? [svcType] : [];
          }
        }
      });
    }
  });

  return tempCategoryWiseServices;
};

const DataWithLimitAndSortByTitle = (data, limit = 3) => {
  if (data !== null && data !== undefined) {
    const objectToArray = Object.values(data).sort((a, b) => {
      const titleA = a.title || '';
      const titleB = b.title || '';
      return titleA.localeCompare(titleB);
    });
    objectToArray.length = limit;
    return objectToArray;
  }
};
// hiding the field based on the field permission.
const hideFieldPermission = (refId, pId, serviceType, txnId, businessId) => {
  businessId = getLoginBusinessId() || businessId;
  const fields = getPerspectObjFields(pId, serviceType, txnId, businessId) || {};
  // checking * permission or not
  if (fields['*'] === '*') {
    return false;
  }
  return !!((fields[refId] === 'HIDE' || fields[refId] === 'PD_HIDE'));
};

const gettingPerspectiveObj = (serviceType, perspectiveId, businessId) => {
  businessId = getLoginBusinessId();
  const bizAccountObjPermissions = useBizAccountObjPermissions(businessId);
  let obj = {};
  if (bizAccountObjPermissions?.objPermissions[serviceType]) {
    obj =
      Object.values(bizAccountObjPermissions?.objPermissions[serviceType]).find((accessObj) => {
        if (accessObj.perspectiveId === perspectiveId) {
          return accessObj.view;
        }
      }) || {};
  }

  return obj.view;
};

const isCheckServiceTxnCreatePermission = (serviceType, perspectiveId, businessId) => {
  businessId = getLoginBusinessId();
  let permission = false;
  const viewObj = gettingPerspectiveObj(serviceType, perspectiveId, businessId);
  if (viewObj && viewObj.create) {
    if (viewObj.create.state === 'ACTIVE') {
      permission = true;
    }
  }
  return permission;
};

function htmlDecode(str) {
  if (str !== '' && str !== undefined && str !== null) {
    return str
      // .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
    // .replace(/&quot;/g, '"')
    // .replace(/&#039;/g, "'");
  }
}

const showMessageAlert = (msgContent) => {
  Message({
    className: accountsConstant.MESSAGE_POPUP.ERROR.CLASSNAME,
    type: accountsConstant.MESSAGE_POPUP.ERROR.TYPE,
    content: msgContent,
    duration: 3,
  });
};

const showMessageAlertWithCloseButton = (msgContent) => {
  const closeMessage = () => {
    // This will manually close the message
    message.destroy();
  };

  message.open({
    content: (
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span>{msgContent}</span>
        <CloseOutlined onClick={closeMessage} style={{ marginLeft: '10px', cursor: 'pointer' }} />
      </div>
    ),
    key: Date.now(),
    className: accountsConstant.MESSAGE_POPUP.ERROR.CLASSNAME,
    // type: accountsConstant.MESSAGE_POPUP.ERROR.TYPE,
    duration: 0, // This ensures the message won't auto-close
  });
};
// preparing the fields data for post json data
const validateManadtorySubform = (fieldsData, perspectiveId, serviceType, txnId, businessId) => {
  businessId = getLoginBusinessId();
  fieldsData.atLeastOneValue = false;
  fieldsData.isMandatory = false;
  for (const key in fieldsData?.fields) {
    const obj = fieldsData?.fields[key];
    if (!hideFieldPermission(obj?.refId, perspectiveId, serviceType, txnId, businessId)) {
      switch (obj.type) {
        case templates.UI_TEMPLATES.SINGLE_CHOICE_UI_TEMPLATE:
        case templates.UI_TEMPLATES.RADIO_BUTTON_UI_TEMPLATE:
          if (!obj.isSkippable) {
            if (obj.value === undefined || obj.value === '' || obj.value === null) {
              fieldsData.isMandatory = true;
            }
          }
          if (obj.value && obj.value !== '' && obj.value !== null) {
            fieldsData.atLeastOneValue = true;
          }
          break;

        case templates.UI_TEMPLATES.CHECKBOX_UI_TEMPLATE:
        case templates.UI_TEMPLATES.MULTI_SELECT_UI_TEMPLATE:
          if (!obj.isSkippable) {
            if (obj.value === '' ||
              obj.value === null ||
              obj.value === undefined ||
              (Array.isArray(obj.value) && obj.value.length === 0)
            ) {
              fieldsData.isMandatory = true;
            }
          }
          if (obj?.value && obj?.value !== '' && obj?.value !== null && obj?.value?.length > 0) {
            fieldsData.atLeastOneValue = true;
          }
          break;

        case templates.UI_TEMPLATES.BAR_CODE_UI_TEMPLATE:
        case templates.UI_TEMPLATES.QR_CODE_UI_TEMPLATE:
          if (!obj.isSkippable) {
            if ((obj.value === '' || obj.value === null)) {
              fieldsData.isMandatory = true;
            }
          } if (obj.value && obj.value !== '') {
            fieldsData.atLeastOneValue = true;
          }
          break;

        case templates.UI_TEMPLATES.DATE_PICKER_UI_TEMPLATE:
          if (!obj.isSkippable) {
            if (obj.value === '' || obj.value === null) {
              fieldsData.isMandatory = true;
            }
          } if (obj.value && obj.value !== '' && obj.value !== null) {
            fieldsData.atLeastOneValue = true;
          }
          break;

        case templates.UI_TEMPLATES.MOBILE_NUMBER_UI_TEMPLATE:
          if (!obj.isSkippable) {
            if (obj.value === '' || obj.value === null || obj?.value?.length === 0) {
              fieldsData.isMandatory = true;
            }
          } if (obj.value && obj.value !== '' && obj.value !== null) {
            fieldsData.atLeastOneValue = true;
          }
          break;

        case templates.UI_TEMPLATES.LOCATION_UI_TEMPLATE:
          if (!obj.isSkippable) {
            if (obj.value === '' || obj.value === null || obj.value === undefined || obj.coordinates?.length === 0) {
              fieldsData.isMandatory = true;
            }
          } if (obj.value && obj.value !== '' && obj.value !== null) {
            fieldsData.atLeastOneValue = true;
          }
          break;

        case templates.UI_TEMPLATES.SIGNATURE_UI_TEMPLATE:
          if (!obj.isSkippable) {
            if (!obj.value || obj.value === form?.EMPTY_IMAGE || typeof obj.value === 'undefined') {
              fieldsData.isMandatory = true;
            }
          }
          if (obj.value && obj.value !== '' && obj.value !== null) {
            fieldsData.atLeastOneValue = true;
          }
          break;

        case templates.UI_TEMPLATES.NUMBER_UI_TEMPLATE:
        case templates.UI_TEMPLATES.CURRENCY_UI_TEMPLATE:
          if (!obj.isSkippable) {
            if (Number.isNaN(obj.value) || obj.value === '' || obj.value === null || obj.value === undefined) {
              fieldsData.isMandatory = true;
            }
          }
          if (obj.value && obj.value !== '' && obj.value !== null) {
            fieldsData.atLeastOneValue = true;
          }
          break;

        case templates.UI_TEMPLATES.EDIT_TEXT_UI_TEMPLATE:
          if (!obj.isSkippable) {
            if (obj.value === '' || obj.value === null) {
              fieldsData.isMandatory = true;
            }
          }
          if (obj.value && obj.value !== '' && obj.value !== null) {
            fieldsData.atLeastOneValue = true;
          }
          break;

        case templates.UI_TEMPLATES.URL_UI_TEMPLATE:
          if (!obj.isSkippable) {
            if (obj.value === '' || obj.value === null) {
              fieldsData.isMandatory = true;
            }
          }
          if (obj.value && obj.value !== '' && obj.value !== null) {
            fieldsData.atLeastOneValue = true;
          }
          break;


        case templates.UI_TEMPLATES.TEXTAREA_UI_TEMPLATE:
        case templates.UI_TEMPLATES.RATING_UI_TEMPLATE:
        case templates.UI_TEMPLATES.LOOKUP_UI_TEMPLATE:
          if (!obj.isSkippable) {
            if (obj.value === '' || obj.value === null || obj.value === undefined) {
              fieldsData.isMandatory = true;
            }
          }
          if (obj.value && obj.value !== '' && obj.value !== null) {
            fieldsData.atLeastOneValue = true;
          }
          break;


        case templates.UI_TEMPLATES.IMAGE_UPLOAD_UI_TEMPLATE:
        case templates.UI_TEMPLATES.FILE_UPLOAD_UI_TEMPLATE:
          if (!obj.isSkippable) {
            if (obj.value === '' || obj.value === null) {
              fieldsData.isMandatory = true;
            }
          }
          if (obj.value && obj.value !== '' && obj.value !== null) {
            fieldsData.atLeastOneValue = true;
          }
          break;

        case templates.UI_TEMPLATES.EMAIL_TEXT_UI_TEMPLATE:
          if (!obj.isSkippable) {
            if (obj.value === '' || obj.value === null) {
              fieldsData.isMandatory = true;
            }
          }
          if (obj.value && obj.value !== '' && obj.value !== null) {
            fieldsData.atLeastOneValue = true;
          }
          break;
        default:
          if (
            obj.type !== templates.UI_TEMPLATES.SECTION_UI_TEMPLATE &&
            obj.type !== templates.UI_TEMPLATES.SPACER_UI_TEMPLATE &&
            obj.type !== templates.UI_TEMPLATES.LINE_UI_TEMPLATE &&
            obj.type !== templates.UI_TEMPLATES.BUTTON_UI_TEMPLATE
          ) {
            if (!obj.isSkippable) {
              if (obj.value === undefined || obj.value === '' || obj.value === null) {
                fieldsData.isMandatory = true;
              }
            }
            if (obj.value && obj.value !== '') {
              fieldsData.atLeastOneValue = true;
            }
          }
      }
    }
  }
  return fieldsData;
};

// preparing the fields data for post json data
const prepareFieldsData = (fields, perspectiveId, serviceType, txnId, businessId) => {
  for (const key in fields) {
    const obj = fields[key];
    if (obj.type === templates.UI_TEMPLATES?.CHECKBOX_UI_TEMPLATE) {
      const element = document.getElementById(key);
      if (
        !hideFieldPermission(obj?.refId, perspectiveId, serviceType, txnId, businessId) &&
        element &&
        window.getComputedStyle(element).display === 'block'
      ) {
        if (
          !obj.isSkippable &&
          (obj.value === '' ||
            obj.value === null ||
            obj.value === undefined ||
            (Array.isArray(obj.value) && obj.value.length === 0))
        ) {
          showMessageAlert(`${form.DYNAMIC_FORM.MANDATORY} : ${obj.label}`);
          return;
        }
        obj.value = obj.value === '' || obj.value === null ? [] : obj.value;
      }
    } else if (obj.type === templates.UI_TEMPLATES?.MULTI_SELECT_UI_TEMPLATE && obj.options) {
      const element = document.getElementById(key);
      if (
        !hideFieldPermission(obj?.refId, perspectiveId, serviceType, txnId, businessId) &&
        element &&
        window.getComputedStyle(element).display === 'block'
      ) {
        const optionLabel = [];
        for (const i in obj.value) {
          for (let j = 0; j < obj.options.length; j++) {
            if (obj.options[j] === obj.value[i]) optionLabel.push(obj.options[j]);
          }
        }
        obj.optionLabel = optionLabel;
        obj.value = obj.value === '' ? [] : obj.value;
        if (
          !obj.isSkippable &&
          (obj.value === '' ||
            obj.value === null ||
            obj.value === undefined ||
            (Array.isArray(obj.value) && obj.value.length === 0))
        ) {
          showMessageAlert(`${form.DYNAMIC_FORM.MANDATORY} : ${obj.label}`);
          return;
        }
      }
    }
    else if (
      obj.type === templates.UI_TEMPLATES?.SINGLE_CHOICE_UI_TEMPLATE
    ) {
      const element = document.getElementById(key);
      if (
        !hideFieldPermission(obj?.refId, perspectiveId, serviceType, txnId, businessId) &&
        element &&
        window.getComputedStyle(element).display === 'block'
      ) {
        if (!obj.isSkippable && !obj?.notShowFieldValues && (obj.value === '' || obj.value === null || obj.value === undefined)) {
          showMessageAlert(`${form.DYNAMIC_FORM.MANDATORY} : ${obj.label}`);
          return;
        }
        if (!obj.isSkippable && obj?.notShowFieldValues && obj?.enableAttachment && (obj?.attachmentList === undefined || obj?.attachmentList?.length === 0)) {
          showMessageAlert(`Please add atleast one attachment to : ${obj.label}`);
          return;
        }
        if (!obj.isSkippable && obj?.notShowFieldValues && obj?.enableComment && (obj?.commentsList === undefined || obj?.commentsList?.length === 0)) {
          showMessageAlert(`Please add atleast one comment to : ${obj.label}`);
          return;
        }
        if (obj?.options) {
          let optionLabel = '';
          for (let i = 0; i < obj.options.length; i++) {
            if (obj.options[i] === obj.value) optionLabel = obj.options[i];
          }
          obj.optionLabel = optionLabel;
        }
      }
    } else if (
      (obj.type === templates.UI_TEMPLATES?.RADIO_BUTTON_UI_TEMPLATE) &&
      obj.options
    ) {
      const element = document.getElementById(key);
      if (
        !hideFieldPermission(obj?.refId, perspectiveId, serviceType, txnId, businessId) &&
        element &&
        window.getComputedStyle(element).display === 'block'
      ) {
        if (!obj.isSkippable && (obj.value === '' || obj.value === null || obj.value === undefined)) {
          showMessageAlert(`${form.DYNAMIC_FORM.MANDATORY} : ${obj.label}`);
          return;
        }
        let optionLabel = '';
        for (let i = 0; i < obj.options.length; i++) {
          if (obj.options[i] === obj.value) optionLabel = obj.options[i];
        }
        obj.optionLabel = optionLabel;
      }
    } else if (obj.type === templates.UI_TEMPLATES?.DATE_PICKER_UI_TEMPLATE) {
      const element = document.getElementById(key);
      if (
        !hideFieldPermission(obj?.refId, perspectiveId, serviceType, txnId, businessId) &&
        element &&
        window.getComputedStyle(element).display === 'block'
      ) {
        if (!obj.isSkippable && (obj.value === '' || obj.value === null || obj.value === undefined)) {
          showMessageAlert(`${form.DYNAMIC_FORM.MANDATORY} : ${obj.label}`);
          return;
        }
        let dateString = '';
        if (obj?.dateFormat === "dd-MM-yyyy") {
          if (moment(obj?.value, 'YYYY-MM-DD', true).isValid()) {
            dateString = obj?.value;
          } else {
            // Step 1: Parse the date correctly using the 'DD-MM-YYYY' format
            const parsedDate = moment(obj.value, 'DD-MM-YYYY', true);  // Strict mode ensures exact format match
            // Step 2: If the date is valid, convert it to 'YYYY-MM-DD' format
            if (parsedDate.isValid()) {
              dateString = parsedDate.format('YYYY-MM-DD');
              console.log('Formatted Date:', dateString);
            } else {
              console.log('Invalid date format');
            }
          }
        } else {
          dateString = obj.value ? moment(obj.value).format('YYYY-MM-DD') : '';
        }
        obj.value = dateString;
      }
    } else if (obj.type === templates.UI_TEMPLATES?.MOBILE_NUMBER_UI_TEMPLATE) {
      const element = document.getElementById(key);
      if (
        !hideFieldPermission(obj?.refId, perspectiveId, serviceType, txnId, businessId) &&
        element &&
        window.getComputedStyle(element).display === 'block'
      ) {
        if (!obj.isSkippable && (obj.value === '' || obj.value === null || obj?.value?.length === 0 || obj.value === undefined)) {
          showMessageAlert(`${form.DYNAMIC_FORM.MANDATORY} : ${obj.label}`);
          return;
        }
        const numstr = obj.value ? obj.value.toString() : '';
        obj.value = numstr;
        if (obj.isValid === false) {
          showMessageAlert(`Please enter valid : ${obj.label}`);
          return false;
        }
      }
    } else if (obj.type === templates.UI_TEMPLATES?.LOCATION_UI_TEMPLATE) {
      const element = document.getElementById(key);
      if (
        !hideFieldPermission(obj?.refId, perspectiveId, serviceType, txnId, businessId) &&
        element &&
        window.getComputedStyle(element).display === 'block'
      ) {
        if (!obj.isSkippable) {
          if (!hideFieldPermission(obj?.refId, perspectiveId, serviceType, txnId, businessId, businessId)) {
            if (obj.value === '' || obj.value === null || obj.value === undefined || obj.coordinates?.length === 0) {
              showMessageAlert(`Please point a location on the map : ${obj.label}`);
              return false;
            }
          }
        }
      }
    } else if (obj.type === templates.UI_TEMPLATES?.SIGNATURE_UI_TEMPLATE) {
      if (!obj.isSkippable) {
        const element = document.getElementById(key);
        if (
          !hideFieldPermission(obj?.refId, perspectiveId, serviceType, txnId, businessId) &&
          element &&
          window.getComputedStyle(element).display === 'block'
        ) {
          if (!obj.value || obj.value === form?.EMPTY_IMAGE || typeof obj.value === 'undefined') {
            showMessageAlert(`Please provide an eSignature : ${obj.label}`);
            return false;
          }
        }
      }
    } else if (
      obj.type === templates.UI_TEMPLATES?.NUMBER_UI_TEMPLATE ||
      obj.type === templates.UI_TEMPLATES?.CURRENCY_UI_TEMPLATE
    ) {
      if (!obj.isSkippable) {
        const element = document.getElementById(key);
        if (
          !hideFieldPermission(obj?.refId, perspectiveId, serviceType, txnId, businessId) &&
          element &&
          window.getComputedStyle(element).display === 'block'
        ) {
          if (Number.isNaN(obj.value) || obj.value === '' || obj.value === null || obj.value === undefined) {
            showMessageAlert(`${form.DYNAMIC_FORM.MANDATORY} : ${obj.label}`);
            return false;
          }
          if (typeof obj.minDigits !== 'undefined' && obj.value && obj.value.toString().length < obj.minDigits) {
            showMessageAlert(`Value entered should be at least : ${obj.minDigits} digit(s). ${obj.label}`);
            return false;
          }
          // eslint-disable-next-line no-else-return
          if (typeof obj.maxDigits !== 'undefined' && obj.value && obj.value.toString().length > obj.maxDigits) {
            showMessageAlert(`Value entered should be ${obj.maxDigits} digit(s) : ${obj.label}`);
            return false;
          }
          if (typeof obj.value === 'undefined' || obj.value === null) {
            obj.value = 0;
          }
        }
      }
      if (obj?.dnaNegative && obj?.dnaNegative && obj?.value && obj?.value < 0) {
        showMessageAlert(`Negative values are not allowed in ${obj.label}`);
        return false;
      }

    } else if (obj.type === templates.UI_TEMPLATES?.EDIT_TEXT_UI_TEMPLATE) {
      if (!obj.isSkippable) {
        const element = document.getElementById(key);
        if (
          !hideFieldPermission(obj?.refId, perspectiveId, serviceType, txnId, businessId) &&
          element &&
          window.getComputedStyle(element).display === 'block'
        ) {
          if (!obj.isSkippable) {
            if (obj.value === '' || obj.value === null || obj.value === undefined) {
              showMessageAlert(`${form.DYNAMIC_FORM.MANDATORY} : ${obj.label}`);
              return false;
            }
            if (
              typeof obj.minChars !== 'undefined' &&
              typeof obj.value !== 'undefined' &&
              obj.value.length < obj.minChars
            ) {
              showMessageAlert(`Value entered should be at least ${obj.minChars} character(s) : ${obj.label}`);
              return false;
            }
            // eslint-disable-next-line no-else-return
            else if (
              typeof obj.maxChars !== 'undefined' &&
              typeof obj.value !== 'undefined' &&
              obj.value.length > obj.maxChars
            ) {
              showMessageAlert(`Value entered should be of ${obj.maxChars} character(s): ${obj.label}`);
              return false;
            }
          }
        }
      }

    } else if (obj.type === templates.UI_TEMPLATES?.URL_UI_TEMPLATE) {
      const element = document.getElementById(key);
      if (
        !hideFieldPermission(obj?.refId, perspectiveId, serviceType, txnId, businessId) &&
        element &&
        window.getComputedStyle(element).display === 'block'
      ) {
        if (!obj.isSkippable && (obj.value === '' || obj.value === null || obj.value === undefined)) {
          showMessageAlert(`${form.DYNAMIC_FORM.MANDATORY} : ${obj.label}`);
          return false;
        }
        if (obj.value) {
          // eslint-disable-next-line no-useless-escape
          const res = obj.value.match(/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/);
          if (res === null) {
            showMessageAlert(`Please enter valid : ${obj.label}`);
            return false;
          }
        }
      }
    } else if (obj.type === templates.UI_TEMPLATES?.TEXTAREA_UI_TEMPLATE) {
      const element = document.getElementById(key);
      if (
        !hideFieldPermission(obj?.refId, perspectiveId, serviceType, txnId, businessId) &&
        element &&
        window.getComputedStyle(element).display === 'block'
      ) {
        if(obj.dataViewMode === 'JSON'){
          try{
              if(obj.value !== "")JSON.parse(obj.value);
          } catch (error) {
              showMessageAlert(`Please enter valid JSON for : ${obj.label}`);
              return false;
          }
        }
        if (obj.dataViewMode === 'RICH_TEXT') {
          const richTextValue = htmlDecode(obj.value);
          if (!obj.isSkippable && (richTextValue === '' || richTextValue === null || richTextValue === undefined || richTextValue === '<p><br></p>')) {
            showMessageAlert(`${form.DYNAMIC_FORM.MANDATORY} : ${obj.label}`);
            return false;
          }
        }
        if (!obj.isSkippable && (obj.value === '' || obj.value === null || obj.value === undefined)) {
          showMessageAlert(`${form.DYNAMIC_FORM.MANDATORY} : ${obj.label}`);
          return false;
        }
      }
    } else if (
      obj.type === templates.UI_TEMPLATES?.RATING_UI_TEMPLATE ||
      obj.type === templates.UI_TEMPLATES.LOOKUP_UI_TEMPLATE
    ) {
      const element = document.getElementById(key);
      if (
        !hideFieldPermission(obj?.refId, perspectiveId, serviceType, txnId, businessId) &&
        element &&
        window.getComputedStyle(element).display === 'block'
      ) {
        if (!obj.isSkippable && (obj.value === '' || obj.value === null || obj.value === undefined)) {
          showMessageAlert(`${form.DYNAMIC_FORM.MANDATORY} : ${obj.label}`);
          return false;
        }
      }
    } else if (
      obj.type === templates.UI_TEMPLATES?.IMAGE_UPLOAD_UI_TEMPLATE ||
      obj.type === templates?.UI_TEMPLATES?.FILE_UPLOAD_UI_TEMPLATE
    ) {
      const element = document.getElementById(key);
      if (
        !hideFieldPermission(obj?.refId, perspectiveId, serviceType, txnId, businessId) &&
        element &&
        window.getComputedStyle(element).display === 'block'
      ) {
        if (!obj.isSkippable && (obj.value === '' || obj.value === null)) {
          showMessageAlert(`${form.DYNAMIC_FORM.MANDATORY} : ${obj.label}`);
          return false;
        }
        /* Uncomment the following code block if you want to validate the URL using regular expression
        if (obj.value) {
          const res = obj.value.match(/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+(?:png|jpg|jpeg|JPG|JPEG|PNG)+$/);
          if (res === null) {
            // Assuming you have a growlService function for showing error messages
           showWarningMessageAlert(`Please enter valid .jpg/.jpeg/.png for ${obj.label}`, CONSTATNS.SWAL_MSG_DANGER);
            return false;
          }
        }
        */
      }
    } else if (obj.type === templates.UI_TEMPLATES?.FORMULA_UI_TEMPLATE) {
      const element = document.getElementById(key);
      if (
        !hideFieldPermission(obj?.refId, perspectiveId, serviceType, txnId, businessId) &&
        element &&
        window.getComputedStyle(element).display === 'block'
      ) {
        if (obj.returnType === 'DATE') {
          const dateString = obj.value ? moment(obj.value).format('YYYY-MM-DD') : '';
          obj.value = dateString;
        }
      }
    } else if (obj.type === templates.UI_TEMPLATES?.EMAIL_TEXT_UI_TEMPLATE && !obj.allowCsv) {
      const element = document.getElementById(key);
      if (
        !hideFieldPermission(obj?.refId, perspectiveId, serviceType, txnId, businessId) &&
        element &&
        window.getComputedStyle(element).display === 'block'
      ) {
        if (!obj.isSkippable && (obj.value === '' || obj.value === null || obj.value === undefined)) {
          showMessageAlert(`${form.DYNAMIC_FORM.MANDATORY} : ${obj.label}`);
          return false;
        }
        if (obj?.value && obj?.value !== null && obj?.value !== '') {
          // Now you can use the match method
          const regExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          const matchResult = regExp.test(obj.value);
          if (!matchResult) {
            showMessageAlert(`Please enter valid email Id : ${obj.label}`);
            return false;
          }
        }
      }
    }
    else if (obj.type === templates.UI_TEMPLATES?.EMAIL_TEXT_UI_TEMPLATE && obj.allowCsv) {
      const element = document.getElementById(key);
      if (
        !hideFieldPermission(obj?.refId, perspectiveId, serviceType, txnId, businessId) &&
        element &&
        window.getComputedStyle(element).display === 'block'
      ) {
        if (!obj.isSkippable && (obj.value === '' || obj.value === null || obj.value === undefined)) {
          showMessageAlert(`${form.DYNAMIC_FORM.MANDATORY} : ${obj.label}`);
          return false;
        }
        if (obj?.value && obj?.value !== null && obj?.value !== '') {
          // Now you can use the match method
          const regExp = /^(\s?[^\s,]+@[^\s,]+\.[^\s,]+\s?,)*(\s?[^\s,]+@[^\s,]+\.[^\s,]+)$/;
          const matchResult = regExp.test(obj.value);
          if (!matchResult) {
            showMessageAlert(`Please enter valid email Id(s) : ${obj.label}`);
            return false;
          }
        }
      }
    } else if (
      obj.type === templates.UI_TEMPLATES?.BAR_CODE_UI_TEMPLATE ||
      obj.type === templates.UI_TEMPLATES?.QR_CODE_UI_TEMPLATE
    ) {
      if (!obj.isSkippable) {
        const element = document.getElementById(key);
        if (
          !hideFieldPermission(obj?.refId, perspectiveId, serviceType, txnId, businessId) &&
          element &&
          window.getComputedStyle(element).display === 'block'
        ) {
          if (!obj.isSkippable) {
            if (obj.value === '' || obj.value === null || obj.value === undefined) {
              showMessageAlert(`${form.DYNAMIC_FORM.MANDATORY} : ${obj.label}`);
              return false;
            }
            if (
              typeof obj.maxChars !== 'undefined' &&
              typeof obj.value !== 'undefined' &&
              obj.value.length > obj.maxChars
            ) {
              showMessageAlert(`Value entered should be of ${obj.maxChars} character(s) : ${obj.label}`);
              return false;
            }
          }
        }
      }

    } else if (obj.type === templates.UI_TEMPLATES?.ENCRYPT_UI_TEMPLATE && (txnId === '' || txnId === undefined || txnId === null)) {
      if (!obj.isSkippable) {
        const element = document.getElementById(key);
        if (
          !hideFieldPermission(obj?.refId, perspectiveId, serviceType, txnId, businessId) &&
          element &&
          window.getComputedStyle(element).display === 'block'
        ) {
          if (!obj.isSkippable) {
            if (obj.value === '' || obj.value === null || obj.value === undefined) {
              showMessageAlert(`${form.DYNAMIC_FORM.MANDATORY} : ${obj.label}`);
              return false;
            }
            if (
              typeof obj.minChars !== 'undefined' &&
              typeof obj.value !== 'undefined' &&
              obj.value.length < obj.minChars
            ) {
              showMessageAlert(`Value entered should be at least ${obj.minChars} character(s) : ${obj.label}`);
              return false;
            }
            // eslint-disable-next-line no-else-return
            else if (
              typeof obj.maxChars !== 'undefined' &&
              typeof obj.value !== 'undefined' &&
              obj.value.length > obj.maxChars
            ) {
              showMessageAlert(`Value entered should be of ${obj.maxChars} character(s): ${obj.label}`);
              return false;
            }
          }
        }
      }
    }
    else if ((obj.type === templates.UI_TEMPLATES?.TABLE_UI_TEMPLATE && txnId === '') || txnId === undefined) {
      const element = document.getElementById(key);
      if (
        !hideFieldPermission(obj?.refId, perspectiveId, serviceType, txnId, businessId) &&
        element &&
        window.getComputedStyle(element).display === 'block'
      ) {
        if (txnId !== '' && txnId !== undefined) {
          return;
        }
        if (!obj.isSkippable && (obj?.tableRows === undefined || obj?.tableRows?.length === 0)) {
          showMessageAlert(`${form.DYNAMIC_FORM.TABLE_ROW} : ${obj.label}`);
          return false;
        }

        // iterating the table field logic
        for (const i in obj?.tableRows) {
          for (const tableKey in obj?.tableRows[i]?.fields) {
            const fieldObj = obj?.tableRows[i]?.fields[tableKey];

            switch (fieldObj.type) {
              case templates.UI_TEMPLATES.SINGLE_CHOICE_UI_TEMPLATE:
                if (!fieldObj.isSkippable && (fieldObj.value === '' || fieldObj.value === null)) {
                  showMessageAlert(`${form.DYNAMIC_FORM.TABLE_MANDATORY} ${fieldObj.label} in ${obj.label}`);
                  return;
                }
                // eslint-disable-next-line no-case-declarations
                let tableOptionLabels = '';
                if (fieldObj?.options !== undefined && fieldObj?.options !== null) {
                  for (let i = 0; i < fieldObj.options.length; i++) {
                    if (fieldObj.options[i] === fieldObj.value) tableOptionLabels = fieldObj.options[i];
                  }
                }
                fieldObj.optionLabel = tableOptionLabels;
                break;

              case templates.UI_TEMPLATES.EMAIL_TEXT_UI_TEMPLATE:
                if (!fieldObj.isSkippable && (fieldObj.value === '' || fieldObj.value === null)) {
                  showMessageAlert(`${form.DYNAMIC_FORM.TABLE_MANDATORY} ${fieldObj.label} in ${obj.label}`);
                  return false;
                }
                if (fieldObj.value !== '' && fieldObj.value !== null && fieldObj.value !== undefined) {
                  const regExp = /^(\s?[^\s,]+@[^\s,]+\.[^\s,]+\s?,)*(\s?[^\s,]+@[^\s,]+\.[^\s,]+)$/;
                  const matchResult = regExp.test(fieldObj?.value);
                  if (!matchResult) {
                    showMessageAlert(`Please enter valid email Id(s) : ${fieldObj.label} in  ${obj.label}`);
                    return false;
                  }
                }
                break;

              case templates.UI_TEMPLATES.EDIT_TEXT_UI_TEMPLATE:
                if (!fieldObj.isSkippable) {
                  if (fieldObj.value === '' || !fieldObj.value) {
                    showMessageAlert(`${form.DYNAMIC_FORM.TABLE_MANDATORY} ${fieldObj.label} in ${obj.label}`);
                    return;
                  }
                  if (
                    typeof fieldObj?.minChars !== 'undefined' &&
                    typeof fieldObj?.value !== 'undefined' &&
                    fieldObj?.value?.length < fieldObj?.minChars
                  ) {
                    showMessageAlert(`Value entered should be at least ${fieldObj.minChars} character(s) : ${fieldObj.label} in ${obj.label}`);
                    return false;
                  }
                  // eslint-disable-next-line no-else-return
                  else if (
                    typeof fieldObj?.maxChars !== 'undefined' &&
                    typeof fieldObj?.value !== 'undefined' &&
                    fieldObj?.value?.length > fieldObj?.maxChars
                  ) {
                    showMessageAlert(`Value entered should be of ${fieldObj?.maxChars} character(s): ${fieldObj?.label} in ${obj.label}`);
                    return false;
                  }
                }
                break;
              case templates.UI_TEMPLATES.LOOKUP_UI_TEMPLATE:
              case templates.UI_TEMPLATES.URL_UI_TEMPLATE:
              case templates.UI_TEMPLATES.TEXTAREA_UI_TEMPLATE:
                if (!fieldObj.isSkippable && (fieldObj.value === '' || !fieldObj.value)) {
                  showMessageAlert(`${form.DYNAMIC_FORM.TABLE_MANDATORY} ${fieldObj.label} in ${obj.label}`);
                  return;
                }
                break;
              case templates.UI_TEMPLATES.DATE_PICKER_UI_TEMPLATE:
                if (!fieldObj.isSkippable && (fieldObj.value === '' || fieldObj.value === null)) {
                  showMessageAlert(`${form.DYNAMIC_FORM.TABLE_MANDATORY} ${fieldObj.label} in ${obj.label}`);
                  return;
                }
                let dateString = '';
                if (fieldObj?.dateFormat === "dd-MM-yyyy") {
                  if (moment(fieldObj?.value, 'YYYY-MM-DD', true).isValid()) {
                    dateString = fieldObj?.value;
                  } else {
                    // Step 1: Parse the date correctly using the 'DD-MM-YYYY' format
                    const parsedDate = moment(fieldObj.value, 'DD-MM-YYYY', true);  // Strict mode ensures exact format match
                    // Step 2: If the date is valid, convert it to 'YYYY-MM-DD' format
                    if (parsedDate.isValid()) {
                      dateString = parsedDate.format('YYYY-MM-DD');
                      console.log('Formatted Date:', dateString);
                    } else {
                      console.log('Invalid date format');
                    }
                  }
                } else {
                  dateString = fieldObj.value ? moment(fieldObj.value).format('YYYY-MM-DD') : '';
                }
                fieldObj.value = dateString;
                break;
              case templates.UI_TEMPLATES.MOBILE_NUMBER_UI_TEMPLATE:
                if (
                  !fieldObj.isSkippable &&
                  (fieldObj.value === '' || fieldObj.value === null || fieldObj?.value?.length === 0)
                ) {
                  showMessageAlert(`${form.DYNAMIC_FORM.TABLE_MANDATORY} ${fieldObj.label} in ${obj.label}`);
                  return;
                }
                // eslint-disable-next-line no-case-declarations
                const numstr = fieldObj.value ? fieldObj.value.toString() : '';
                fieldObj.value = numstr;
                if (fieldObj.isValid === false) {
                  showMessageAlert(
                    `${form.DYNAMIC_FORM.TABLE_MANDATORY} Please enter valid : ${fieldObj.label} in ${obj.label}`,
                  );
                  return false;
                }
                break;
              case templates.UI_TEMPLATES.NUMBER_UI_TEMPLATE:
              case templates.UI_TEMPLATES.CURRENCY_UI_TEMPLATE:
                if (!fieldObj.isSkippable) {
                  if (fieldObj.value === '' || fieldObj.value === null) {
                    showMessageAlert(`${form.DYNAMIC_FORM.TABLE_MANDATORY} ${fieldObj.label} in ${obj.label}`);
                    return false;
                  }
                  if (typeof fieldObj.minDigits !== 'undefined' && fieldObj.value && fieldObj.value.toString().length < fieldObj.minDigits) {
                    showMessageAlert(`Value entered should be at least : ${fieldObj.minDigits} digit(s). ${fieldObj.label} in ${obj.label}`);
                    return false;
                  }
                  // eslint-disable-next-line no-else-return
                  if (typeof fieldObj.maxDigits !== 'undefined' && fieldObj.value && fieldObj.value.toString().length > fieldObj.maxDigits) {
                    showMessageAlert(`Value entered should be ${fieldObj.maxDigits} digit(s) : ${fieldObj.label} in ${obj.label}`);
                    return false;
                  }
                  if (typeof fieldObj?.value === 'undefined' || fieldObj?.value === null || fieldObj?.value === '') {
                    fieldObj.value = 0;
                  }
                }
                if (fieldObj?.dnaNegative && fieldObj?.dnaNegative && fieldObj?.value && fieldObj?.value < 0) {
                  showMessageAlert(`Negative values are not allowed : ${fieldObj.label} in ${obj.label} `);
                  return false;
                }
                break;
              case templates.UI_TEMPLATES.IMAGE_UPLOAD_UI_TEMPLATE:
                if (!fieldObj.isSkippable && (fieldObj.value === '' || fieldObj.value === null)) {
                  showMessageAlert(`${form.DYNAMIC_FORM.TABLE_MANDATORY} ${fieldObj.label} in ${obj.label}`);
                  return false;
                }
                break;

              case templates.UI_TEMPLATES.CHECKBOX_UI_TEMPLATE:
                if (
                  !fieldObj.isSkippable &&
                  (fieldObj.value === '' ||
                    fieldObj.value === null ||
                    fieldObj?.value?.length === 0 ||
                    fieldObj.value === undefined)
                ) {
                  showMessageAlert(`${form.DYNAMIC_FORM.TABLE_MANDATORY} ${fieldObj.label} in ${obj.label}`);
                  return;
                }
                fieldObj.value = fieldObj.value === '' || fieldObj.value === null ? [] : fieldObj.value;
                break;

              case templates.UI_TEMPLATES.MULTI_SELECT_UI_TEMPLATE:

                if (fieldObj?.notShowFieldValues && (fieldObj?.enableAttachment || fieldObj?.enableComment)) {
                  const optionsKey = getTableFieldName(obj?.checklistFields?.options?.refId, obj?.tableRows[i]?.fields);
                  const labelKey = getTableFieldName(obj?.checklistFields?.label?.refId, obj?.tableRows[i]?.fields);
                  // comments realted functionality
                  if (obj?.checklistFields?.comments?.refId === fieldObj?.refId) {
                    const commentsKey = getTableFieldName(obj?.checklistFields?.comments?.refId, obj?.tableRows[i]?.fields);
                    const commentRequiredKey = getTableFieldName(obj?.checklistFields?.commentRequired?.refId, obj?.tableRows[i]?.fields);
                    const isCommentRequired = obj?.tableRows[i]?.fields[commentRequiredKey]?.value?.includes(obj?.tableRows[i]?.fields[optionsKey]?.value) || false;
                    if (isCommentRequired && obj?.tableRows[i]?.fields[commentsKey].value?.length === 0) {
                      showMessageAlert(`Please add atleast one comment to : ${obj?.tableRows[i]?.fields[labelKey]?.value}`);
                      return false;
                    }
                  }
                  // attachments realted functionality
                  if (obj?.checklistFields?.images?.refId === fieldObj?.refId) {
                    const imagesKey = getTableFieldName(obj?.checklistFields?.images?.refId, obj?.tableRows[i]?.fields);
                    const imageRequiredKey = getTableFieldName(obj?.checklistFields?.imageRequired?.refId, obj?.tableRows[i]?.fields);
                    const isImageRequiredKey = obj?.tableRows[i]?.fields[imageRequiredKey]?.value?.includes(obj?.tableRows[i]?.fields[optionsKey]?.value) || false;
                    if (isImageRequiredKey && obj?.tableRows[i]?.fields[imagesKey].value?.length === 0) {
                      showMessageAlert(`Please add atleast one attachment to : ${obj?.tableRows[i]?.fields[labelKey]?.value}`);
                      return false;
                    }
                  }
                }

                if (!fieldObj.isSkippable) {
                // eslint-disable-next-line no-case-declarations
                const tableOptionLabel = [];
                for (const i in fieldObj.value) {
                  for (let j = 0; j < fieldObj?.options?.length; j++) {
                    if (fieldObj.options[j] === fieldObj.value[i]) tableOptionLabel.push(fieldObj.options[j]);
                  }
                }
                fieldObj.optionLabel = tableOptionLabel;
                fieldObj.value = fieldObj.value === '' ? [] : fieldObj.value;
                if (
                  !fieldObj.isSkippable &&
                  (fieldObj.value === '' || fieldObj.value === null || fieldObj?.value?.length === 0)
                ) {
                  showMessageAlert(`${form.DYNAMIC_FORM.TABLE_MANDATORY} ${fieldObj.label} in ${obj.label}`);
                  return;
                }
                }
                break;
            }
            obj.tableRows[i].fields[tableKey] = fieldObj;
          }
        }
      }
    }
    else if ((obj.type === templates.UI_TEMPLATES?.SUB_FORM_UI_TEMPLATE && txnId === '') || txnId === undefined) {
      if (!obj.isSkippable) {
        const subFormFieldObj = validateManadtorySubform(obj, perspectiveId, serviceType, txnId, businessId);
        if (subFormFieldObj?.isMandatory) {
          showMessageAlert(`Plese fill all the mandatory fields for the : ${obj.label}`);
          return false;
        }
        else if (!subFormFieldObj?.atLeastOneValue) {
          showMessageAlert(`Plese fill atleast one field for the : ${obj.label}`);
          return false;
        }
      }
    }
    // Add more validations for other field types as required
    fields[key] = obj;
  }
  return fields;
};

const prepareSubformData = (subFormFields, perspectiveId, serviceType, txnId) => {
  const fields = subFormFields;
  const tempFieldsData = {};
  for (const key in fields) {
    // eslint-disable-next-line no-use-before-define
    if (!payLoadHideFieldPermission(fields[key]?.refId, perspectiveId, serviceType, txnId)) {
    const val = fields[key];
    if (val.type === templates.UI_TEMPLATES.LOCATION_UI_TEMPLATE) {
      tempFieldsData[key] = {
        coordinates: val?.coordinates ? val.coordinates : [],
        value: val?.value ? val.value : '',
      };
    } else if (val.type === templates.UI_TEMPLATES.LOOKUP_UI_TEMPLATE) {
      tempFieldsData[key] = {
        value: val?.selectedValue ? val.selectedValue : '',
      };
    } else if (val.type === templates.UI_TEMPLATES.DATE_PICKER_UI_TEMPLATE) {
      if (!val.value || val.value === '' || val.value === 'Invalid date') {
        val.value = null;
      }
      let dateString = null;
      if (val?.dateFormat === "dd-MM-yyyy") {
        if (moment(val?.value, 'YYYY-MM-DD', true).isValid()) {
          dateString = val?.value;
        } else {
          // Step 1: Parse the date correctly using the 'DD-MM-YYYY' format
          const parsedDate = moment(val.value, 'DD-MM-YYYY', true);  // Strict mode ensures exact format match
          // Step 2: If the date is valid, convert it to 'YYYY-MM-DD' format
          if (parsedDate.isValid()) {
            dateString = parsedDate.format('YYYY-MM-DD');
            console.log('Formatted Date:', dateString);
          } else {
            console.log('Invalid date format');
          }
        }
      } else {
        dateString = val.value ? moment(val.value).format('YYYY-MM-DD') : null;
      }
      tempFieldsData[key] = {
        value: dateString,
      };
    } else if (val.type === templates.UI_TEMPLATES.NUMBER_UI_TEMPLATE) {
      if (!val.value || val.value === 0) {
        val.value = 0;
      }
      tempFieldsData[key] = {
        value: parseFloat(val.value),
      };
    } else if (val.type === templates.UI_TEMPLATES.CURRENCY_UI_TEMPLATE) {
      if (!val.value || (Array.isArray(val.value) && val.value.length === 0)) {
        val.value = 0;
      }
      tempFieldsData[key] = {
        value: parseFloat(val.value),
      };
    } else if (
      val.type === templates.UI_TEMPLATES.CHECKBOX_UI_TEMPLATE ||
      val.type === templates.UI_TEMPLATES.MULTI_SELECT_UI_TEMPLATE ||
      val.type === templates.UI_TEMPLATES.RATING_UI_TEMPLATE ||
      val.type === templates.UI_TEMPLATES.SIGNATURE_UI_TEMPLATE
    ) {
      if (!val.value || (Array.isArray(val.value) && val.value.length === 0)) {
        val.value = null;
      }
      tempFieldsData[key] = {
        value: val.value,
      };
    } else if (val.type === templates.UI_TEMPLATES.MOBILE_NUMBER_UI_TEMPLATE) {
      tempFieldsData[key] = {
        value: val?.normalNum ? val.normalNum : '',
        code: val?.code ? val.code : '',
      };
    } else if (val.type === templates.UI_TEMPLATES.URL_UI_TEMPLATE) {
      tempFieldsData[key] = {
        value: val?.value ? val.value : '',
        title: val?.title ? val.title : '',
      };
    } else if (
      val.type !== templates.UI_TEMPLATES.SECTION_UI_TEMPLATE &&
      val.type !== templates.UI_TEMPLATES.SPACER_UI_TEMPLATE &&
      val.type !== templates.UI_TEMPLATES.LINE_UI_TEMPLATE &&
      val.type !== templates.UI_TEMPLATES.WIDGET_UI_TEMPLATE &&
      val.type !== templates.UI_TEMPLATES.GRAPH_UI_TEMPLATE &&
      val.type !== templates.UI_TEMPLATES.BUTTON_UI_TEMPLATE
    ) {
      tempFieldsData[key] = {
        value: val?.value ? val.value : '',
      };
    }
  }
  }
  return tempFieldsData;
};

const showSuccesMessageAlert = (msgContent) => {
  Message({
    className: accountsConstant.MESSAGE_POPUP.SUCCESS.CLASSNAME,
    type: accountsConstant.MESSAGE_POPUP.SUCCESS.TYPE,
    content: msgContent,
    duration: 3,
  });
};

// Remove duplicate perspectives based on the perspective id.
const getBizAccountObjPermissionsList = (obj) => {
  const newObj = {};
  Object.keys(obj).forEach((key) => {
    let exists = false;
    Object.keys(newObj).forEach((key2) => {
      if (obj[key].perspectiveId === newObj[key2].perspectiveId) {
        exists = true;
      }
    });
    if (exists === false && obj[key].perspectiveId !== '') {
      newObj[key] = obj[key];
    }
  });
  return newObj;
};

// getting default values
const getDefaultValue = (fields) => {
  if (fields) {
    Object.keys(fields).forEach((key) => {
      const val = fields[key];
      if (val && val.type === templates.UI_TEMPLATES.MULTI_SELECT_UI_TEMPLATE) {
        if (val.isDynamicOptions && (!val.options || val.options.length === 0)) {
          val.options = [];
        }
      }
      if (val) {
        switch (val.type) {
          case templates.UI_TEMPLATES.CHECKBOX_UI_TEMPLATE:
          case templates.UI_TEMPLATES.MULTI_SELECT_UI_TEMPLATE:
            if(!val.value){
              if (val.isDynamicOptions && (!val.options || val.options.length === 0)) {
                val.options = [];
              }
              val.value = val.options[val.defaultValue] ? [val.options[val.defaultValue]] : [];
            }
            break;

          case templates.UI_TEMPLATES.RADIO_BUTTON_UI_TEMPLATE:
          case templates.UI_TEMPLATES.SINGLE_CHOICE_UI_TEMPLATE:
            if(!val.value){
              if (val.isDynamicOptions && (!val.options || val.options.length === 0)) {
                val.options = [];
              }
              val.value = val.options && val.options[val.defaultValue] ? val.options[val.defaultValue] : null;
            }
            break;

          case templates.UI_TEMPLATES.NUMBER_UI_TEMPLATE:
            if(!val.value){
            val.value = val.defaultValue ? val.defaultValue : 0;
            }
            break;

          case templates.UI_TEMPLATES.CURRENCY_UI_TEMPLATE:
            if(!val.value){
            val.value = val.defaultValue && val.defaultValue !== '' && val.defaultValue !== 0 ? val.defaultValue : 0;
          }
            break;

          case templates.UI_TEMPLATES.FORMULA_UI_TEMPLATE:
            if(!val.value){
            if (val.returnType === 'NUMBER') {
              val.value = 0;
            }
          }
            break;
        }
      }
    });
  }
};

// txn edit form

const prepareFieldsConfigValObj = (fields) => {
  const fieldsData = {};

  Object.keys(fields).forEach((key) => {
    const val = fields[key];
    if (val.type === templates.UI_TEMPLATES.LOCATION_UI_TEMPLATE) {
      fieldsData[key] = {
        coordinates: val.coordinates,
        value: val.value || '',
      };
    } else if (val.type === templates.UI_TEMPLATES.MOBILE_NUMBER_UI_TEMPLATE) {
      fieldsData[key] = {
        value: val.value || '',
        code: val.code,
      };
    } else if (val.type === templates.UI_TEMPLATES.URL_UI_TEMPLATE) {
      fieldsData[key] = {
        value: val.value,
        title: val.title,
      };
    } else if (val.type === templates.UI_TEMPLATES.LOOKUP_UI_TEMPLATE) {
      fieldsData[key] = {
        value: val.value || '',
      };
    } else if (val.type === templates.UI_TEMPLATES.DATE_PICKER_UI_TEMPLATE) {
      fieldsData[key] = {
        value: val.value || null,
      };
    } else if (
      val.type === templates.UI_TEMPLATES.NUMBER_UI_TEMPLATE ||
      val.type === templates.UI_TEMPLATES.CURRENCY_UI_TEMPLATE
    ) {
      fieldsData[key] = {
        value: val.value || 0,
      };
    } else if (
      val.type === templates.UI_TEMPLATES.CHECKBOX_UI_TEMPLATE ||
      val.type === templates.UI_TEMPLATES.MULTI_SELECT_UI_TEMPLATE ||
      val.type === templates.UI_TEMPLATES.RATING_UI_TEMPLATE ||
      val.type === templates.UI_TEMPLATES.SIGNATURE_UI_TEMPLATE
    ) {
      fieldsData[key] = {
        value: val.value || null,
      };
    } else if (
      val.type === templates.UI_TEMPLATES.TABLE_UI_TEMPLATE ||
      val.type === templates.UI_TEMPLATES.SUB_FORM_UI_TEMPLATE
    ) {
      // Handle TABLE_UI_TEMPLATE and SUB_FORM_UI_TEMPLATE
    } else if (
      ![
        templates.UI_TEMPLATES.SECTION_UI_TEMPLATE,
        templates.UI_TEMPLATES.SPACER_UI_TEMPLATE,
        templates.UI_TEMPLATES.LINE_UI_TEMPLATE,
        templates.UI_TEMPLATES.WIDGET_UI_TEMPLATE,
        templates.UI_TEMPLATES.GRAPH_UI_TEMPLATE,
        templates.UI_TEMPLATES.BUTTON_UI_TEMPLATE,
      ].includes(val.type)
    ) {
      fieldsData[key] = {
        value: val.value || '',
      };
    }
  });
  // eslint-disable-next-line dot-notation
  delete fieldsData['__refOptions__'];

  return fieldsData;
};

const formatCurrency = (value, precision) => {
  return parseFloat(value).toFixed(precision);
};

const getLookupDisplayFieldsValueArray = (existedFieldsById, displayfields, lookuptypeService, businessId) => {
  businessId = getLoginBusinessId();
  const selectedValues = [];
  const currencySymbol = getSession(`${businessId}_biz_currency_symbol`);
  logger.debug('LOOKUP VALUE {} ', existedFieldsById?.fields);

  displayfields?.forEach((fieldKey) => {
    if (fieldKey?.includes('fields.')) {
      const resObj =
        existedFieldsById !== undefined &&
        existedFieldsById?.fields !== undefined &&
        existedFieldsById?.fields[fieldKey?.replace('fields.', '')];

      if (
        resObj &&
        resObj.type === templates.UI_TEMPLATES.MOBILE_NUMBER_UI_TEMPLATE &&
        resObj.value &&
        resObj.value !== ''
      ) {
        selectedValues.push(`+${resObj.code}${resObj.value}`);
      } else if (
        resObj &&
        resObj.type === templates.UI_TEMPLATES.DATE_PICKER_UI_TEMPLATE &&
        resObj.value &&
        resObj.value !== ''
      ) {
        selectedValues.push(moment(resObj.value).format('MMM DD, YYYY')); // You need to import moment.js
      } else if (
        resObj &&
        resObj.type === templates.UI_TEMPLATES.CURRENCY_UI_TEMPLATE &&
        resObj.value &&
        resObj.value !== ''
      ) {
        const fieldName = fieldKey.replace('fields.', '');
        const precision =
          lookuptypeService && lookuptypeService?.fields && lookuptypeService?.fields[fieldName]
            ? lookuptypeService?.fields[fieldName]?.decimalPositions
            : undefined;

        if (Number(resObj.value)) {
          selectedValues.push(`₹ ${formatCurrency(resObj.value, precision || 2)}`);
        } else if (currencySymbol === '₹') {
          if (!resObj.value?.includes(currencySymbol)) {
            selectedValues.push(`₹ ${formatCurrency(resObj.value, precision || 2)}`);
          } else {
            selectedValues.push(resObj.value);
          }
        } else if (!resObj.value?.includes(currencySymbol)) {
          selectedValues.push(`${currencySymbol} ${formatCurrency(resObj.value, precision || 2)}`);
        } else {
          selectedValues.push(resObj.value);
        }
      } else if (resObj && resObj.type === templates.UI_TEMPLATES.IMAGE_UPLOAD_UI_TEMPLATE) {
        // Handle image upload template
      } else {
        const value = resObj ? resObj.value : '';
        if (value && value !== '') selectedValues.push(value);
      }
    } else {
      selectedValues.push(existedFieldsById[fieldKey]);
    }
  });

  return selectedValues;
};

const setLookupValue = (currentFieldObj, lookup, businessId) => {
  businessId = getLoginBusinessId();
  if (lookup && currentFieldObj?.value) {
    if (typeof currentFieldObj?.value === 'object' && currentFieldObj?.value.id) {
      currentFieldObj.value = currentFieldObj?.value.id;
    }
    const existedFieldsById = lookup[currentFieldObj?.value] || {};
    let imgUrl = null;
    if (
      Object.keys(existedFieldsById)?.length > 0 &&
      existedFieldsById?.fields !== undefined &&
      existedFieldsById?.fields !== null &&
      Object.keys(existedFieldsById?.fields)?.length > 0
    ) {
      Object.keys(existedFieldsById?.fields)?.forEach((exitKey) => {
        const exitObj = existedFieldsById.fields[exitKey];
        if (exitObj.type === 'imageUploadUiTemplate') {
          imgUrl = exitObj.value;
        }
      });
    }
    let selectedValues = [];
    const lookuptypeService = getServiceData(currentFieldObj.lookupType, businessId); // You need to implement this function
    if (existedFieldsById) {
      selectedValues = getLookupDisplayFieldsValueArray(
        existedFieldsById,
        currentFieldObj?.displayFields,
        lookuptypeService,
        businessId,
      ); // You need to implement this function
    }

    if (currentFieldObj && selectedValues?.length > 0) {
      currentFieldObj.selectedValue = currentFieldObj?.value;
      currentFieldObj.imgUrl = imgUrl;
      currentFieldObj.value = {
        id: currentFieldObj?.value,
        imgUrl,
        value: selectedValues.join(' '),
        valueArr: selectedValues,
      };
    }
  }
};

const getFileExtension = (url) => {
  if (typeof url === 'string') {
    const arr = url.split('?')[0].split('/');
    const ty = arr[arr.length - 1].split('.')[1];
    return ty;
  }
};

const isCheckServiceTxnReadonlyPermission = (serviceType, perspectiveId, businessId) => {
  businessId = getLoginBusinessId();
  let permission = false;
  const viewObj = gettingPerspectiveObj(serviceType, perspectiveId, businessId);
  if (viewObj && viewObj.details) {
    if (viewObj.details.state === 'ACTIVE' && viewObj.details.type === 'READONLY') {
      permission = true;
    }
  }
  return permission;
};

// getting color value based on code
const getColorValueByCode = (code, notCheckNone) => {
  const skinList = [
    { code: '#9C27B0', value: 'purple' },
    { code: '#3F51B5', value: 'indigo' },
    { code: '#2196F3', value: 'blue' },
    { code: '#4CAF50', value: 'green' },
    { code: '#FFEB3B', value: 'yellow' },
    { code: '#FF9800', value: 'orange' },
    { code: '#F44336', value: 'red' },
    { code: '#FFFFFF', value: 'None' },
  ];
  const obj = _.find(skinList, { code });
  if (obj) {
    if (obj.value === 'None' && !notCheckNone) {
      return 'gray';
    }
    return obj.value;
  }
};

// get color code value for status fields
const getColorCodeValue = (options, value, colorCodes) => {
  if (options && value && colorCodes) {
    const optionIdx = options.indexOf(value);
    if (optionIdx !== -1 && colorCodes) {
      return getColorValueByCode(colorCodes[optionIdx]);
    }
  }
};

const openUrlWindow = (urlValue) => {
  if (urlValue && urlValue !== '') {
    if (urlValue.includes('https://s3-ap-southeast-1.amazonaws.com/') && urlValue.includes('fname=')) {
      const url = `${getEnvironmentHost()}/media?key=${urlValue}`;
      const bizAccessToken = getLoginAccessToken();
      axios
        .get(url, {
          cache: true,
          headers: {
            Authorization: `Bearer ${bizAccessToken}`, // Add the Authorization header
          },
        })
        .then((response) => {
          window.open(response.data.url);
        });
    } else {
      window.open(urlValue);
    }
  }
};

const getFileImage = (url) => {
  if (typeof url === 'string') {
    const arr = url.split('?')[0].split('/');
    const ty = arr[arr.length - 1].split('.')[1];

    switch (ty) {
      case 'pdf' || 'PDF':
        return '../../static/img/icons/hoo_pdf.png';

      case 'docx' || 'DOCX' || 'doc' || 'DOC' || 'txt' || 'TXT':
        return '../../static/img/icons/hoo_doc.png';

      case 'csv' || 'CSV':
        return '../../static/img/icons/hoo_csv.jpeg';

      case 'xlsx' || 'XLSX' || 'xls' || 'XLS':
        return '../../static/img/icons/hoo_xls.png';

      default:
        return '';
    }
  }
};

// =========================== SCRIPT LOGIC RELATED FUNCTIONALITY =================
// ============================================== MAIN FORM SCRIPT LOGIC ================================

// parse function.
function parseFunction(str) {
  if (str) {
    const fn_body_idx = str.indexOf('{'),
      fn_body = str.substring(fn_body_idx + 1, str.lastIndexOf('}')),
      fn_declare = str.substring(0, fn_body_idx),
      fn_params = fn_declare.substring(fn_declare.indexOf('(') + 1, fn_declare.lastIndexOf(')'));
    return new Function(fn_params, fn_body);
  }
}

const formlaFieldOnChangeCall = async (fieldConfiguration, refId, type, serviceData, data, scriptLogicWrapper) => {
  if(fieldConfiguration){
    Object.values(fieldConfiguration)?.forEach((fieldObj) => {
      if (fieldObj?.refId === refId) {
        fieldObj?.formulaFuncs?.forEach((func) => {
          if (typeof window[func] === 'function') {
            window[func](fieldConfiguration); // Assuming fieldConfigurations is defined in your component
          }
        });
      }
    });
  }

  if (serviceData?.scripts) {
    switch (type) {
      case templates.UI_TEMPLATES.EDIT_TEXT_UI_TEMPLATE:
      case templates.UI_TEMPLATES.MOBILE_NUMBER_UI_TEMPLATE:
      case templates.UI_TEMPLATES.NUMBER_UI_TEMPLATE:
      case templates.UI_TEMPLATES.EMAIL_TEXT_UI_TEMPLATE:
      case templates.UI_TEMPLATES.RADIO_BUTTON_UI_TEMPLATE:
      case templates.UI_TEMPLATES.SINGLE_CHOICE_UI_TEMPLATE:
      case templates.UI_TEMPLATES.MULTI_SELECT_UI_TEMPLATE:
      case templates.UI_TEMPLATES.CURRENCY_UI_TEMPLATE:
      case templates.UI_TEMPLATES.LOOKUP_UI_TEMPLATE:
      case templates.UI_TEMPLATES.DATE_PICKER_UI_TEMPLATE:
      case templates.UI_TEMPLATES.LOCATION_UI_TEMPLATE:
      case templates.UI_TEMPLATES.CHECKBOX_UI_TEMPLATE:
      case templates.UI_TEMPLATES.SECTION_UI_TEMPLATE:
      case templates.UI_TEMPLATES.BUTTON_UI_TEMPLATE:
        serviceData.scripts.forEach(async (script) => {
          try {
            if (script.fid === refId) {
              // eslint-disable-next-line camelcase
              const f_name = `${script.fid}_${script.action}`;
              logger.debug(f_name);
              logger.debug(fieldConfiguration);
              // eslint-disable-next-line camelcase
              if (window[f_name]) {
                if (data) {
                  const searchString = 'data';
                  if (script?.args?.includes(searchString)) {
                    // eslint-disable-next-line camelcase
                    await window[f_name](fieldConfiguration, data, scriptLogicWrapper);
                  } else {
                    // eslint-disable-next-line camelcase
                    await window[f_name](fieldConfiguration, scriptLogicWrapper);
                  }
                } else {
                  // eslint-disable-next-line camelcase
                  await window[f_name](fieldConfiguration, scriptLogicWrapper);
                }
              }
            }
          } catch (error) {
            logger.error('Error executing actionScript:', error);
          }
        });
        break;
      // return fieldConfiguration;
    }
  }
};
const formulaActionScriptExecute = (formFields, serviceData, scriptLogicWrapper, callBackFun) => {
  logger.info('Entered in formulaActionScriptExecute');

  if (
    serviceData?.formulaScript &&
    typeof serviceData?.formulaScript === 'object' &&
    Object.keys(serviceData?.formulaScript)?.length > 0
  ) {
    Object.entries(serviceData?.formulaScript).forEach(([func, fun_name]) => {
      logger.debug(func);
      window[func] = parseFunction(fun_name);
      logger.debug("WINDOW FUNC ===== ", window[fun_name]);
      logger.debug("WINDOW FUNC 11 ===== ", window);

    });

    if (!Array.isArray(formFields)) {
      logger.error('formFields is not an array');
      if (callBackFun) callBackFun();
      return;
    }

    formFields?.forEach((fieldObj) => {
      if (fieldObj && fieldObj.formulaFuncs && fieldObj.value !== null && fieldObj.value !== '') {
        formlaFieldOnChangeCall(fieldObj, fieldObj?.refId, fieldObj?.type, serviceData, scriptLogicWrapper);
      }

      if (fieldObj && fieldObj.formulaFuncs && fieldObj.type === templates.UI_TEMPLATES.FORMULA_UI_TEMPLATE) {
        const [oldValue, setOldValue] = useState(fieldObj.value);
        useEffect(() => {
          if (fieldObj.value !== oldValue) {
            formlaFieldOnChangeCall(fieldObj.formulaFuncs, fieldObj.refId, fieldObj.type);
            setOldValue(fieldObj.value);
          }
        }, [fieldObj.value, oldValue, formlaFieldOnChangeCall]);
      }
    });

    if (callBackFun) callBackFun();
  } else if (callBackFun) callBackFun();
};

const actionScriptExecute = (fields, data, perspectiveId, txnId) => {
  logger.info('Entered in GetSeerviceData');
  const businessId = getLoginBusinessId();
  const hideFieldsArray = [];
  if (data && data?.actionScript) {
    try {
      // eslint-disable-next-line no-eval
      window.eval(data?.actionScript);
      // eslint-disable-next-line no-eval
      if (typeof window.onLoadFunc === 'function' && typeof window.onChangeFunc === 'function') {
        const { onLoadFunc } = window;
        const { onChangeFunc } = window;
        logger.debug('onLoadFunc', onLoadFunc);
        logger.debug('onChangeFunc', onChangeFunc);
        if (typeof fields === 'object' && fields !== null) {
          Object.keys(fields)?.forEach((key) => {
            onLoadFunc(key);
          });
          Object.keys(fields)?.forEach((key) => {
            const obj = fields[key];
            if (
              obj &&
              obj.value !== null &&
              obj.value !== '' &&
              !hideFieldPermission(obj.refId, perspectiveId, data.type, txnId, businessId)
            ) {
              const element = document.getElementById(key);
              if (element && window.getComputedStyle(element).display === 'none') {
                logger.info(`FIELD KEY 1111 ${key}`, window.getComputedStyle(element).display === 'none');
                logger.info(element?.style.display);
                hideFieldsArray.push(key);
              }
              onChangeFunc(key, obj.value);
            }
          });
          setHideFieldsArray(hideFieldsArray);
        }
      }
    } catch (error) {
      logger.error('Error executing actionScript:', error);
    }
  }
};

// subform field logic execution based on the fields.
const subFormFieldLogicScriptExecute = (fields, data, perspectiveId, txnId) => {
  logger.info('Entered in GetSeerviceData');
  const businessId = getLoginBusinessId();
  if (data && data?.sfActionScripts) {
    try {
      // eslint-disable-next-line no-eval
      window.eval(data?.sfActionScripts);
      // eslint-disable-next-line no-eval
      if (typeof window.onLoadFunc === 'function' && typeof window.onChangeFunc === 'function') {
        const { onLoadFunc } = window;
        const { onChangeFunc } = window;
        logger.debug('onLoadFunc', onLoadFunc);
        logger.debug('onChangeFunc', onChangeFunc);
        if (typeof fields === 'object' && fields !== null) {
          Object.keys(fields)?.forEach((key) => {
            onLoadFunc(key);
          });
          Object.keys(fields)?.forEach((key) => {
            const obj = fields[key];
            if (
              obj &&
              obj.value !== null &&
              obj.value !== '' &&
              !hideFieldPermission(obj.refId, perspectiveId, data.type, txnId, businessId)
            ) {
              onChangeFunc(key, obj.value);
            }
          });
        }
      }
    } catch (error) {
      logger.error('Error executing actionScript:', error);
    }
  }
};

// eslint-disable-next-line no-empty-function
const AsyncFunction = Object.getPrototypeOf(async function () {}).constructor;

const fieldActionScriptExecute = (formFields, serviceData, scriptLogicWrapper) => {
  logger.info('Entered in actionScriptExecute');
  try {
    if (serviceData?.scripts) {
      serviceData?.scripts.forEach((script) => {
        // eslint-disable-next-line camelcase
        let f_name = '';
        if (script.action === 'ON_FORM_LOAD' || script.action === 'ON_FORM_SUBMIT') {
          // eslint-disable-next-line camelcase
          f_name = `f_script_${script.action}`;
        } else {
          // eslint-disable-next-line camelcase
          f_name = `${script.fid}_${script.action}`;
        }
        // eslint-disable-next-line camelcase
        if (script.columnFieldId) f_name = `${f_name}_${script.columnFieldId}`;
        const params = `${script.args.toString()}, app_lib`;
        if (script.action === 'ON_FORM_SUBMIT') {
          window[f_name] = new AsyncFunction(params, script.body);
        } else {
          // eslint-disable-next-line no-new-func, camelcase
          window[f_name] = new Function(params, script.body);
        }
        // eslint-disable-next-line camelcase
        logger.debug(window[f_name]);

        if (script.action === 'ON_FORM_LOAD') {
          // eslint-disable-next-line camelcase
          window[f_name](formFields, scriptLogicWrapper);
        }
      });
    }
  } catch (error) {
    logger.error('Error executing fieldActionScriptExecute:', error);
  }
};
// ==================================================== APP LIB FUNCTION =================================

// adding app lib for the getComment and attachments count.
const getCommentAndAttachmentsCount = (fieldName, fieldConfigurations, transactionData, action) => {
  let refId = null;
  let count = 0;
  switch (action) {
    case 'GET_COMMENT_COUNT':
      refId = fieldConfigurations[fieldName] ? fieldConfigurations[fieldName].refId : null;
      count = 0;

      if (transactionData?.id) {
        if (transactionData?.fieldsMeta) {
          const resultArray = transactionData?.fieldsMeta?.filter(
            (item) => item?.type === `${fieldConfigurations[fieldName]?.refId}/COMMENT_STORE`,
          );
          count = resultArray.length;
        }
      }
      if (refId && fieldConfigurations[fieldName]?.commentsList !== undefined) {
        // eslint-disable-next-line no-unsafe-optional-chaining
        if (fieldConfigurations[fieldName]?.commentsList[refId]) {
          count = fieldConfigurations[fieldName]?.commentsList[refId]?.length;
        }
      }
      return count;

    case 'GET_ATTACHMENT_COUNT':
      refId = fieldConfigurations[fieldName] ? fieldConfigurations[fieldName].refId : null;
      count = 0;

      if (transactionData?.id) {
        if (transactionData?.fieldsMeta) {
          const resultArray = transactionData?.fieldsMeta?.filter(
            (item) => item?.type === `${fieldConfigurations[fieldName]?.refId}/ASSET`,
          );
          count = resultArray.length;
        }
      }
      if (refId && fieldConfigurations[fieldName]?.attachmentList !== undefined) {
        // eslint-disable-next-line no-unsafe-optional-chaining
        if (fieldConfigurations[fieldName]?.attachmentList[refId]) {
          count = fieldConfigurations[fieldName]?.attachmentList[refId]?.length;
        }
      }
      return count;
  }
};

// applib function for look up data.
const getSelectedLookupArr = async (value, lookupType, destinationObj) => {
  try {
    const response = await getLookupData(value, lookupType);
    const res = response?.data;
    if (res.statusCode === 0) {
      if (res?.data) {
        const selectedValues = [];
        let imgUrl = null;
        destinationObj.displayFields.forEach((fieldKey) => {
          if (fieldKey.includes('fields.')) {
            const resObj = res.data.fields[fieldKey.replace('fields.', '')];
            if (resObj) {
              if (
                resObj.type === templates.UI_TEMPLATES.MOBILE_NUMBER_UI_TEMPLATE &&
                resObj.value &&
                resObj.value !== ''
              ) {
                selectedValues.push(`+${resObj.code} ${resObj.value}`);
              } else if (
                resObj.type === templates.UI_TEMPLATES.DATE_PICKER_UI_TEMPLATE &&
                resObj.value &&
                resObj.value !== ''
              ) {
                selectedValues.push(moment(resObj.value).format('YYYY-MM-DD'));
              } else if (resObj.type === templates.UI_TEMPLATES.IMAGE_UPLOAD_UI_TEMPLATE) {
                if (resObj.value && resObj.value !== '') imgUrl = resObj.value;
              } else {
                const value = resObj.value || '';
                if (value && value !== '') selectedValues.push(value);
              }
            } else {
              selectedValues.push(res.data[fieldKey]);
            }
          } else {
            selectedValues.push(res.data[fieldKey]);
          }
        });

        const previousSelectedLookupData = getSelectedLookupFormData();
        const lookupDataObj = {};
        lookupDataObj.id = value;
        lookupDataObj.value = res.data;
        lookupDataObj.isFromLookupScriptLogic = true;
        // eslint-disable-next-line no-underscore-dangle
        delete lookupDataObj?.value?.fields?.__refOptions__;
        const updateSelectedLookupData = { ...previousSelectedLookupData, [value]: lookupDataObj };
        setSelectedLookupFormData(updateSelectedLookupData);
        destinationObj.selectedValue = value;
        destinationObj.value = {
          id: value,
          imgUrl,
          value: selectedValues.join(' '),
          valueArr: selectedValues,
        };
        if (window.updateStateFromUtility) window.updateStateFromUtility(destinationObj, true);
      }
    } else {
      // eslint-disable-next-line no-use-before-define
      showWarningMessageAlert(res?.statusMessage);
    }
  } catch (error) {
    // Handle any errors that occur during the process
  }
};

// hide table action func.
const hideTableActionsFun = (tableName, fieldConfigurations, hideCreate, hideUpdate, hideDelete) => {
  if (tableName !== null && fieldConfigurations !== undefined && fieldConfigurations[tableName]) {
    fieldConfigurations[tableName].hideCreate = hideCreate;
    fieldConfigurations[tableName].hideUpdate = hideUpdate;
    fieldConfigurations[tableName].hideDelete = hideDelete;
  }
};

const initializeScriptWrapperServiceFields = (service, fields, txnData, perspectiveId, scriptLogicWrapper, verifySubformChecksObj) => {
  if (scriptLogicWrapper) {
    scriptLogicWrapper.setServiceRelatedInfo(service, fields, txnData, perspectiveId, scriptLogicWrapper, verifySubformChecksObj);
    // eslint-disable-next-line no-use-before-define
    scriptLogicWrapper.setTableCallFunFromScriptWrapper(() => callFunFromScriptWrapper);
    scriptLogicWrapper.setCommentsAndAttachmentsFun(() => getCommentAndAttachmentsCount);
    scriptLogicWrapper.setAdditionalFuns(() => getSelectedLookupArr);
    // scriptLogicWrapper.setRefreshFuns(refreshFieldFun);
    scriptLogicWrapper.setHideTableActionsFun(() => hideTableActionsFun);
  }
};

const showWarningMessageAlert = (msgContent) => {
  Message({
    className: accountsConstant.MESSAGE_POPUP.WARNING.CLASSNAME,
    type: accountsConstant.MESSAGE_POPUP.WARNING.TYPE,
    content: msgContent,
    duration: 3,
  });
};

const showInfoMessageAlert = (msgContent) => {
  Message({
    className: accountsConstant.MESSAGE_POPUP.INFO.CLASSNAME,
    type: accountsConstant.MESSAGE_POPUP.INFO.TYPE,
    content: msgContent,
    duration: 3,
  });
};
const isCheckServiceTxnEditPermission = (serviceType, perspectiveId, businessId) => {
  businessId = getLoginBusinessId();
  let permission = false;
  const viewObj = gettingPerspectiveObj(serviceType, perspectiveId, businessId);

  if (viewObj && viewObj.details) {
    if (viewObj.details.state === 'ACTIVE' && viewObj.details.type === 'EDIT') {
      permission = true;
    }
  }

  return permission;
};

const getColSpan = (serviceData) => {
  if (serviceData?.allowAsset || serviceData?.allowActivity || serviceData?.allowComment) {
    return 18;
  }
  return 24;
};

const tokenHasExpired = (expiresOn) => {
  const currentTime = new Date().getTime() / 1000; // current time in seconds
  return currentTime > expiresOn;
};

const getStatusFieldColors = (refDBId, resGraphType, labelsArr, serviceDashBoardListData, businessId) => {
  businessId = getLoginBusinessId();
  const statusFieldColors = {};
  if (serviceDashBoardListData?.length > 0) {
    const svcType = serviceDashBoardListData?.find((item) => item.refDBId === refDBId)?.onType;
    const serviceData = getServiceData(svcType, businessId);
    let dimFieldId = serviceDashBoardListData?.find((item) => item.refDBId === refDBId)?.dimFieldId;
    if (
      resGraphType === 'STACKED_BAR_GRAPH' ||
      resGraphType === 'STACKED_VERTICAL_GRAPH' ||
      resGraphType === 'STACKED_LINE_GRAPH'
    ) {
      const groupFieldId = serviceDashBoardListData?.find((item) => item.refDBId === refDBId)?.groupFieldId;
      dimFieldId = groupFieldId;
    }
    if (serviceData !== undefined) {
      Object.keys(serviceData?.fields || {}).forEach((key) => {
        if (serviceData?.fields[key]?.refId === dimFieldId && serviceData?.fields[key]?.isStatusField) {
          serviceData?.fields[key]?.options?.forEach((option, index) => {
            if (labelsArr?.includes(option)) {
              if (serviceData?.fields[key]?.colorCodes[index] === '#FFFFFF') {
                statusFieldColors[option] = '#A9A9A9';
              } else {
                statusFieldColors[option] = serviceData?.fields[key]?.colorCodes[index];
              }
            }
          });
        }
      });
    }
  }
  const statusColorsArr = Object.keys(statusFieldColors).map((labelKey) => statusFieldColors[labelKey]);
  return statusColorsArr;
};

const getCommentslength = (fieldData, fieldsMeta, fieldTxnComments, txnId, subFormData) => {
  let count = 0;

  if (subFormData?.optionConfig && subFormData?.optionConfig[fieldData?.value]?.comments?.enable) {
    if (fieldTxnComments[fieldData?.refId]?.length === 0) {
      const resultArray = fieldsMeta?.filter((item) => item?.type === `${fieldData?.refId}/COMMENT_STORE`);
      count = resultArray?.length;
    }
    if (fieldTxnComments[fieldData?.refId]?.length > 0) {
      count += fieldTxnComments[fieldData?.refId].length;
    }
    subFormData.optionConfig[fieldData?.value].comments.count = count;
  } else if (!fieldData?.notShowFieldValues && fieldData?.enableComment && txnId) {
    if (fieldTxnComments[fieldData?.refId]?.length === 0) {
      const resultArray = fieldsMeta?.filter((item) => item?.type === `${fieldData?.refId}/COMMENT_STORE`);
      count = resultArray?.length;
    }

    if (fieldTxnComments[fieldData?.refId]?.length > 0) {
      count += fieldTxnComments[fieldData?.refId].length;
    }
  } else if (fieldTxnComments[fieldData?.refId]?.length > 0) {
    count += fieldTxnComments[fieldData?.refId].length;
  }

  return count;
};

const setAllFieldsAttachmentsData = (fields, txnId) => {
  const fieldsAttachmentData = {};
  for (const key in fields) {
    const obj = fields[key];
    // preparing the attchments data based on the field refId.
    if (obj?.attachmentList !== undefined && Object.keys(obj?.attachmentList)?.length > 0) {
      fieldsAttachmentData[obj.refId] = obj?.attachmentList[obj.refId];
    }
    // preparing subform related data.
    if (
      (txnId === '' || txnId === undefined || txnId === null) &&
      obj?.type === templates.UI_TEMPLATES.SUB_FORM_UI_TEMPLATE
    ) {
      for (const subFormkey in obj?.fields) {
        const subFormObj = obj?.fields[subFormkey];
        // preparing the attchments data based on the field refId.
        if (subFormObj?.attachmentList !== undefined && Object.keys(subFormObj?.attachmentList)?.length > 0) {
          fieldsAttachmentData[subFormObj.refId] = subFormObj?.attachmentList[subFormObj.refId];
        }
      }
    }
  }
  setAttachmentsData(fieldsAttachmentData);
};

const setAllSubFormFieldsAttachmentsData = (fields) => {
  const fieldsAttachmentData = {};
  // preparing subform related data.
  for (const subFormkey in fields) {
    const subFormObj = fields[subFormkey];
    // preparing the attchments data based on the field refId.
    if (subFormObj?.attachmentList !== undefined && Object.keys(subFormObj?.attachmentList)?.length > 0) {
      fieldsAttachmentData[subFormObj.refId] = subFormObj?.attachmentList[subFormObj.refId];
    }
  }
  setSubFormAttachmentsData(fieldsAttachmentData);
};

const getXtraFieldsData = (fields, txnId) => {
  // preparing xtrafield data based on the comments
  const xtraFieldsData = {};
  const fieldsAttachmentData = {};
  for (const key in fields) {
    const obj = fields[key];
    if (obj?.xtraFieldsData !== undefined && Object.keys(obj?.xtraFieldsData)?.length > 0) {
      xtraFieldsData[obj.refId] = obj.xtraFieldsData[obj.refId];
    }
    // preparing the attchments data based on the field refId.
    if (obj?.attachmentList !== undefined && Object.keys(obj?.attachmentList)?.length > 0) {
      fieldsAttachmentData[obj.refId] = obj?.attachmentList[obj.refId];
    }
  }
  setAllFieldsAttachmentsData(fields, txnId);
  return xtraFieldsData;
};

// get subform xtrafields data.
const getSubformXtraFieldsData = (fields, txnId) => {
  // preparing xtrafield data based on the comments
  const xtraSubFormFieldsData = {};
  const fieldsAttachmentData = {};
  for (const key in fields) {
    const obj = fields[key];
    if (obj?.xtraFieldsData !== undefined && Object.keys(obj?.xtraFieldsData)?.length > 0) {
      xtraSubFormFieldsData[obj.refId] = obj.xtraFieldsData[obj.refId];
    }
    // preparing the attchments data based on the field refId.
    if (obj?.attachmentList !== undefined && Object.keys(obj?.attachmentList)?.length > 0) {
      fieldsAttachmentData[obj.refId] = obj?.attachmentList[obj.refId];
    }
  }
  if (txnId) {
    setAllSubFormFieldsAttachmentsData(fields);
  }
  return xtraSubFormFieldsData;
};

// get attchments length
const getAttachmentslength = (fieldData, fieldsMeta, fieldTxnAttachments, txnId, subFormData) => {
  let count = 0;

  if (subFormData?.optionConfig && subFormData?.optionConfig[fieldData?.value]?.attachements?.enable && txnId) {
    if (fieldTxnAttachments[fieldData?.refId]?.length === 0) {
      const resultArray = fieldsMeta?.filter((item) => item?.type === `${fieldData?.refId}/ASSET`);
      count = resultArray?.length;
    }
    if (fieldTxnAttachments[fieldData?.refId]?.length > 0) {
      count += fieldTxnAttachments[fieldData?.refId].length;
    }
    subFormData.optionConfig[fieldData?.value].attachements.count = count;
  } else if (!fieldData?.notShowFieldValues && fieldData?.enableAttachment && txnId) {
    if (fieldTxnAttachments[fieldData?.refId]?.length === 0) {
      const resultArray = fieldsMeta?.filter((item) => item?.type === `${fieldData?.refId}/ASSET`);
      count = resultArray?.length;
    }

    if (fieldTxnAttachments[fieldData?.refId]?.length > 0) {
      count += fieldTxnAttachments[fieldData?.refId].length;
    }
  } else if (fieldTxnAttachments[fieldData?.refId]?.length > 0) {
    count += fieldTxnAttachments[fieldData?.refId].length;
  }
  return count;
};

// checking is there any new attachments need to be add.
const checkIsAttachmentsExist = (attachments) => {
  let isBoolen = false; // Use let instead of const
  for (const key in attachments) {
    const newAttachmentArray = attachments[key]?.filter((item) => item?.action === 'ACN_ATTACH_IMAGE');
    if (newAttachmentArray?.length > 0) {
      isBoolen = true;
      break;
    }
  }
  return isBoolen;
};

const filedOrderApply = (fieldConfigurations, fieldsOrder, callback) => {
  logger.info(fieldConfigurations);
  const fieldsConfig = { ...fieldConfigurations };
  if (fieldsOrder && fieldsOrder?.length > 0) {
    fieldConfigurations = {};
  }
  fieldsOrder.forEach((key) => {
    fieldConfigurations[key] = fieldsConfig[key];
  });

  logger.info(fieldConfigurations);
  callback(fieldConfigurations);
};

const subformPreviewCreateArr = [];
const fetchSubformPreviewFieldsData = async (
  serviceType,
  subformRefId,
  perspectiveId,
  businessId,
  fieldConfigurations,
) => {
  const postSubformFields = [];
  const subformPreviewObj = {};
  businessId = getLoginBusinessId();
  const serviceData = await getServiceData(serviceType, businessId);
  if (!subformPreviewCreateArr.includes(subformRefId)) {
    subformPreviewCreateArr.push(subformRefId);
  }

  const perspectiveObj = gettingPerspectiveObj(serviceData.type, perspectiveId, businessId);
  const sfHeadFields = perspectiveObj.details.sfHeadFields || {};

  Object.keys(sfHeadFields).forEach((key) => {
    const find = _.find(serviceData.fields, { refId: key });
    if (find && sfHeadFields[key]?.length > 0) {
      const prepareObj = { refId: key, fields: {}, fieldsArr: [] };
      sfHeadFields[key].forEach((arrRefId) => {
        for (const subformKey in find.fields) {
          const subformObj = find.fields[subformKey];
          if (arrRefId === subformObj.refId) {
            prepareObj.fields[subformKey] = {};
            prepareObj.fieldsArr.push(subformKey);
            break;
          }
        }
      });

      postSubformFields.push(prepareObj);
    }
  });

  if (postSubformFields?.length > 0) {
    const res = { data: postSubformFields };
    if (res.data) {
      res.data.forEach((resObj) => {
        Object.keys(resObj.fields).forEach((subKey) => {
          // const subformRefObj = _.find(fieldConfigurations, { refId: resObj.refId });
          if (fieldConfigurations?.refId === resObj.refId) {
            const subformRefObj = fieldConfigurations;
            const mergeJson = {
              ...subformRefObj.fields[subKey],
              ...resObj.fields[subKey],
            };
            resObj.fields[subKey] = mergeJson;
          }
        });

        postSubformFields.forEach((psFObj) => {
          if (psFObj.refId === resObj.refId) {
            if (subformPreviewCreateArr.includes(resObj.refId)) {
              filedOrderApply(resObj.fields, psFObj.fieldsArr.reverse(), (fields) => {
                subformPreviewObj[resObj.refId] = fields;
              });
            } else {
              filedOrderApply(resObj.fields, psFObj.fieldsArr.reverse(), (fields) => {
                subformPreviewObj[resObj.refId] = fields;
              });
            }
          }
        });
      });
      logger.info(subformPreviewObj);
    }
  }
  return subformPreviewObj;
};

// preparing the fields data for post json data
const validateSubform = (fieldsData, perspectiveId, serviceType, txnId, businessId) => {
  businessId = getLoginBusinessId();
  fieldsData.atLeastOneValue = false;
  for (const key in fieldsData?.fields) {
    const obj = fieldsData?.fields[key];
    if (!hideFieldPermission(obj?.refId, perspectiveId, serviceType, txnId, businessId)) {
      switch (obj.type) {
        case templates.UI_TEMPLATES.SINGLE_CHOICE_UI_TEMPLATE:
        case templates.UI_TEMPLATES.RADIO_BUTTON_UI_TEMPLATE:
          if (!obj.isSkippable) {
            if (fieldsData?.enableChecklist && obj.type === templates.UI_TEMPLATES.RADIO_BUTTON_UI_TEMPLATE) {
              if (
                fieldsData.optionConfig[obj.value] &&
                fieldsData.optionConfig[obj.value].attachements &&
                fieldsData.optionConfig[obj.value].attachements.enable &&
                fieldsData.optionConfig[obj.value].attachements.isRequired &&
                fieldsData.optionConfig[obj.value].attachements?.count === 0
              ) {
                showMessageAlert(`Please add atleast one attachment to : ${obj.label}`);
                return;
              }
              if (
                fieldsData.optionConfig[obj.value] &&
                fieldsData.optionConfig[obj.value].comments &&
                fieldsData.optionConfig[obj.value].comments.enable &&
                fieldsData.optionConfig[obj.value].comments.isRequired &&
                fieldsData.optionConfig[obj.value].comments?.count === 0
              ) {
                showMessageAlert(`Please add atleast one comment to : ${obj.label}`);
                return;
              }
              if (obj?.options) {
                let optionLabel = '';
                for (let i = 0; i < obj.options.length; i++) {
                  if (obj.options[i] === obj.value) optionLabel = obj.options[i];
                }
                obj.optionLabel = optionLabel;
              }
            }
            if (obj.type === templates.UI_TEMPLATES.SINGLE_CHOICE_UI_TEMPLATE) {

              if (!obj.isSkippable && !obj?.notShowFieldValues && (obj.value === '' || obj.value === null || obj.value === undefined)) {
                showMessageAlert(`${form.DYNAMIC_FORM.MANDATORY} : ${obj.label}`);
                return;
              }
              if (!obj.isSkippable && obj?.notShowFieldValues && obj?.enableAttachment && (obj?.attachmentList === undefined || obj?.attachmentList?.length === 0)) {
                showMessageAlert(`Please add atleast one attachment to : ${obj.label}`);
                return;
              }
              if (!obj.isSkippable && obj?.notShowFieldValues && obj?.enableComment && (obj?.commentsList === undefined || obj?.commentsList?.length === 0)) {
                showMessageAlert(`Please add atleast one comment to : ${obj.label}`);
                return;
              }
              if (obj?.options) {
                let optionLabel = '';
                for (let i = 0; i < obj.options.length; i++) {
                  if (obj.options[i] === obj.value) optionLabel = obj.options[i];
                }
                obj.optionLabel = optionLabel;
              }
            } else if (obj.value === undefined || obj.value === '' || obj.value === null) {
              showMessageAlert(`${form.DYNAMIC_FORM.MANDATORY} : ${obj.label}`);
              return;
          // eslint-disable-next-line no-else-return
            }
          } else if (obj.value && obj.value !== '' && obj.value !== null) {
            fieldsData.atLeastOneValue = true;
          }
          break;

        case templates.UI_TEMPLATES.CHECKBOX_UI_TEMPLATE:
        case templates.UI_TEMPLATES.MULTI_SELECT_UI_TEMPLATE:
          if (!obj.isSkippable) {
            if (obj.value === '' ||
              obj.value === null ||
              obj.value === undefined ||
              (Array.isArray(obj.value) && obj.value.length === 0)
            ) {
              showMessageAlert(`${form.DYNAMIC_FORM.MANDATORY} : ${obj.label}`);
              return;
            }
            if (obj.type === templates.UI_TEMPLATES?.MULTI_SELECT_UI_TEMPLATE && obj?.options) {
              const optionLabel = [];
              for (const i in obj.value) {
                for (let j = 0; j < obj.options.length; j++) {
                  if (obj.options[j] === obj.value[i]) optionLabel.push(obj.options[j]);
                }
              }
              obj.optionLabel = optionLabel;
              obj.value = obj.value === '' ? [] : obj.value;
            }
            obj.value = obj.value === '' || obj.value === null ? [] : obj.value;

          } else if (obj?.value && obj?.value !== '' && obj?.value !== null && obj?.value?.length > 0) {
            fieldsData.atLeastOneValue = true;
          }
          break;

        case templates.UI_TEMPLATES.BAR_CODE_UI_TEMPLATE:
        case templates.UI_TEMPLATES.QR_CODE_UI_TEMPLATE:
          if (!obj.isSkippable) {
            if ((obj.value === '' || obj.value === null || obj.value === undefined)) {
              showMessageAlert(`${form.DYNAMIC_FORM.MANDATORY} : ${obj.label}`);
              return false;
            }
            if (
              typeof obj.maxChars !== 'undefined' &&
              typeof obj.value !== 'undefined' &&
              obj.value.length > obj.maxChars
            ) {
              showMessageAlert(`Value entered should be of ${obj.maxChars} character(s) : ${obj.label}`);
              return false;
            }
          } else if (obj.value && obj.value !== '') {
            fieldsData.atLeastOneValue = true;
          }
          break;

        case templates.UI_TEMPLATES.DATE_PICKER_UI_TEMPLATE:
          if (!obj.isSkippable) {
            if (obj.value === '' || obj.value === null || obj.value === undefined) {
              showMessageAlert(`${form.DYNAMIC_FORM.MANDATORY} : ${obj.label}`);
              return;
            }
            let dateString = '';
            if (obj?.dateFormat === "dd-MM-yyyy") {
              if (moment(obj?.value, 'YYYY-MM-DD', true).isValid()) {
                dateString = obj?.value;
              } else {
                // Step 1: Parse the date correctly using the 'DD-MM-YYYY' format
                const parsedDate = moment(obj.value, 'DD-MM-YYYY', true);  // Strict mode ensures exact format match
                // Step 2: If the date is valid, convert it to 'YYYY-MM-DD' format
                if (parsedDate.isValid()) {
                  dateString = parsedDate.format('YYYY-MM-DD');
                  console.log('Formatted Date:', dateString);
                } else {
                  console.log('Invalid date format');
                }
              }
            } else {
              dateString = obj.value ? moment(obj.value).format('YYYY-MM-DD') : '';
            }
            obj.value = dateString;
          } else if (obj.value && obj.value !== '' && obj.value !== null) {
            fieldsData.atLeastOneValue = true;
          }
          break;

        case templates.UI_TEMPLATES.MOBILE_NUMBER_UI_TEMPLATE:
          if (!obj.isSkippable) {
            if (obj.value === '' || obj.value === null || obj?.value?.length === 0) {
              showMessageAlert(`${form.DYNAMIC_FORM.MANDATORY} : ${obj.label}`);
              return;
            }
          }
          const numstr = obj.value ? obj.value.toString() : '';
          obj.value = numstr;
          if (obj.isValid === false) {
            showMessageAlert(`Please enter valid : ${obj.label}`);
            return false;
          }
          if (obj.value && obj.value !== '' && obj.value !== null) {
            fieldsData.atLeastOneValue = true;
          }
          break;

        case templates.UI_TEMPLATES.LOCATION_UI_TEMPLATE:
          if (!obj.isSkippable) {
            if (obj.value === '' || obj.value === null || obj.value === undefined || obj.coordinates?.length === 0) {
              showMessageAlert(`Please point a location on the map : ${obj.label}`);
              return false;
            }
          } else if (obj.value && obj.value !== '' && obj.value !== null) {
            fieldsData.atLeastOneValue = true;
          }
          break;

        case templates.UI_TEMPLATES.SIGNATURE_UI_TEMPLATE:
          if (!obj.isSkippable) {
            if (!obj.value || obj.value === form?.EMPTY_IMAGE || typeof obj.value === 'undefined') {
              showMessageAlert(`Please provide an eSignature : ${obj.label}`);
              return false;
            }
          }
          else if (obj.value && obj.value !== '' && obj.value !== null) {
            fieldsData.atLeastOneValue = true;
          }
          break;

        case templates.UI_TEMPLATES.NUMBER_UI_TEMPLATE:
        case templates.UI_TEMPLATES.CURRENCY_UI_TEMPLATE:
          if (!obj.isSkippable) {
            if (Number.isNaN(obj.value) || obj.value === '' || obj.value === null || obj.value === undefined) {
              showMessageAlert(`${form.DYNAMIC_FORM.MANDATORY} : ${obj.label}`);
              return false;
            }
            if (obj?.dnaNegative && obj?.dnaNegative && obj?.value && obj?.value < 0) {
              showMessageAlert(`Negative values are not allowed in ${obj.label}`);
              return false;
            }
            if (typeof obj.minDigits !== 'undefined' && obj.value && obj.value.toString().length < obj.minDigits) {
              showMessageAlert(`Value entered should be at least : ${obj.minDigits} digit(s). ${obj.label}`);
              return false;
            }
            // eslint-disable-next-line no-else-return
            else if (typeof obj.maxDigits !== 'undefined' && obj.value && obj.value.toString().length > obj.maxDigits) {
              showMessageAlert(`Value entered should be ${obj.maxDigits} digit(s) : ${obj.label}`);
              return false;
            }
            else if (typeof obj.value === 'undefined' || obj.value === null) {
              obj.value = 0;
            }
          }
          if (obj.value && obj.value !== '' && obj.value !== null) {
            fieldsData.atLeastOneValue = true;
          }
          break;

        case templates.UI_TEMPLATES.EDIT_TEXT_UI_TEMPLATE:
          if (!obj.isSkippable) {
            if (obj.value === '' || obj.value === null || obj.value === undefined) {
              showMessageAlert(`${form.DYNAMIC_FORM.MANDATORY} : ${obj.label}`);
              return false;
            }
            if (
              typeof obj.minChars !== 'undefined' &&
              typeof obj.value !== 'undefined' &&
              obj.value.length < obj.minChars
            ) {
              showMessageAlert(`Value entered should be at least ${obj.minChars} character(s) : ${obj.label}`);
              return false;
            }
            // eslint-disable-next-line no-else-return
            else if (
              typeof obj.maxChars !== 'undefined' &&
              typeof obj.value !== 'undefined' &&
              obj.value.length > obj.maxChars
            ) {
              showMessageAlert(`Value entered should be of ${obj.maxChars} character(s): ${obj.label}`);
              return false;
            }
          }
          else if (obj.value && obj.value !== '' && obj.value !== null) {
            fieldsData.atLeastOneValue = true;
          }
          break;

        case templates.UI_TEMPLATES.URL_UI_TEMPLATE:
          if (!obj.isSkippable) {
            if (obj.value === '' || obj.value === null || obj.value === undefined) {
              showMessageAlert(`${form.DYNAMIC_FORM.MANDATORY} : ${obj.label}`);
              return false;
            }
            if (obj.value) {
              // eslint-disable-next-line no-useless-escape
              const res = obj.value.match(/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/);
              if (res === null) {
                showMessageAlert(`Please enter valid : ${obj.label}`);
                return false;
              }
            }
          }
          else if (obj.value && obj.value !== '' && obj.value !== null) {
            fieldsData.atLeastOneValue = true;
          }
          break;


        case templates.UI_TEMPLATES.TEXTAREA_UI_TEMPLATE:
        case templates.UI_TEMPLATES.RATING_UI_TEMPLATE:
        case templates.UI_TEMPLATES.LOOKUP_UI_TEMPLATE:
          if (!obj.isSkippable) {
            if (obj.value === '' || obj.value === null || obj.value === undefined) {
              showMessageAlert(`${form.DYNAMIC_FORM.MANDATORY} : ${obj.label}`);
              return false;
            }
          }
          else if (obj.value && obj.value !== '' && obj.value !== null) {
            fieldsData.atLeastOneValue = true;
          }
          break;


        case templates.UI_TEMPLATES.IMAGE_UPLOAD_UI_TEMPLATE:
        case templates.UI_TEMPLATES.FILE_UPLOAD_UI_TEMPLATE:
          if (!obj.isSkippable) {
            if (obj.value === '' || obj.value === null) {
              showMessageAlert(`${form.DYNAMIC_FORM.MANDATORY} : ${obj.label}`);
              return false;
            }
          }
          else if (obj.value && obj.value !== '' && obj.value !== null) {
            fieldsData.atLeastOneValue = true;
          }
          break;

        case templates.UI_TEMPLATES.FORMULA_UI_TEMPLATE:
          if (obj.returnType === 'DATE') {
            const dateString = obj.value ? moment(obj.value).format('YYYY-MM-DD') : '';
            obj.value = dateString;
          }
          if (obj.value && obj.value !== '' && obj.value !== null) {
            fieldsData.atLeastOneValue = true;
          }
          break;

        case templates.UI_TEMPLATES.EMAIL_TEXT_UI_TEMPLATE:
          if (!obj.isSkippable) {
            if (obj.value === '' || obj.value === null || obj.value === undefined) {
              showMessageAlert(`${form.DYNAMIC_FORM.MANDATORY} : ${obj.label}`);
              return false;
            }
            if (obj.value !== null && obj.value !== '') {
              // Now you can use the match method
              const regExp = /^(\s?[^\s,]+@[^\s,]+\.[^\s,]+\s?,)*(\s?[^\s,]+@[^\s,]+\.[^\s,]+)$/;
              const matchResult = regExp.test(obj.value);
              if (!matchResult) {
                showMessageAlert(`Please enter valid email Id(s) : ${obj.label}`);
                return false;
              }
            }
          }
          else if (obj.value && obj.value !== '' && obj.value !== null) {
            fieldsData.atLeastOneValue = true;
          }
          break;
        default:
          if (
            obj.type !== templates.UI_TEMPLATES.SECTION_UI_TEMPLATE &&
            obj.type !== templates.UI_TEMPLATES.SPACER_UI_TEMPLATE &&
            obj.type !== templates.UI_TEMPLATES.LINE_UI_TEMPLATE &&
            obj.type !== templates.UI_TEMPLATES.BUTTON_UI_TEMPLATE
          ) {
            if (!obj.isSkippable) {
              if (obj.value === undefined || obj.value === '' || obj.value === null) {
                showMessageAlert(`${form.DYNAMIC_FORM.MANDATORY} : ${obj.label}`);
                return;
              }
            }
            else if (obj.value && obj.value !== '') {
              fieldsData.atLeastOneValue = true;
            }
          }
      }
    }
  }
  return fieldsData;
};

const getPerspectiveIds = (bizAccountRefId, businessId, bizAccountServiceList, bizAccountObjPermissions) => {
  businessId = getLoginBusinessId();
  const perspectiveArray = [bizAccountRefId];
  const types = [];

  if (bizAccountObjPermissions && Object.keys(bizAccountObjPermissions)?.length > 0) {
    Object.keys(bizAccountObjPermissions)?.forEach((type) => {
      if (bizAccountServiceList && Object.keys(bizAccountServiceList)?.length > 0) {
        const serviceInfo = bizAccountServiceList[type] || {};
        if (serviceInfo.actionFlowOrder && serviceInfo.actionFlowOrder.length > 0) {
          Object.values(bizAccountObjPermissions[type]).forEach((val) => {
            if (val && val.perspectiveId) {
              perspectiveArray.push(val.perspectiveId);
              types.push(type);
            }
          });
        }
      }
    });
  }

  return {
    perspectiveArray,
    types: [...new Set(types)], // Use Set to remove duplicates
  };
};

const getIsHiddenModeVal = (serviceObjPermissionObj) => {
  for (const accessId in serviceObjPermissionObj) {
    const accessObj = serviceObjPermissionObj[accessId];
    if (!accessObj.hiddenMode && accessId !== 'config' && accessId !== 'teamIds') {
      return false;
    }
  }
  return true;
};

// =========================================================================
// checking account user permissions
// =========================================================================
const checkAccountUserPermission = (permission, bizAccountPermissions) => {
  // Copy the permissions array to prevent mutations.
  const userBusinessId = getLoginBusinessId();
  const accountUserPermissionList = useBizAccountObjPermissions(userBusinessId)?.permissions || [];

  // If user is a Super user, return true.
  if (accountUserPermissionList && permission && permission !== '') {
    if (accountUserPermissionList.includes(permission)) {
      // If the user has the permission, return true.
      return true;
    } else {
      // Return false if the user doesn't have the permission.
      return false;
    }
  } else {
    // Return false if no value is assigned to the permission.
    return false;
  }
};

// lookup filter dependency.
// getting lookup options based on depends on fields
const preparingLookupFilterData = (dependsOn, key, fields, action, currentFieldObj, filterArray, parent, tableName) => {
  const userBusinessId = getLoginBusinessId();
  // getting the apps list
  const bizAccountServiceList = getSession(
    `${userBusinessId}_biz_accocunt_user_service_list`,
    true,
  )?.bizAccountServiceList;

  // getting the consumers list
  const bizAccountConsumersList = getSession(
    `${userBusinessId}_biz_accocunt_user_consumer_list`,
    true,
  )?.bizAccountConsumersList;

  const fieldsByRefId = {};
  Object.keys(fields).forEach((fieldKey) => {
    const obj = { ...fields[fieldKey], name: fieldKey };
    fieldsByRefId[obj.refId] = obj;
  });

  let parentServiceData = {};
  if (parent[key] && parent[key]?.lookupType?.includes('SVC')) {
    parentServiceData = bizAccountServiceList[parent[key].lookupType] || {};
  } else if (parent[key] && parent[key]?.lookupType?.includes('USR')) {
    parentServiceData = bizAccountConsumersList[parent[key]?.lookupType] || {};
  }

  const parentFieldsByRefId = {};
  if (parentServiceData?.fields) {
    Object.keys(parentServiceData?.fields).forEach((fieldKey) => {
      const obj = { ...parentServiceData.fields[fieldKey], name: fieldKey };
      parentFieldsByRefId[obj.refId] = obj;
    });
  }

  for (const i in dependsOn) {
    const isMandatory = dependsOn[i].isMandatory !== undefined ? dependsOn[i].isMandatory : true;
    const obj = fieldsByRefId[dependsOn[i].cFid];
    const parentObj = parentFieldsByRefId[dependsOn[i].pFid];

    if (obj && parentObj) {
      switch (obj.type) {
        case templates.UI_TEMPLATES.LOOKUP_UI_TEMPLATE:
          if ((!obj.selectedValue || obj.selectedValue === '') && isMandatory) {
            if (action === 'TABLE') {
              showMessageAlert(`Please fill the ${obj.label} in ${tableName}`);
            } else {
              showMessageAlert(`Please fill the ${obj.label}`);
            }
            return;
          }
          if (obj.selectedValue && obj.selectedValue !== '') {
            filterArray.push({ name: parentObj.name, value: obj.selectedValue, operator: dependsOn[i].operator });
          }
          break;

        case templates.UI_TEMPLATES.DATE_PICKER_UI_TEMPLATE:
          if ((!obj.value || obj.value === '' || obj.value === 'Invalid date') && isMandatory) {
            if (action === 'TABLE') {
              showMessageAlert(`Please fill the ${obj.label} in ${tableName}`);
            } else {
              showMessageAlert(`Please fill the ${obj.label}`);
            }
            return;
          }
          if (obj.value && obj.value !== '' && obj.value !== 'Invalid date') {
            filterArray.push({
              name: parentObj.name,
              value: moment(obj.value).format('YYYY-MM-DD'),
              operator: dependsOn[i].operator,
            });
          }
          break;

        case templates.UI_TEMPLATES.MULTI_SELECT_UI_TEMPLATE:
          if ((!obj.value || obj.value.length === 0 || obj.value === '') && isMandatory) {
            if (action === 'TABLE') {
              showMessageAlert(`Please fill the ${obj.label} in ${tableName}`);
            } else {
              showMessageAlert(`Please fill the ${obj.label}`);
            }
            return;
          }
          if (obj.value && obj.value !== '' && obj.value.length !== 0) {
            filterArray.push({ name: parentObj.name, value: obj.value, operator: dependsOn[i].operator });
          }
          break;

        case templates.UI_TEMPLATES.NUMBER_UI_TEMPLATE:
          if ((Number.isNaN(obj.value) || obj.value === undefined || obj.value === null) && isMandatory) {
            if (action === 'TABLE') {
              showMessageAlert(`Please fill the ${obj.label} in ${tableName}`);
            } else {
              showMessageAlert(`Please fill the ${obj.label}`);
            }
            return;
          }
          if (obj.value !== undefined && obj.value !== null) {
            filterArray.push({ name: parentObj.name, value: obj.value, operator: dependsOn[i].operator });
          }
          break;

        default:
          if ((!obj.value || obj.value === '' || obj.value?.length === 0) && isMandatory) {
            if (action === 'TABLE') {
              showMessageAlert(`Please fill the ${obj.label} in ${tableName}`);
            } else {
              showMessageAlert(`Please fill the ${obj.label}`);
            }
            return;
          }
          if (obj.value && obj.value !== '' && obj.value?.length !== 0) {
            logger.info('obj.value', obj);
            filterArray.push({ name: parentObj.name, value: obj.value, operator: dependsOn[i].operator });
          }
          break;
      }
    }
  }
  logger.info('obj.value', filterArray);

  return filterArray;
};

const getPerspectiveObjWithId = (serviceType, perspectiveId) => {
  const businessId = getLoginBusinessId();
  const bizAccountObjPermissions = useBizAccountObjPermissions(businessId);
  let obj = {};
  if (bizAccountObjPermissions?.objPermissions[serviceType]) {
    obj =
      Object.values(bizAccountObjPermissions?.objPermissions[serviceType]).find((accessObj) => {
        if (accessObj.perspectiveId === perspectiveId) {
          return accessObj;
        }
      }) || {};
  }

  return obj;
};

// parameters are currentFieldObj.dependsOn, keyName, action, currentFieldObj
const getDependsOnOpts = (dependsOn, fieldKey, formAction, currentFieldObj) => {
  let filterArray = [];
  const fields = getTxnFormData();
  if (fields !== undefined && Object.keys(fields).length > 0) {
    filterArray = preparingLookupFilterData(
      dependsOn,
      fieldKey,
      fields,
      formAction,
      currentFieldObj,
      filterArray,
      fields,
    );
    if (!filterArray) return;
    if (fields[fieldKey] !== undefined) {
      fields[fieldKey].filterData = filterArray || [];
    }
    setTxnFormData(fields);
    return true;
  }
};

// parameters are currentFieldObj.dependsOn, keyName, action, currentFieldObj
const getTableDependsOnOpts = (dependsOn, fieldKey, formAction, currentFieldObj, tableFields, tableName) => {
  let filterArray = [];
  const fields = getTxnFormData();
  if (fields !== undefined && Object.keys(fields).length > 0) {
    filterArray = preparingLookupFilterData(
      dependsOn,
      fieldKey,
      fields,
      formAction,
      currentFieldObj,
      filterArray,
      tableFields,
      tableName
    );
    if (!filterArray) return;
    if (currentFieldObj !== undefined) {
      currentFieldObj.filterData = filterArray || [];
    }
  }
  if (tableFields !== undefined && Object.keys(tableFields).length > 0) {
    filterArray = preparingLookupFilterData(
      dependsOn,
      fieldKey,
      tableFields,
      formAction,
      currentFieldObj,
      filterArray,
      tableFields,
      tableName
    );
    if (!filterArray) return;
    if (fields[fieldKey] !== undefined) {
      fields[fieldKey].filterData = filterArray || [];
    }
  }
  return true;
};

const checkIsCustomFilterMode = (currentFieldObj, serviceType, perspectiveId, txnId, isDisabled) => {
  let action = null;
  let currentPerspectiveId = null;
  let type = '';
  let pageMode = 'NEW';

  if (txnId !== undefined && txnId !== null && txnId !== '') {
    pageMode = isDisabled ? 'VIEW' : 'UPDATE';
  }

  if (serviceType === 'USR_TYPE') {
    currentPerspectiveId = perspectiveId;
    type = serviceType;

    if (pageMode === 'NEW' && currentPerspectiveId) {
      action = 'CREATE';
    } else if (pageMode === 'VIEW' && currentPerspectiveId) {
      action = 'UPDATE';
    }
  } else {
    currentPerspectiveId = perspectiveId;
    type = serviceType;

    if (pageMode === 'NEW' && currentPerspectiveId) {
      action = 'CREATE';
    } else if (pageMode === 'UPDATE' || pageMode === 'VIEW' && currentPerspectiveId) {
      action = 'UPDATE';
    }
  }

  const persObj = getPerspectiveObjWithId(type, currentPerspectiveId);
  if (persObj && persObj.type === 'SYSTEM') {
    currentPerspectiveId = null;
    action = null;
    return {};
  } else {
    let isExistFilter = null;

    if (action === 'CREATE') {
      if (persObj && persObj.view && persObj.view.create && persObj.view.create.lookups) {
        isExistFilter = persObj.view.create.lookups[currentFieldObj.refId];
      }
    } else if (action === 'UPDATE' || pageMode === 'VIEW') {
      if (persObj && persObj.view && persObj.view.details && persObj.view.details.lookups) {
        isExistFilter = persObj.view.details.lookups[currentFieldObj.refId];
      }
    }

    return isExistFilter ? { perspectiveId: currentPerspectiveId, txnAction: action, isFilter: true } : {};
  }
};

const clearLookupDependsOn = (refId, fields) => {
  for (const key in fields) {
    const obj = fields[key];
    if (
      obj &&
      obj.type === templates.UI_TEMPLATES.LOOKUP_UI_TEMPLATE &&
      obj?.dependsOn &&
      obj?.dependsOn.length > 0 &&
      obj?.dependsOn.some((dependsOnItem) => dependsOnItem.cFid === refId)
    ) {
      // if (!checkIsFromParentLookup(fields[key].lookupType)) {
      fields[key].filterData = null;
      fields[key].selectedValue = '';
      fields[key].value = '';
      //  }
    }

    // single select look up dependency
    if (
      obj &&
      obj.type === templates.UI_TEMPLATES.SINGLE_CHOICE_UI_TEMPLATE &&
      obj?.isDynamicOptions &&
      obj?.dependsOn &&
      obj?.dependsOn?.length > 0 &&
      obj?.dependsOn.some((dependsOnItem) => dependsOnItem.cFid === refId)
    ) {
      fields[key].filterData = null;
      fields[key].selectedValue = '';
      fields[key].value = '';
    }

    // table field dependency checking.
    if (obj && obj.type === templates.UI_TEMPLATES.TABLE_UI_TEMPLATE) {
      const tableFields = obj.fields;
      for (const column in tableFields) {
        const rowObj = tableFields[column];
        if ((rowObj.type === templates.UI_TEMPLATES.LOOKUP_UI_TEMPLATE || rowObj.type === templates.UI_TEMPLATES.MULTI_SELECT_UI_TEMPLATE) &&
          rowObj?.dependsOn &&
          rowObj?.dependsOn?.length > 0 &&
          rowObj?.dependsOn?.some((dependsOnItem) => dependsOnItem.cFid === refId)
        //  _.includes(rowObj.dependsOn, { cFid: refId })
        ) {
          obj?.tableRows?.forEach((tableRowObj) => {
            tableRowObj.fields[column].filterData = null;
            tableRowObj.fields[column].selectedValue = '';
            tableRowObj.fields[column].value = '';
            // eslint-disable-next-line no-use-before-define
            scriptLogicForTableRow(
              tableRowObj.fields,
              tableRowObj.fields[column].type,
              obj.refId,
              obj?.tableRows,
              tableRowObj.fields[column].refId,
            );
          });
        }
      }
    }
  }
};

// getting fav dashboard id's form the user obj permissions.
const getFavRefdashboardIds = () => {
  const businessId = getLoginBusinessId();
  const bizObj = useBizAccountObjPermissions(businessId);
  return bizObj?.preferences?.dashboards || [];
};

// downloading multiple images as zip folder
const downloadImagesAsZip = async (imageUrls, serviveTitle) => {
  const zip = new JSZip();
  const promises = imageUrls.map(async (img, index) => {
    try {
      const response = await fetch(img?.url);
      logger.info(img?.fname);
      logger.info(response);
      const blob = await response.blob();
      zip.file(`${img?.fname}-${index + 1}.jpg`, blob);
    } catch (error) {
      logger.error(`Failed to fetch image ${index + 1}:`, error);
    }
  });

  // Wait for all images to be added to the zip
  await Promise.all(promises);

  // Generate the zip file
  zip.generateAsync({ type: 'blob' }).then((content) => {
    // Save the zip file
    saveAs(content, `${serviveTitle}.zip`);
  });
};

// making the graph Options
const checkFloatNumber = (n) => {
  return Number(n) === n && n % 1 !== 0;
};
// get percentage value for graph while hover the graph
function getPercentage(graphData, index) {
  let totalCount = 0;
  let percent = 0;
  graphData?.datasets[0]?.data.forEach((item) => {
    if (typeof item === 'number') {
      totalCount += item;
    }
  });
  // eslint-disable-next-line no-unsafe-optional-chaining
  percent = (graphData?.datasets[0]?.data[index] / totalCount) * 100;
  return percent.toFixed(2);
}
// get percentage value for graph while hover the graph
function getIndividualVal(graphData, index) {
  let totalCount = 0;
  if (graphData && graphData.datasets && graphData.datasets[0] && graphData.datasets[0].data) {
    totalCount = graphData.datasets[0].data[index];
  }
  return totalCount;
}
// coma sepaterd value
function getCommaSeparatedValues(input) {
  if (typeof input === 'number' && typeof input !== 'undefined' && input !== null) {
    const result = input.toString().split('.');
    const lastThree = result[0].substring(result[0].length - 3);
    const otherNumbers = result[0].substring(0, result[0].length - 3);
    let output = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + lastThree;
    if (result.length > 1) {
      output += `.${result[1]}`;
    }
    return output;
  }
  return 0;
}
// Include a dollar sign in the ticks
function getFormatValues(value) {
  if (value > 9999) {
    const units = ['K', 'M', 'B', 'T'];
    const order = Math.floor(Math.log(value) / Math.log(1000));
    const unitname = units[order - 1];
    const num = Math.floor(value / 1000 ** order);
    // output number remainder + unitname
    return num + unitname;
  }
  let returnVal = value;
  if (checkFloatNumber(value)) {
    returnVal = Math.round(value * 100) / 100;
  }
  // return formatted original number
  return returnVal === 0 ? 'No data available' : returnVal;
}
// getting totals for showing the data on graph center.
function getSum(total, num) {
  if (typeof num === 'number') {
    return total + num;
  }
  return total;
}

const showFieldGraphData = (labels, graphData, fieldData, graphType) => {
  const graphOptions =
    graphType === 'bar' || graphType === 'line' || graphType === 'horizontalBar'
      ? {
          responsive: true,
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  display: graphType === 'horizontalBar' ? fieldData?.axisLabels : fieldData?.axisValues,
                  fontSize: 10,
                  fontWeight: 400,
                  fontColor: 'rgb(159, 159, 159)',
                  fontFamily: 'tahoma',
                  // eslint-disable-next-line no-unused-vars
                  callback(value, index, values) {
                    if (value > 9999) {
                      const units = ['K', 'M', 'B', 'T'];
                      const order = Math.floor(Math.log(value) / Math.log(1000));
                      const unitname = units[order - 1];
                      const num = Math.floor(value / 1000 ** order);
                      return num + unitname;
                    }
                    return value;
                  },
                },
                scaleLabel: {
                  display: graphType === 'horizontalBar' ? fieldData?.axisLabels : fieldData?.axisValues,
                  //  labelString: measLabel,
                  fontSize: 12,
                  fontWeight: 900,
                  fontColor: '#384d48',
                  fontFamily: 'tahoma',
                },
              },
            ],
            xAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  display: graphType === 'horizontalBar' ? fieldData?.axisValues : fieldData?.axisLabels,
                  fontSize: 10,
                  fontColor: '#000000',
                  fontWeight: 400,
                  fontFamily: 'tahoma',
                },
                afterTickToLabelConversion(data) {
                  const xLabels = data.ticks;
                  xLabels.forEach(function (label, i) {
                    xLabels[i] = label.length > 10 ? `${label.substring(0, 10)}...` : label;
                  });
                },
                scaleLabel: {
                  display: graphType === 'horizontalBar' ? fieldData?.axisValues : fieldData?.axisLabels,
                  // labelString: dimLabel,
                  fontSize: 12,
                  fontWeight: 900,
                  fontColor: '#384d48',
                  fontFamily: 'tahoma',
                },
              },
            ],
          },
          plugins: {
            datalabels: {
              display: true,
              align: 'center',
              anchor: 'center',
              color: '#384d48',
              font: {
                weight: 'bold',
                size: 12,
              },
              rotation: graphType === 'horizontalBar' ? undefined : '-90',
              formatter(value, context) {
                if (value > 9999) {
                  const units = ['K', 'M', 'B', 'T'];
                  const order = Math.floor(Math.log(value) / Math.log(1000));
                  const unitname = units[order - 1];
                  const num = Math.floor(value / 1000 ** order);
                  // eslint-disable-next-line no-return-assign
                  return (context.chart.data[context.dataIndex] = num + unitname);
                }
                // eslint-disable-next-line no-return-assign
                return (context.chart.data[context.dataIndex] = value);
              },
              // eslint-disable-next-line no-dupe-keys
              display(context) {
                return context.dataset.data[context.dataIndex] !== 0;
              },
            },
          },
          tooltips: {
            backgroundColor: '#ffffff',
            bodyFontColor: '#384d48',
            caretSize: 5,
            borderColor: '#384d48',
            borderWidth: 1,
            cornerRadius: 2,
            xPadding: 10,
            yPadding: 10,
            bodyFontSize: 14,
            bodyFontStyle: 'bold',
            callbacks: {
              label(tooltipItem, data) {
                const percentValue = getPercentage(data, tooltipItem.index);
                const totalVal = getIndividualVal(data, tooltipItem.index);
                return `${data.labels[tooltipItem.index]} : ${totalVal} (${percentValue}%)`;
              },
            },
          },
          legend: {
            display: false,
            position: 'right',
            fontFamily: 'tahoma',
            labels: {
              fontColor: 'rgb(159, 159, 159)',
              fontSize: 10,
              boxWidth: 5,
              fontWeight: 400,
            },
          },
        }
      : {
          responsive: true,
          legend: {
            display: true,
            position: 'right',
            fontFamily: 'tahoma',
            labels: {
              fontColor: '#384d48',
              fontSize: 11,
              boxWidth: 5,
              fontStyle: 'bold',
              generateLabels: (chart) => {
                const { data } = chart;
                if (data.labels.length && data.datasets.length) {
                  return data.labels.map((label, i) => {
                    const meta = chart.getDatasetMeta(0);
                    const ds = data.datasets[0];
                    const arc = meta.data[i];
                    const custom = (arc && arc.custom) || {};
                    const arcOpts = chart.options.elements.arc;
                    const fill = custom.backgroundColor
                      ? custom.backgroundColor
                      : (ds.backgroundColor && ds.backgroundColor[i]) || arcOpts.backgroundColor;
                    const stroke = custom.borderColor
                      ? custom.borderColor
                      : (ds.borderColor && ds.borderColor[i]) || arcOpts.borderColor;
                    const bw = custom.borderWidth
                      ? custom.borderWidth
                      : (ds.borderWidth && ds.borderWidth[i]) || arcOpts.borderWidth;
                    // eslint-disable-next-line no-underscore-dangle
                    const value = chart.config.data.datasets[arc._datasetIndex].data[arc._index];
                    if (arc._index < 8) {
                      return {
                        text:
                          label.length > 15
                            ? `${label.substring(0, 15)}...`
                            : `${label} (${getCommaSeparatedValues(value)})`,
                        fillStyle: fill,
                        strokeStyle: stroke,
                        lineWidth: bw,
                        hidden: typeof ds.data[i] !== 'number' || meta.data[i].hidden,
                        index: i,
                      };
                    }
                    if (arc._index === 8) {
                      return {
                        text: `+${data.labels.length - 7} More`,
                        fillStyle: '#ffffff',
                        strokeStyle: '#ffffff',
                        lineWidth: bw,
                        hidden: typeof ds.data[i] !== 'number' || meta.data[i].hidden,
                        index: i,
                      };
                    }
                    return {
                      text: '',
                      fillStyle: '#ffffff',
                      strokeStyle: '#ffffff',
                      lineWidth: bw,
                      hidden: meta.data[i].hidden,
                      index: i,
                    };
                  });
                }
                return [];
              },
            },
          },
          plugins: {
            datalabels: {
              display: true,
              align: 'center',
              anchor: 'center',
              color: '#ffffff',
              font: {
                weight: 'bold',
                size: 12,
              },
              formatter: (value, context) => {
                if (value > 9999) {
                  const units = ['k', 'M', 'B', 'T'];
                  const order = Math.floor(Math.log(value) / Math.log(1000));
                  const unitname = units[order - 1];
                  const num = Math.floor(value / 1000 ** order);
                  // eslint-disable-next-line no-return-assign
                  return (context.chart.data[context.dataIndex] = num + unitname);
                }
                // eslint-disable-next-line no-return-assign
                return (context.chart.data[context.dataIndex] = value);
              },
              // eslint-disable-next-line no-dupe-keys
              display: (context) => {
                return context.dataset.data[context.dataIndex] !== 0;
              },
            },
          },
          tooltips: {
            backgroundColor: '#ffffff',
            bodyFontColor: '#384d48',
            caretSize: 5,
            borderColor: '#384d48',
            borderWidth: 1,
            cornerRadius: 2,
            xPadding: 10,
            yPadding: 10,
            bodyFontSize: 14,
            bodyFontStyle: 'bold',
            custom: (tooltip) => {
              if (!tooltip) return;
              tooltip.displayColors = false;
            },
            callbacks: {
              label: (tooltipItem, data) => {
                const percentValue = getPercentage(data, tooltipItem.index);
                const totalVal = getIndividualVal(data, tooltipItem.index);
                return `${data.labels[tooltipItem.index]} : ${totalVal} (${percentValue}%)`;
              },
              // eslint-disable-next-line no-unused-vars
              title: (tooltipItem, data) => {
                // eslint-disable-next-line no-useless-return
                return;
              },
            },
          },
          animation: {
            duration: 1,
            onComplete() {
              const { height } = this.chart;
              const { ctx } = this.chart;
              const fontSize = (height / 200).toFixed(2);
              this.chart.ctx.font = `bold ${fontSize}em Verdana`;
              ctx.textAlign = 'center';
              ctx.textBaseline = 'middle';
              ctx.fillStyle = '#384d48';
              const centerX = (this.chart.controller.chartArea.left + this.chart.controller.chartArea.right) / 2;
              const centerY = (this.chart.controller.chartArea.top + this.chart.controller.chartArea.bottom) / 2;
              ctx.fillText(
                graphData.length > 0 ? getFormatValues(graphData.reduce(getSum)) : 'No Data Available',
                centerX,
                centerY,
              );
            },
          },
        };
  if (fieldData?.graphMode === 'STACKED_BAR_GRAPH' || fieldData?.graphMode === 'STACKED_VERTICAL_GRAPH') {
    graphOptions.scales.yAxes[0].stacked = fieldData?.graphMode === 'STACKED_BAR_GRAPH';
    graphOptions.scales.xAxes[0].stacked = fieldData?.graphMode === 'STACKED_BAR_GRAPH';
    graphOptions.tooltips = {
      mode: 'x',
    };
    graphOptions.legend = {
      display: !(fieldData?.allowMultiColor),
      fontFamily: 'tahoma',
      labels: {
        fontColor: '#384d48',
        fontSize: 11,
        boxWidth: 10,
        fontStyle: 'bold',
        padding: 25,
      },
    };
  }
  if (graphType === 'line') {
    graphOptions.scales.yAxes[0].stacked = false;
    graphOptions.scales.xAxes[0].stacked = false;
    graphOptions.plugins.datalabels.display = false;
    graphOptions.tooltips = {};
  }
  return graphOptions;
};

const handleTableRowActionPermission = (refId, pId, serviceType, txnId, actionName) => {
  const businessId = getLoginBusinessId(); // Assuming you have a function to get the business ID
  const bizAccountObjPermissions = useBizAccountObjPermissions(businessId); // Assuming you have a custom hook for permissions

  if (bizAccountObjPermissions?.objPermissions[serviceType]) {
    const serviceTypePermissions = bizAccountObjPermissions?.objPermissions[serviceType];

    for (const accId in serviceTypePermissions) {
      const perspectiveObj = serviceTypePermissions[accId];

      if (perspectiveObj.perspectiveId === pId) {
        const table = txnId ? perspectiveObj.view.details.table || {} : perspectiveObj.view.create.table || {};

        if (_.includes(table[refId], actionName) || perspectiveObj.type === 'SYSTEM') {
          return true;
        }
      }
    }
  }

  return false;
};

// getting the table column width.
const getFieldClassName = (tableObj) => {
  if (tableObj && tableObj?.columnWidth) {
    return tableObj?.columnWidth;
  }
  return 'table-col-small';
};

const getTableColSize = (tableObj) => {
  switch (tableObj?.columnWidth) {
    case 'table-col-xtra-small':
      return 100;
    case 'table-col-small':
      return 200;
    case 'table-col-medium':
      return 300;
    case 'table-col-large':
      return 400;
    case 'table-col-xtra-large':
      return 600;
    default:
      return 200;
  }
};

// Function to deep clone the fields object
const cloneFields = (fields) => {
  const fieldObj = {};
  for (const key in fields) {
    fieldObj[key] = { ...fields[key] }
  }
  return fieldObj;
};

// clearing the table fields values
const clearTableFieldsValues = (serviceType, tableKey) => {
  const businessId = getLoginBusinessId();
  const serviceData = getServiceData(serviceType, businessId);
  const fieldsData = serviceData?.fields[tableKey]?.fields;
  const columnOrder = serviceData?.fields[tableKey]?.columnOrder;
  // const tableFields = serviceData?.fields[tableKey]?.sortedColumns;
  const fieldsObj = {};

  for (const columnName in columnOrder) {
    for (const key in fieldsData) {
      if (columnOrder[columnName] === key) {
        fieldsObj[key] = fieldsData[key];
        fieldsObj[key].name = key;
        switch (fieldsObj[key].type) {
          case templates.UI_TEMPLATES.SINGLE_CHOICE_UI_TEMPLATE:
            fieldsObj[key].value = fieldsObj[key]?.defaultValue > -1 ? fieldsObj[key]?.options[fieldsObj[key]?.defaultValue] : '';
            break;
          case templates.UI_TEMPLATES.CHECKBOX_UI_TEMPLATE:
          case templates.UI_TEMPLATES.MULTI_SELECT_UI_TEMPLATE:
            fieldsObj[key].value = [];
            break;
          case templates.UI_TEMPLATES.DATE_PICKER_UI_TEMPLATE:
            fieldsObj[key].value = null;
            break;
          case templates.UI_TEMPLATES.NUMBER_UI_TEMPLATE:
            fieldsObj[key].value = 0;
            break;

          default:
            if (
              fieldsObj[key].type !== templates.UI_TEMPLATES.NUMBER_UI_TEMPLATE &&
              fieldsObj[key].type !== templates.UI_TEMPLATES.CHECKBOX_UI_TEMPLATE &&
              fieldsObj[key].type !== templates.UI_TEMPLATES.MULTI_SELECT_UI_TEMPLATE &&
              fieldsObj[key].type !== templates.UI_TEMPLATES.DATE_PICKER_UI_TEMPLATE &&
              fieldsObj[key].type !== templates.UI_TEMPLATES.SINGLE_CHOICE_UI_TEMPLATE
            ) {
              fieldsObj[key].value = '';
            }
        }
      }
    }
  }
  logger.info('ADDING NEW ROW {} ', fieldsObj);
  return fieldsObj;
};

// preparing the table field data
const prepareTableFormData = (tableRows) => {
  const tempRowData = [];
  for (const i in tableRows) {
    const fields = tableRows[i]?.fields;
    // if (!tempRowData[i]) {
    tempRowData[i] = {}; // Initialize the object if it doesn't exist
    // }
    for (const key in fields) {
      const val = fields[key];
      if (val.type === templates.UI_TEMPLATES.LOOKUP_UI_TEMPLATE) {
        tempRowData[i][key] = {
          value: val?.selectedValue ? val?.selectedValue : '',
        };
      } else if (val.type === templates.UI_TEMPLATES.DATE_PICKER_UI_TEMPLATE) {
        if (!val.value || val.value === '' || val.value === 'Invalid date') {
          val.value = null;
        }
        let dateString = null;
        if (val?.dateFormat === "dd-MM-yyyy") {
          if (moment(val?.value, 'YYYY-MM-DD', true).isValid()) {
            dateString = val?.value;
          } else {
            // Step 1: Parse the date correctly using the 'DD-MM-YYYY' format
            const parsedDate = moment(val.value, 'DD-MM-YYYY', true);  // Strict mode ensures exact format match
            // Step 2: If the date is valid, convert it to 'YYYY-MM-DD' format
            if (parsedDate.isValid()) {
              dateString = parsedDate.format('YYYY-MM-DD');
              console.log('Formatted Date:', dateString);
            } else {
              console.log('Invalid date format');
            }
          }
        } else {
          dateString = val.value ? moment(val.value).format('YYYY-MM-DD') : null;
        }
        tempRowData[i][key] = {
          value: dateString,
        };
      } else if (val.type === templates.UI_TEMPLATES.NUMBER_UI_TEMPLATE) {
        if (!val.value || val.value === 0) {
          val.value = 0;
        }
        tempRowData[i][key] = {
          value: parseFloat(val.value),
        };
      } else if (val.type === templates.UI_TEMPLATES.CURRENCY_UI_TEMPLATE) {
        if (!val.value || (Array.isArray(val.value) && val.value.length === 0)) {
          val.value = 0;
        }
        tempRowData[i][key] = {
          value: parseFloat(val.value),
        };
      } else if (
        val.type === templates.UI_TEMPLATES.CHECKBOX_UI_TEMPLATE ||
        val.type === templates.UI_TEMPLATES.MULTI_SELECT_UI_TEMPLATE
      ) {
        if (!val.value || (Array.isArray(val.value) && val.value.length === 0)) {
          val.value = [];
        }
        tempRowData[i][key] = {
          value: val.value,
        };
      } else if (val.type === templates.UI_TEMPLATES.MOBILE_NUMBER_UI_TEMPLATE) {
        tempRowData[i][key] = {
          value: val?.normalNum ? val?.normalNum : '',
          code: val?.code ? val?.code : '',
        };
      } else if (val.type === templates.UI_TEMPLATES.URL_UI_TEMPLATE) {
        tempRowData[i][key] = {
          value: val?.value ? val?.value : '',
          title: val?.title ? val?.title : '',
        };
      } else if (
        val.type !== templates.UI_TEMPLATES.SECTION_UI_TEMPLATE &&
        val.type !== templates.UI_TEMPLATES.SPACER_UI_TEMPLATE &&
        val.type !== templates.UI_TEMPLATES.LINE_UI_TEMPLATE &&
        val.type !== templates.UI_TEMPLATES.WIDGET_UI_TEMPLATE &&
        val.type !== templates.UI_TEMPLATES.GRAPH_UI_TEMPLATE &&
        val.type !== templates.UI_TEMPLATES.BUTTON_UI_TEMPLATE
      ) {
        tempRowData[i][key] = {
          value: val?.value ? val?.value : '',
        };
      }
    }
  }
  return tempRowData;
};

// validation for table fields data

// preparing the fields data for post json data
const prepareTableFieldsData = (fields, tableField) => {
  // iterating the table field logic
  for (const tableKey in fields) {
    const fieldObj = fields[tableKey];

    switch (fieldObj.type) {
      case templates.UI_TEMPLATES.SINGLE_CHOICE_UI_TEMPLATE:
        if (!fieldObj.isSkippable && (fieldObj.value === '' || fieldObj.value === null || fieldObj.value === undefined)) {
          showMessageAlert(`${form.DYNAMIC_FORM.TABLE_MANDATORY} ${fieldObj.label} in ${tableField.label}`);
          return;
        }
        // eslint-disable-next-line no-case-declarations
        let tableOptionLabels = '';
        for (let i = 0; i < fieldObj?.options?.length; i++) {
          if (fieldObj.options[i] === fieldObj.value) tableOptionLabels = fieldObj.options[i];
        }
        fieldObj.optionLabel = tableOptionLabels;
        break;

      case templates.UI_TEMPLATES.EMAIL_TEXT_UI_TEMPLATE:
        if (!fieldObj.isSkippable && (fieldObj.value === '' || fieldObj.value === null)) {
          showMessageAlert(`${form.DYNAMIC_FORM.TABLE_MANDATORY} ${fieldObj.label} in ${tableField.label}`);
          return false;
        }
        if (fieldObj.value !== '' && fieldObj.value !== null && fieldObj.value !== undefined) {
          const regExp = /^(\s?[^\s,]+@[^\s,]+\.[^\s,]+\s?,)*(\s?[^\s,]+@[^\s,]+\.[^\s,]+)$/;
          const matchResult = regExp.test(fieldObj?.value);
          if (!matchResult) {
            showMessageAlert(`Please enter valid email Id(s) : ${fieldObj.label} in  ${tableField.label}`);
            return false;
          }
        }
        break;
      case templates.UI_TEMPLATES.EDIT_TEXT_UI_TEMPLATE:
        if (!fieldObj.isSkippable) {
          if (fieldObj.value === '' || !fieldObj.value) {
            showMessageAlert(`${form.DYNAMIC_FORM.TABLE_MANDATORY} ${fieldObj.label} in ${tableField.label}`);
            return false;
          }
          if (
            typeof fieldObj?.minChars !== 'undefined' &&
            typeof fieldObj?.value !== 'undefined' &&
            fieldObj?.value?.length < fieldObj?.minChars
          ) {
            showMessageAlert(`Value entered should be at least ${fieldObj.minChars} character(s) : ${fieldObj.label} in ${tableField.label}`);
            return false;
          }
          // eslint-disable-next-line no-else-return
          else if (
            typeof fieldObj?.maxChars !== 'undefined' &&
            typeof fieldObj?.value !== 'undefined' &&
            fieldObj?.value?.length > fieldObj?.maxChars
          ) {
            showMessageAlert(`Value entered should be of ${fieldObj?.maxChars} character(s): ${fieldObj?.label} in ${tableField.label}`);
            return false;
          }
        }
        break;
      case templates.UI_TEMPLATES.LOOKUP_UI_TEMPLATE:
      case templates.UI_TEMPLATES.URL_UI_TEMPLATE:
        if (!fieldObj.isSkippable && (fieldObj.value === '' || !fieldObj.value)) {
          showMessageAlert(`${form.DYNAMIC_FORM.TABLE_MANDATORY} ${fieldObj.label} in ${tableField.label}`);
          return;
        }
        break;
      case templates.UI_TEMPLATES.DATE_PICKER_UI_TEMPLATE:
        if (!fieldObj.isSkippable && (fieldObj.value === '' || fieldObj.value === null)) {
          showMessageAlert(`${form.DYNAMIC_FORM.TABLE_MANDATORY} ${fieldObj.label} in ${tableField.label}`);
          return;
        }
        // eslint-disable-next-line no-case-declarations
        let dateString = '';
        if (fieldObj?.dateFormat === "dd-MM-yyyy") {
          if (moment(fieldObj?.value, 'YYYY-MM-DD', true).isValid()) {
            dateString = fieldObj?.value;
          } else {
            // Step 1: Parse the date correctly using the 'DD-MM-YYYY' format
            const parsedDate = moment(fieldObj.value, 'DD-MM-YYYY', true);  // Strict mode ensures exact format match
            // Step 2: If the date is valid, convert it to 'YYYY-MM-DD' format
            if (parsedDate.isValid()) {
              dateString = parsedDate.format('YYYY-MM-DD');
              console.log('Formatted Date:', dateString);
            } else {
              console.log('Invalid date format');
            }
          }
        } else {
          dateString = fieldObj.value ? moment(fieldObj.value).format('YYYY-MM-DD') : '';
        }
        fieldObj.value = dateString;
        break;
      case templates.UI_TEMPLATES.MOBILE_NUMBER_UI_TEMPLATE:
        if (!fieldObj.isSkippable && (fieldObj.value === '' || fieldObj.value === null || fieldObj.value?.length === 0)) {
          showMessageAlert(`${form.DYNAMIC_FORM.TABLE_MANDATORY} ${fieldObj.label} in ${tableField.label}`);
          return;
        }
        // eslint-disable-next-line no-case-declarations
        const numstr = fieldObj.value ? fieldObj.value.toString() : '';
        fieldObj.value = numstr;
        if (fieldObj.isValid === false) {
          showMessageAlert(
            `${form.DYNAMIC_FORM.TABLE_MANDATORY} Please enter valid : ${fieldObj.label} in ${tableField.label}`,
          );
          return false;
        }
        break;
      case templates.UI_TEMPLATES.NUMBER_UI_TEMPLATE:
      case templates.UI_TEMPLATES.CURRENCY_UI_TEMPLATE:
        if (!fieldObj.isSkippable) {
          if (Number.isNaN(fieldObj.value) || fieldObj.value === '' || fieldObj.value === null || fieldObj.value === undefined) {
            showMessageAlert(`${form.DYNAMIC_FORM.MANDATORY} : ${fieldObj.label} in in ${tableField.label}`);
            return false;
          }
          if (typeof fieldObj.minDigits !== 'undefined' && fieldObj.value && fieldObj.value.toString().length < fieldObj.minDigits) {
            showMessageAlert(`Value entered should be at least : ${fieldObj.minDigits} digit(s). ${fieldObj.label} in ${tableField.label}`);
            return false;
          }
          // eslint-disable-next-line no-else-return
          if (typeof fieldObj.maxDigits !== 'undefined' && fieldObj.value && fieldObj.value.toString().length > fieldObj.maxDigits) {
            showMessageAlert(`Value entered should be ${fieldObj.maxDigits} digit(s) : ${fieldObj.label} in ${tableField.label}`);
            return false;
          }
          if (typeof fieldObj?.value === 'undefined' || fieldObj?.value === null || fieldObj?.value === '') {
            fieldObj.value = 0;
          }
        }
        if (fieldObj?.dnaNegative && fieldObj?.dnaNegative && fieldObj?.value && fieldObj?.value < 0) {
          showMessageAlert(`Negative values are not allowed : ${fieldObj.label} in ${tableField.label} `);
          return false;
        }
        break;
      case templates.UI_TEMPLATES.IMAGE_UPLOAD_UI_TEMPLATE:
        if (!fieldObj.isSkippable && (fieldObj.value === '' || fieldObj.value === null)) {
          showMessageAlert(`${form.DYNAMIC_FORM.TABLE_MANDATORY} ${fieldObj.label} in ${tableField.label}`);
          return false;
        }
        break;

      case templates.UI_TEMPLATES.CHECKBOX_UI_TEMPLATE:
        if (
          !fieldObj.isSkippable &&
          (fieldObj.value === '' || fieldObj.value === null || fieldObj?.value?.length === 0 || fieldObj.value === undefined)
        ) {
          showMessageAlert(`${form.DYNAMIC_FORM.TABLE_MANDATORY} ${fieldObj.label} in ${tableField.label}`);
          return;
        }
        fieldObj.value = fieldObj.value === '' || fieldObj.value === null ? [] : fieldObj.value;
        break;

      case templates.UI_TEMPLATES.MULTI_SELECT_UI_TEMPLATE:

        if (fieldObj?.notShowFieldValues && (fieldObj?.enableAttachment || fieldObj?.enableComment)) {
          const optionsKey = getTableFieldName(tableField?.checklistFields?.options?.refId, fields);
          const labelKey = getTableFieldName(tableField?.checklistFields?.label?.refId, fields);
          // comments realted functionality
          if (tableField?.checklistFields?.comments?.refId === fieldObj?.refId) {
            const commentsKey = getTableFieldName(tableField?.checklistFields?.comments?.refId, fields);
            const commentRequiredKey = getTableFieldName(tableField?.checklistFields?.commentRequired?.refId, fields);
            const isCommentRequired = fields[commentRequiredKey]?.value?.includes(fields[optionsKey]?.value) || false;
            if (isCommentRequired && fields[commentsKey].value?.length === 0) {
              showMessageAlert(`Please add atleast one comment to : ${fields[labelKey]?.value}`);
              return false;
            }
          }
          // attachments realted functionality
          if (tableField?.checklistFields?.images?.refId === fieldObj?.refId) {
            const imagesKey = getTableFieldName(tableField?.checklistFields?.images?.refId, fields);
            const imageRequiredKey = getTableFieldName(tableField?.checklistFields?.imageRequired?.refId, fields);
            const isImageRequiredKey = fields[imageRequiredKey]?.value?.includes(fields[optionsKey]?.value) || false;
            if (isImageRequiredKey && fields[imagesKey].value?.length === 0) {
              showMessageAlert(`Please add atleast one attachment to : ${fields[labelKey]?.value}`);
              return false;
            }
          }
        }
        // eslint-disable-next-line no-case-declarations
        const tableOptionLabel = [];
        for (const i in fieldObj.value) {
          for (let j = 0; j < fieldObj?.options?.length; j++) {
            if (fieldObj.options[j] === fieldObj.value[i]) tableOptionLabel.push(fieldObj.options[j]);
          }
        }
        fieldObj.optionLabel = tableOptionLabel;
        fieldObj.value = fieldObj.value === '' ? [] : fieldObj.value;
        if (!fieldObj.isSkippable && (fieldObj.value === '' || fieldObj.value === null || fieldObj.value?.length === 0)) {
          showMessageAlert(`${form.DYNAMIC_FORM.TABLE_MANDATORY} ${fieldObj.label} in ${tableField.label}`);
          return;
        }
        break;
    }
    fields[tableKey] = fieldObj;
  }

  return fields;
};

// updating main form data.
const updateTxnFormData = async (fieldConfiguration, serviceData) => {
  for (const key in fieldConfiguration) {
    if (fieldConfiguration[key])
      if (fieldConfiguration[key]?.type !== templates?.UI_TEMPLATES?.TABLE_UI_TEMPLATE && fieldConfiguration[key]?.type !== templates?.UI_TEMPLATES?.SUB_FORM_UI_TEMPLATE) {
        if (window.updateStateFromUtility) window.updateStateFromUtility(fieldConfiguration[key], true);
      }
  }
}

// table row data, row field type, table refId, table rows, row field columnFieldId, data
const scriptLogicForTableRow = (
  row,
  type,
  refId,
  rows,
  columnFieldId,
  data,
  serviceData,
  fieldConfigurations,
  scriptLogicWrapper,
) => {
  if (serviceData?.scripts) {
    try {
      switch (type) {
        case templates.UI_TEMPLATES.EDIT_TEXT_UI_TEMPLATE:
        case templates.UI_TEMPLATES.MOBILE_NUMBER_UI_TEMPLATE:
        case templates.UI_TEMPLATES.NUMBER_UI_TEMPLATE:
        case templates.UI_TEMPLATES.EMAIL_TEXT_UI_TEMPLATE:
        case templates.UI_TEMPLATES.RADIO_BUTTON_UI_TEMPLATE:
        case templates.UI_TEMPLATES.SINGLE_CHOICE_UI_TEMPLATE:
        case templates.UI_TEMPLATES.CURRENCY_UI_TEMPLATE:
        case templates.UI_TEMPLATES.DATE_PICKER_UI_TEMPLATE:
        case templates.UI_TEMPLATES.LOOKUP_UI_TEMPLATE:
        case templates.UI_TEMPLATES.MULTI_SELECT_UI_TEMPLATE:
        case templates.UI_TEMPLATES.CHECKBOX_UI_TEMPLATE:
          serviceData?.scripts?.forEach((script) => {
            if (script.fid === refId && script.columnFieldId === columnFieldId) {
              const f_name = `${script.fid}_ON_USER_INPUT_${script.columnFieldId}`;
              if (typeof window[f_name] === 'function') {
                if (data) {
                  window[f_name](fieldConfigurations, row, rows, data, scriptLogicWrapper);
                }
                else if (type === templates.UI_TEMPLATES.LOOKUP_UI_TEMPLATE) {
                  window[f_name](fieldConfigurations, row, rows, undefined, scriptLogicWrapper);
                } else {
                  window[f_name](fieldConfigurations, row, rows, scriptLogicWrapper);
                }
              }
            }
          });

          break;

        case 'ROW_DELETE':
          serviceData?.scripts?.forEach((script) => {
            if (script.fid === refId) {
              const f_name = `${script.fid}_ON_DELETE_ROW`;
              if (typeof window[f_name] === 'function') {
                // if (data) window[f_name](fieldConfigurations, {}, rows, data, scriptLogicWrapper);
                window[f_name](fieldConfigurations, {}, rows, scriptLogicWrapper);
              }
            }
          });
          break;
        case 'ROW_ADD':
          serviceData?.scripts?.forEach((script) => {
            if (script.fid === refId && script?.action?.includes("ON_ADD_ROW")) {
              const f_name = `${script.fid}_ON_ADD_ROW`;
              if (typeof window[f_name] === 'function') {
                // if (data) window[f_name](fieldConfigurations, row, rows, data, scriptLogicWrapper);
                window[f_name](fieldConfigurations, row, rows, scriptLogicWrapper);
              }
            }
          });
          break;

        case 'ROW_UPDATE':
          serviceData?.scripts?.forEach((script) => {
            if (script.fid === refId && script?.action?.includes("ON_UPDATE_ROW")) {
              const f_name = `${script.fid}_ON_UPDATE_ROW`;
              if (typeof window[f_name] === 'function') {
                // if (data) window[f_name](fieldConfigurations, row, rows, data, scriptLogicWrapper);
                window[f_name](fieldConfigurations, row, rows, scriptLogicWrapper);
              }
            }
          });
          break;
      }
      // need to check if main form is not updated through script logic.
      setTimeout(() => {
        updateTxnFormData(fieldConfigurations, serviceData);
      }, 500);
    } catch (error) {
      logger.error(error);
    }
  }
};

// =============================== TABLE COPY FUNCTIONALITY ==================================
const strRep = (data) => {
  if (typeof data === 'string') {
    const newData = data.replace(/,/g, ' ');
    return newData;
  } else if (typeof data === 'undefined') {
    return '';
  } else if (typeof data === 'number') {
    return data.toString();
  } else {
    return data;
  }
};

const ConvertToCSV = (objArray, headerList, headerCol) => {
  let str = '';
  let row = '';
  const newHeaders = [...headerCol];

  for (const index in newHeaders) {
    row += `${newHeaders[index]}\t`;
  }
  row = row.slice(0, -1);
  str += `${row}\r\n`;

  for (let i = 0; i < objArray.length; i++) {
    let line = '';
    for (const index in headerList) {
      const head = headerList[index];
      line += `${strRep(objArray[i][head])}\t`;
    }
    str += `${line}\r\n`;
  }

  return str;
};

const exportTableData = (tableFieldData, tableRows) => {
  const headerCol = [];
  const headers = [];
  for (const tableKey in tableFieldData.fields) {
    if (tableFieldData.fields.hasOwnProperty(tableKey)) {
      const tableObj = tableFieldData.fields[tableKey];
      headerCol.push(tableObj.label);
      headers.push(tableKey);
    }
  }
  const tableData = [];
  tableRows.forEach((tableRowObj) => {
    const obj = {};
    Object.keys(tableRowObj.fields).forEach((fieldKey) => {
      const fieldObj = tableRowObj.fields[fieldKey];
      if (fieldObj.type === 'lookupUiTemplate') {
        obj[fieldKey] = fieldObj.value.value;
      } else if (fieldObj.type === 'imageUploadUiTemplate') {
        obj[fieldKey] = '';
      } else {
        obj[fieldKey] = fieldObj.value;
      }
    });

    tableData.push(obj);
  });
  const csvData = ConvertToCSV(tableData, headers, headerCol);
  logger.info('CSV DATA {} ', csvData);
  const copyElement = document.createElement('textarea');
  copyElement.style.position = 'fixed';
  copyElement.style.opacity = '0';
  copyElement.textContent = csvData;
  const body = document.getElementsByTagName('body')[0];
  body.appendChild(copyElement);
  copyElement.select();
  document.execCommand('copy');
  body.removeChild(copyElement);
  showSuccesMessageAlert('Copied !');
};

const parseCSV = (str) => {
  const arr = [];
  let quote = false;
  let row = 0;
  let col = 0;
  for (let c = 0; c < str?.length; c++) {
    const cc = str[c];
    const nc = str[c + 1];

    arr[row] = arr[row] || [];
    arr[row][col] = arr[row][col] || '';

    if (cc === '"' && quote && nc === '"') {
      arr[row][col] += cc;
      c++;
      continue;
    }

    if (cc === '"') {
      quote = !quote;
      continue;
    }

    if (cc === ',' && !quote) {
      col++;
      continue;
    }

    if (cc === '\n' && !quote) {
      row++;
      col = 0;
      continue;
    }

    arr[row][col] += cc;
  }
  return arr;
};

// clearing the table fields values
const fieldColumnOrderApply = (fieldsData, columnOrder, txnId) => {
  const fieldsObj = {};
  for (const columnName in columnOrder) {
    for (const key in fieldsData) {
      if (columnOrder[columnName] === key) {
        // assigng below key for script logic purpose only.
        if (fieldsData[key]?.type === templates?.UI_TEMPLATES?.TABLE_UI_TEMPLATE) {
          fieldsData[key].isFromScriptLogic = false;
          fieldsData[key].isBulkRowsCreate = false;
          if (txnId === '' || txnId === undefined) {
            fieldsData[key].tableRows = [];
            fieldsData[key].originalTableRows = [];
          }
        }
        if (fieldsData[key]?.type === templates?.UI_TEMPLATES?.LOOKUP_UI_TEMPLATE) {
          if (txnId === '' || txnId === undefined) {
            fieldsData[key].value = '';
            fieldsData[key].selectedValue = '';
          }
        }
        // updating field kay for document view analysis fields data.
        if (txnId && txnId !== '' && txnId !== undefined && fieldsData[key]?.type === templates?.UI_TEMPLATES?.DOCUMENT_ANALYSIS_UI_TEMPLATE) {
          const fieldsOrderArray = [];
          const editFieldsArray = [];
          const mainFormFields = fieldsData;
          fieldsData[key].fieldsOrder = [];

            // iterating the fields data to get the keys based on the refId's.
            for (const index in fieldsData[key]?.fields) {
              for (const fieldOrderKeys in mainFormFields) {
                // checking documents fields refId with main form refId's.
                if (fieldsData[key]?.fields[index] === mainFormFields[fieldOrderKeys]?.refId) {
                  fieldsOrderArray.push(mainFormFields[fieldOrderKeys]?.name);
                }
              }
            }

          // main form fields iteration.
          for (const fieldOrderKey in mainFormFields) {
            // iterating the edit fields data to get the keys based on the refId's.
            for (const editIndex in fieldsData[key]?.editFields) {
              // checking documents fields refId with main form refId's.
              if (fieldsData[key]?.editFields[editIndex] === mainFormFields[fieldOrderKey]?.refId) {
                editFieldsArray.push(mainFormFields[fieldOrderKey]?.name);
              }
            }

            // updating field kay for progress field.
            if (fieldsData[key]?.progressField === mainFormFields[fieldOrderKey]?.refId) {
              fieldsData[key].progressField = mainFormFields[fieldOrderKey]?.name;
            }
            // updating field kay for status field.
            if (fieldsData[key]?.statusField === mainFormFields[fieldOrderKey]?.refId) {
              fieldsData[key].statusField = mainFormFields[fieldOrderKey]?.name;
            }
          }
          fieldsData[key].fieldsOrder = fieldsOrderArray;
          fieldsData[key].editFields = editFieldsArray;
        }

        fieldsObj[key] = fieldsData[key];
      }
    }
  }
  return fieldsObj;
};

// number field validation.
const numberFieldValidations = (fieldData) => {
  let numberRules;
  if (
    !fieldData?.isSkippable &&
    (fieldData?.value === '' ||
      fieldData?.value === null ||
      fieldData?.value === undefined ||
      Number.isNaN(fieldData?.value))
  ) {
    numberRules = `${form.DYNAMIC_FORM.MANDATORY} : ${fieldData?.label}`;
  }
  if (fieldData?.value) {
    if (fieldData?.value?.toString()?.length < fieldData?.minDigits) {
      numberRules = `${form.DYNAMIC_FORM.PLEASE_PROVIDE} ${fieldData?.minDigits} ${form.DYNAMIC_FORM.DIGITS} : ${fieldData?.label}`;
    }
    if (fieldData?.value?.toString()?.length > fieldData?.maxDigits) {
      numberRules = `${form.DYNAMIC_FORM.SHOULD_NOT} ${fieldData?.maxDigits} ${form.DYNAMIC_FORM.DIGITS} : ${fieldData?.label}`;
    }
  }
  return numberRules;
};

// text field validations.
// Define a global function to get validation rules based on the input field properties.
const textFieldValidations = (fieldData) => {
  let textRules;
  // if (
  //   !fieldData?.isSkippable &&
  //   (fieldData?.value === '' ||
  //     fieldData?.value === null ||
  //     fieldData?.value === undefined ||
  //     fieldData?.value?.length === 0)
  // ) {
  //   textRules = `${form.DYNAMIC_FORM.MANDATORY} : ${fieldData?.label}`;
  // }

  if (fieldData?.type === templates.UI_TEMPLATES.ENCRYPT_UI_TEMPLATE) {

    if (fieldData?.maskedValue) {
      if (fieldData?.maskedValue?.length < fieldData?.minChars) {
        textRules = `${form.DYNAMIC_FORM.PLEASE_ENTER} ${fieldData?.minChars} ${form.DYNAMIC_FORM.CHARACTERS} : ${fieldData?.label}`;
      }
      if (fieldData?.maskedValue?.length > fieldData?.maxChars) {
        textRules = `${form.DYNAMIC_FORM.SHOULD_NOT} ${fieldData?.maxChars} ${form.DYNAMIC_FORM.CHARACTERS} : ${fieldData?.label}`;
      }
    } else if (fieldData?.value) {
      if (fieldData?.value?.length < fieldData?.minChars) {
        textRules = `${form.DYNAMIC_FORM.PLEASE_ENTER} ${fieldData?.minChars} ${form.DYNAMIC_FORM.CHARACTERS} : ${fieldData?.label}`;
      }
      if (fieldData?.value?.length > fieldData?.maxChars) {
        textRules = `${form.DYNAMIC_FORM.SHOULD_NOT} ${fieldData?.maxChars} ${form.DYNAMIC_FORM.CHARACTERS} : ${fieldData?.label}`;
      }
    }
  } else if (fieldData?.value) {
    if (fieldData?.value?.length < fieldData?.minChars) {
      textRules = `${form.DYNAMIC_FORM.PLEASE_ENTER} ${fieldData?.minChars} ${form.DYNAMIC_FORM.CHARACTERS} : ${fieldData?.label}`;
    }
    if (fieldData?.value?.length > fieldData?.maxChars) {
      textRules = `${form.DYNAMIC_FORM.SHOULD_NOT} ${fieldData?.maxChars} ${form.DYNAMIC_FORM.CHARACTERS} : ${fieldData?.label}`;
    }
  }


  return textRules;
};

// email validation
const emailFieldValidations = (fieldData) => {
  let emailValidationRules;
  // Regular expression to check if the value is a valid email
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (fieldData?.allowCsv) {
    // Custom validation function for comma-separated emails
    const regExp = /^(\s?[^\s,]+@[^\s,]+\.[^\s,]+\s?,)*(\s?[^\s,]+@[^\s,]+\.[^\s,]+)$/;
    // if (
    //   !fieldData?.isSkippable &&
    //   (fieldData?.value === '' || fieldData?.value === null || fieldData?.value === undefined)
    // ) {
    //   emailValidationRules = `${form.DYNAMIC_FORM.MANDATORY} : ${fieldData?.label}`;
    // }
    if (fieldData?.value && !regExp.test(fieldData?.value)) {
      emailValidationRules = `${form.DYNAMIC_FORM.EMAIL_VALIDATION_MSG} : ${fieldData?.label}`;
    }
    // if (!fieldData?.isSkippable && fieldData?.value && !regExp.test(fieldData?.value)) {
    //   emailValidationRules = `${form.DYNAMIC_FORM.EMAIL_VALIDATION_MSG} : ${fieldData?.label}`;
    // }
  } else if (fieldData?.value && !emailRegex.test(fieldData?.value)) {
    emailValidationRules = `${form.DYNAMIC_FORM.EMAIL_VALIDATION_MSG} : ${fieldData?.label}`;
    // if (
    //   !fieldData?.isSkippable &&
    //   (fieldData?.value === '' || fieldData?.value === null || fieldData?.value === undefined)
    // ) {
    //   emailValidationRules = `${form.DYNAMIC_FORM.MANDATORY} : ${fieldData?.label}`;
    // }
  }
  return emailValidationRules;
};

// ============================================== SUBFORM SCRIPT LOGIC ================================
// formula field on change function
const subFormFormlaFieldOnChangeCall = (funcs, fieldsData) => {
  funcs.forEach((func) => {
    if (typeof window[func] === 'function') {
      window[func](fieldsData); // Assuming fieldConfigurations is defined in your component
    }
  });
};

const subFormFormulaActionScriptFun = (formFields, serviceData, callBackFun) => {
  logger.info('Entered in subFormFormulaActionScriptFun');

  if (
    serviceData?.formulaScript &&
    typeof serviceData?.formulaScript === 'object' &&
    Object.keys(serviceData?.formulaScript)?.length > 0
  ) {
    Object.entries(serviceData?.formulaScript).forEach(([fun_name, func]) => {
      logger.debug(func);
      window[fun_name] = parseFunction(func);
    });

    if (!Array.isArray(formFields)) {
      logger.error('formFields is not an array');
      if (typeof callBackFun === 'function') callBackFun();
      return;
    }

    formFields?.forEach((fieldObj) => {
      if (fieldObj && fieldObj.formulaFuncs && fieldObj.value !== null && fieldObj.value !== '') {
        subFormFormlaFieldOnChangeCall(fieldObj.formulaFuncs, formFields);
      }

      if (fieldObj && fieldObj.formulaFuncs && fieldObj.type === templates.UI_TEMPLATES.FORMULA_UI_TEMPLATE) {
        const [oldValue, setOldValue] = useState(fieldObj.value);
        useEffect(() => {
          if (fieldObj.value !== oldValue) {
            subFormFormlaFieldOnChangeCall(fieldObj.formulaFuncs, formFields);
            setOldValue(fieldObj.value);
          }
        }, [fieldObj.value, oldValue, subFormFormlaFieldOnChangeCall]);
      }
    });

    if (typeof callBackFun === 'function') callBackFun();
  } else if (typeof callBackFun === 'function') callBackFun();
};

const subFormScriptLogicExecute = (formName, formFields, scripts, scriptLogicWrapper) => {
  logger.info('Entered in  subform actionScriptExecute');
  if (scripts) {
    scripts.forEach((script) => {
      // eslint-disable-next-line camelcase
      let f_name = '';
      if (script.action === 'ON_FORM_LOAD' || script.action === 'ON_FORM_SUBMIT') {
        // eslint-disable-next-line camelcase
        f_name = `f_script_${formName}_${script.action}`;
      } else {
        // eslint-disable-next-line camelcase
        f_name = `${script.fid}_${script.action}`;
      }
      // eslint-disable-next-line camelcase
      if (script.columnFieldId) f_name = `${f_name}_${script.columnFieldId}`;
      const params = `${script.args.toString()}, app_lib`;
      if (script.action === 'ON_FORM_SUBMIT') {
        window[f_name] = new AsyncFunction(params, script.body);
      } else {
        // eslint-disable-next-line no-new-func, camelcase
        window[f_name] = new Function(params, script.body);
      }
      // eslint-disable-next-line camelcase
      logger.debug(window[f_name]);

      if (script.action === 'ON_FORM_LOAD') {
        // eslint-disable-next-line camelcase
        window[f_name](formFields, scriptLogicWrapper);
      }
    });
  }
};

// on field change script logic executing
const subFormScriptLogicOnChangeFun = (subFormId, type, refId, serviceData, subFormFields, scriptLogicWrapper) => {
  if (serviceData.sfScripts && serviceData.sfScripts.length > 0) {
    const findScript = _.find(serviceData.sfScripts, { refId: subFormId });
    if (findScript) {
      switch (type) {
        case templates.UI_TEMPLATES.EDIT_TEXT_UI_TEMPLATE:
        case templates.UI_TEMPLATES.MOBILE_NUMBER_UI_TEMPLATE:
        case templates.UI_TEMPLATES.NUMBER_UI_TEMPLATE:
        case templates.UI_TEMPLATES.EMAIL_TEXT_UI_TEMPLATE:
        case templates.UI_TEMPLATES.RADIO_BUTTON_UI_TEMPLATE:
        case templates.UI_TEMPLATES.SINGLE_CHOICE_UI_TEMPLATE:
        case templates.UI_TEMPLATES.MULTI_SELECT_UI_TEMPLATE:
        case templates.UI_TEMPLATES.CURRENCY_UI_TEMPLATE:
        case templates.UI_TEMPLATES.LOOKUP_UI_TEMPLATE:
        case templates.UI_TEMPLATES.DATE_PICKER_UI_TEMPLATE:
        case templates.UI_TEMPLATES.LOCATION_UI_TEMPLATE:
        case templates.UI_TEMPLATES.CHECKBOX_UI_TEMPLATE:
        case templates.UI_TEMPLATES.SECTION_UI_TEMPLATE:
        case templates.UI_TEMPLATES.BUTTON_UI_TEMPLATE:
          findScript.scripts.forEach((script) => {
            if (script.fid === refId) {
              // eslint-disable-next-line camelcase
              const f_name = `${script.fid}_${script.action}`;
              logger.debug(f_name);
              logger.debug(subFormFields);
              // eslint-disable-next-line camelcase
              if (window[f_name]) {
                // eslint-disable-next-line camelcase
                window[f_name](subFormFields, scriptLogicWrapper);
              }
            }
          });
          break;
        // return fieldConfiguration;
      }
    }
  }
};

// ============================================== END SUBFORM SCRIPT LOGIC ================================
const initializeScriptWrapperFun = (subformId, scriptLogicWrapper) => {
  scriptLogicWrapper.setCommentsAndAttachmentsFun(getCommentAndAttachmentsCount);
  scriptLogicWrapper.subFormFuns(subformId);
};

const replaceUnderscoresWithSpaces = (value) => {
  return value.replace(/_/g, ' ');
};

// ================================== TABLE RELATED APP LIB FUNCTIONS ================================
const findLookupTxnData = async (txnId, callback) => {
  try {
    if (txnId !== '' && txnId !== null && txnId !== undefined) {
      const loginUserData = getLoginRes();
      $.ajax({
        type: "GET",
        async: false,
        url: `${ApiService.baseURL}/${ApiLibrary?.V2?.TXN_DETAILS}/${txnId}`,
        headers: {
          'Content-type': 'application/json',
          Authorization: `Bearer ${loginUserData?.access_token}`,
        },
        dataType: "json",
        success(response) {
          const res = response;
          if (res.statusCode === 0) {
            if (res.data) {
              return res?.data;
            }
          } else {
            showWarningMessageAlert(res?.statusMessage);
          }
        }
      });
    }
  } catch (error) {
    // Handle error here
    logger.error('An error occurred:', error);
  }
};

// add new row functionality every row data added from the csv data
// tableName, tableFields, table.columnOrder, table.tableMaxRows, fieldConfigurations
const addTableNewRow = (key, tableFields, columnOrder, tableMaxRows, columnsData, fieldConfigurations, rowIndex) => {
  if (fieldConfigurations[key]?.tableRows?.length >= tableMaxRows) {
    showWarningMessageAlert(`Not allowed more than ${tableMaxRows}`);
    return;
  }
  const fields = tableFields;
  fieldConfigurations[key].tablesFieldsObj = [];

  for (const fieldKey in fields) {
    const fieldObj = fields[fieldKey];
    switch (fieldObj.type) {
      case templates.UI_TEMPLATES.EDIT_TEXT_UI_TEMPLATE:
        fieldObj.value = columnsData[rowIndex]?.fields[fieldKey]?.value;
        break;

      case templates.UI_TEMPLATES.MOBILE_NUMBER_UI_TEMPLATE:
        fieldObj.value = columnsData[rowIndex]?.fields[fieldKey]?.value;
        break;

      case templates.UI_TEMPLATES.NUMBER_UI_TEMPLATE:
        if (
          columnsData[rowIndex]?.fields[fieldKey]?.value === undefined ||
          columnsData[rowIndex]?.fields[fieldKey]?.value === '' ||
          columnsData[rowIndex]?.fields[fieldKey]?.value === null ||
          Number.isNaN(columnsData[rowIndex]?.fields[fieldKey]?.value)
        ) {
          fieldObj.value = 0;
        } else {
          fieldObj.value = columnsData[rowIndex]?.fields[fieldKey]?.value;
        }
        break;

      case templates.UI_TEMPLATES.EMAIL_TEXT_UI_TEMPLATE:
        fieldObj.value = columnsData[rowIndex]?.fields[fieldKey]?.value;
        break;

      case templates.UI_TEMPLATES.SINGLE_CHOICE_UI_TEMPLATE:
        fieldObj.value = columnsData[rowIndex]?.fields[fieldKey]?.value;
        break;
      case templates.UI_TEMPLATES.DATE_PICKER_UI_TEMPLATE:
        // eslint-disable-next-line no-case-declarations
        const dateString = columnsData[rowIndex]?.fields[fieldKey]?.value
          ? moment(columnsData[rowIndex]?.fields[fieldKey]?.value).format('DD-MMM-YYYY')
          : '';
        fieldObj.value = dateString;
        break;
    }
  }
  const index =
    (fieldConfigurations[key]?.tableRows?.length || 0) + (fieldConfigurations[key]?.tablesFieldsObj?.length || 0);
  if (fieldConfigurations[key]?.isCatolougeMode) {
    const rowObj = {
      fields,
      id: index + 1,
      isRowEdit: true,
      isRowDelete: false,
      isSearch: true,
      catelougeMode: 'NEW',
      index: index + 1,
    };
    fieldConfigurations[key].tablesFieldsObj.push(rowObj);
    if (fieldConfigurations[key]?.tableRows !== undefined && fieldConfigurations[key]?.tableRows?.length > 0) {
      fieldConfigurations[key]?.tableRows.push(rowObj);
    } else {
      fieldConfigurations[key].tableRows = [];
      fieldConfigurations[key]?.tableRows.push(rowObj);
    }
  } else {
    const rowObj = { fields, id: index + 1, isRowEdit: true, isRowDelete: false, isSearch: true, lookup: columnsData[rowIndex]?.lookup };
    if (columnsData[rowIndex]?.lookup) {
      rowObj.lookup = columnsData[rowIndex]?.lookup;
    }
    fieldConfigurations[key].tablesFieldsObj.push(rowObj);
    if (fieldConfigurations[key]?.tableRows !== undefined && fieldConfigurations[key]?.tableRows?.length > 0) {
      fieldConfigurations[key]?.tableRows.push(rowObj);
    } else {
      fieldConfigurations[key].tableRows = [];
      fieldConfigurations[key]?.tableRows.push(rowObj);
    }
    fieldConfigurations[key].originalTableRows = fieldConfigurations[key]?.tableRows;
  }
  logger.debug('UPDATED TABLE OBJ ========== ', fieldConfigurations[key]?.tableRows);
};

// add table new row function.
const addTableRowsFun = (table, tableName, rows, fieldConfigurations, isSink, serviceType) => {
  const businessId = getLoginBusinessId();
  const modifiedRows = [];
  let index = 0;
  if (rows.length > 0) {
    rows.forEach((rowObj) => {
      const newRowFieldsData = clearTableFieldsValues(serviceType, tableName);
      const tableFields = cloneFields(newRowFieldsData);
      Object.keys(tableFields).forEach(async (key) => {
        const obj = tableFields[key];
        if (rowObj?.fields[key]) {
          switch (obj.type) {
            case templates.UI_TEMPLATES.MOBILE_NUMBER_UI_TEMPLATE:
              obj.code = rowObj.fields[key].code;
              obj.value = rowObj.fields[key].value;
              tableFields[key] = obj;
              break;
            case templates.UI_TEMPLATES.LOCATION_UI_TEMPLATE:
              obj.coordinates = rowObj.fields[key].coordinates;
              obj.value = rowObj.fields[key].value;
              tableFields[key] = obj;
              break;
            case templates.UI_TEMPLATES.LOOKUP_UI_TEMPLATE:
              // if (!rowObj.lookup) {
                try {
                  if (rowObj.fields[key].value !== '' && rowObj.fields[key].value !== null && rowObj.fields[key].value !== undefined) {
                    const loginUserData = getLoginRes();
                    $.ajax({
                      type: "GET",
                      async: false,
                      url: `${ApiService.baseURL}/${ApiLibrary?.V2?.TXN_DETAILS}/${rowObj.fields[key].value}`,
                      headers: {
                        'Content-type': 'application/json',
                        Authorization: `Bearer ${loginUserData?.access_token}`,
                      },
                      dataType: "json",
                      success(response) {
                        const res = response;
                        if (res.statusCode === 0) {
                          if (res.data) {
                            if (!rowObj?.lookup) {
                              rowObj.lookup = {};
                              rowObj.lookup[rowObj?.fields[key]?.value] = {};
                              rowObj.lookup[rowObj?.fields[key]?.value].fields = res?.data?.fields;
                            };
                            obj.options = [];
                            processOptions(
                              [response?.data],
                              obj?.lookupType,
                              obj?.displayFields,
                              businessId,
                              obj,
                            );
                            const previousSelectedLookupData = getSelectedLookupFormData();
                            const lookupDataObj = {};
                            lookupDataObj.id = rowObj?.fields[key]?.value;
                            lookupDataObj.value = obj?.options[0];
                            const updateSelectedLookupData = { ...previousSelectedLookupData, [rowObj?.fields[key]?.value]: lookupDataObj };
                            setSelectedLookupFormData(updateSelectedLookupData);
                            const lookuptypeService = getServiceData(obj.lookupType, businessId);
                            let selectedValues = [];
                            const filedsObj = {};
                            filedsObj.fields = res?.data?.fields;
                            selectedValues = getLookupDisplayFieldsValueArray(
                              filedsObj,
                              obj.displayFields,
                              lookuptypeService,
                              businessId,
                            );
                            obj.value = { id: rowObj.fields[key].value, value: selectedValues.join(' ') };
                            obj.selectedValue = rowObj.fields[key].value;
                          }
                        } else {
                          showWarningMessageAlert(res?.statusMessage);
                        }
                      }
                    });
                  }
                } catch (error) {
                  // Handle error here
                  logger.error('An error occurred:', error);
                }
                tableFields[key] = obj;
              // }
              break;
            default:
              obj.value = rowObj.fields[key].value;
              tableFields[key] = obj;
              break;
          }
        }
      });
      if (isSink) {
        const obj = { fields: tableFields };
        modifiedRows.push(obj);
      } else {
        addTableNewRow(tableName, tableFields, table.columnOrder, table.tableMaxRows, rows, fieldConfigurations, index);
      }
      index++;
    });
  }
  // else {
  //   rows.forEach((rowObj) => {
  //     const newRowFieldsData = clearTableFieldsValues(serviceType, tableName);
  //     const tableFields = cloneFields(newRowFieldsData);
  //     Object.keys(tableFields).forEach((key) => {
  //       const obj = tableFields[key];
  //       if (rowObj.fields[key]) {
  //         switch (obj.type) {
  //           case templates.UI_TEMPLATES.MOBILE_NUMBER_UI_TEMPLATE:
  //             obj.code = rowObj.fields[key].code;
  //             obj.value = rowObj.fields[key].value;
  //             tableFields[key] = obj;
  //             break;
  //           case templates.UI_TEMPLATES.LOCATION_UI_TEMPLATE:
  //             obj.coordinates = rowObj.fields[key].coordinates;
  //             obj.value = rowObj.fields[key].value;
  //             break;
  //           case templates.UI_TEMPLATES.LOOKUP_UI_TEMPLATE:
  //             // eslint-disable-next-line no-case-declarations
  //             const existedValue = rowObj.fields[key].value;
  //             if (rowObj.lookup && existedValue) {
  //               const existedFieldsById = rowObj.lookup[existedValue] || {};
  //               const lookuptypeService = getServiceData(obj.lookupType, businessId);
  //               let selectedValues = [];
  //               selectedValues = getLookupDisplayFieldsValueArray(
  //                 existedFieldsById,
  //                 obj.displayFields,
  //                 lookuptypeService,
  //                 businessId,
  //               );
  //               obj.value = { id: rowObj.fields[key].value, value: selectedValues.join(' ') };
  //               obj.selectedValue = rowObj.fields[key].value;
  //               tableFields[key] = obj;
  //             }
  //             break;
  //           default:
  //             obj.value = rowObj.fields[key].value;
  //             tableFields[key] = obj;
  //             break;
  //         }
  //       }
  //     });
  //     if (isSink) {
  //       const obj = { fields: tableFields };
  //       modifiedRows.push(obj);
  //     } else
  //       addTableNewRow(tableName, tableFields, table.columnOrder, table.tableMaxRows, rows, fieldConfigurations, index);
  //     index++;
  //   });
  // }
  if (isSink) return modifiedRows;
};

// getting the table rows data by table id.
async function fetchTableRowsData(fieldConfigurations, tableName, txnId) {
  try {
    if (txnId) {
      const response = await getTableRowsById(txnId, fieldConfigurations[tableName]?.refId);
      if (response?.data?.statusCode === 0) {
        if (response?.data?.data !== undefined && response?.data?.data) {
          let tableRowOrderData = [];
          tableRowOrderData = response?.data?.data;
          fieldConfigurations[tableName].tableRows = tableRowOrderData?.map((row) => {
            row.isSearch = true;
            // Create a copy of the row without the fields.__refOptions__ property
            const {
              fields: { __refOptions__, ...fields },
              ...rest
            } = row;
            // Add the isRowEdit property
            return {
              ...rest,
              fields,
              isRowEdit: false,
              isRowDelete: false,
              catelougeMode: 'UPDATE',
            };
          });
          if (window.updateStateFromUtility) window.updateStateFromUtility(fieldConfigurations[tableName]);
        } else if (window.updateStateFromUtility) window.updateStateFromUtility(fieldConfigurations[tableName])
      } else {
        logger.error('error');
        if (window.updateStateFromUtility) window.updateStateFromUtility(fieldConfigurations[tableName]);
      }
    }
  } catch (error) {
    logger.error('Error fetching table rows data:', error);
  }
}

// adding bulk table rows
const bulkTableRowsCreate = async (tableName, rows, fieldConfigurations, txnData, serviceType) => {
  const accessId = getPaccessId();
  const postJson = {
    refTableId: fieldConfigurations[tableName]?.refId,
    refType: serviceType,
    refId: txnData?.id,
    pAccId: accessId,
    txnId: txnData?.txnId,
    rows: [],
  };
  rows.forEach((rowObj) => {
    const obj = {};
    Object.keys(rowObj?.fields).forEach((eachKey) => {
      obj[eachKey] = {};

      switch (rowObj?.fields[eachKey].type) {
        case templates.UI_TEMPLATES.MOBILE_NUMBER_UI_TEMPLATE:
          obj[eachKey].code = rowObj?.fields[eachKey].code;
          obj[eachKey].value = rowObj?.fields[eachKey].value;
          break;
        case templates.UI_TEMPLATES.LOCATION_UI_TEMPLATE:
          obj[eachKey].coordinates = rowObj?.fields[eachKey].coordinates;
          obj[eachKey].value = rowObj?.fields[eachKey].value;
          break;
        case templates.UI_TEMPLATES.LOOKUP_UI_TEMPLATE:
          obj[eachKey].value = rowObj?.fields[eachKey].selectedValue;
          break;
        default:
          obj[eachKey].value = rowObj?.fields[eachKey].value;
          break;
      }
    });
    postJson.rows.push(obj);
  });
  try {
    const response = await addTableBulkRows(postJson);
    if (response?.status === 200) {
      fieldConfigurations[tableName].tablesFieldsObj = [];
      fieldConfigurations[tableName].tableRows = [];
      fieldConfigurations[tableName].tableRowsOrder = [];
      fieldConfigurations[tableName].isFromScriptLogic = false;
      fieldConfigurations[tableName].isBulkRowsCreate = true;
      await fetchTableRowsData(fieldConfigurations, tableName, txnData?.id);
    } else {
      showWarningMessageAlert(response?.data?.error);
    }
  } catch (error) {
    logger.error(error);
  }
};

// removing the bulk api data
async function bulkTableRowsRemove(tableName, fieldConfigurations, txnData, serviceType, callback) {
  const rowIds = [];
  if (fieldConfigurations[tableName]?.tableRows) {
    for (const tableObj of fieldConfigurations[tableName].tableRows) {
      if (tableObj.id) {
        rowIds.push(tableObj.id);
      }
    }
  }
  if (rowIds.length === 0) {
    if (callback) callback();
    return;
  }
  const accessId = getPaccessId();
  const postJson = {
    refTableId: fieldConfigurations[tableName]?.refId,
    refType: serviceType,
    pAccId: accessId,
    refId: txnData?.id,
    txnId: txnData?.txnId,
    rowIds,
  };
  try {
    const response = await removeTableBulkRows(postJson);
    if (response?.status === 200) {
      fieldConfigurations[tableName].tableRows = [];
    } else {
      showWarningMessageAlert(response?.data?.error);
    }
  } catch (error) {
    logger.error(error);
  }
}

// remove bulk rows and adding new rows to the table
async function processTableData(tableName, fieldConfigurations, txnData, serviceType, rows, callback) {
  try {
    // Step 1: Execute bulkTableRowsRemove
    await bulkTableRowsRemove(tableName, fieldConfigurations, txnData, serviceType, callback);
    // Step 2: Execute rows.forEach
    const table = fieldConfigurations[tableName];
    const returnRows = await addTableRowsFun(table, tableName, rows, fieldConfigurations, true, serviceType);
    // Step 3: Execute bulkTableRowsCreate
    await bulkTableRowsCreate(tableName, returnRows, fieldConfigurations, txnData, serviceType);
  } catch (error) {
    // Handle errors if necessary
    logger.error(error);
  }
}

// updating table row
const updateTableRow = async (tableName, postJson, rowObj, rowIdx, fieldConfigurations) => {
  const response = await updateTableRow(postJson, rowObj?.id);
  if (response?.data?.statusCode === 0) {
    showSuccesMessageAlert(txnForm?.TABLE_FORM?.UPDATED_SUCCESS);
    setTimeout(() => {
      fieldConfigurations[tableName].tableRows[rowIdx] = response?.data?.data;
      fieldConfigurations[tableName].tableRows[rowIdx].isRowEdit = false;
      fieldConfigurations[tableName].tableRows[rowIdx].isRowDelete = false; 
      fieldConfigurations[tableName].tableRows[rowIdx].isSearch = true;
      const lookupObj = response?.data?.data?.lookup;
      const businessId = getLoginBusinessId();
      response?.data?.data?.fields?.forEach((fieldObj, fieldKey) => {
        if (fieldObj.type === 'lookupUiTemplate' && lookupObj) {
          setLookupValue(fieldObj, lookupObj, businessId);
        }
      });
    }, 100);
  } else {
    logger.error('error');
  }
};

// table related script logic function from wrapper service.
const callFunFromScriptWrapper = async (
  tableName,
  rows,
  action,
  isSink,
  rowFields,
  fieldConfigurations,
  txnData,
  serviceType,
  perspectiveId,
) => {
  const table = fieldConfigurations[tableName];
  try {
    if (Array.isArray(rows) && rows?.length > 0 && !rows[0]?.fields) {
      // Modified data
      rows = rows?.map((rowObj) => {
        const newObj = { fields: {} }; // Initialize object with "fields" key
        Object.keys(rowObj).forEach((fieldName) => {
          newObj.fields[fieldName] = { value: rowObj[fieldName].value }; // Add field with value property
        });
        return newObj;
      });
    }

    switch (action) {
      // adding table rows      
      case 'ADD_ROW':
        if (isSink && txnData && txnData.id && rows && rows.length > 0) {
          const tableRowsLen = fieldConfigurations[tableName]?.tableRows?.length;
          let isMaxLen = false;
          if (tableRowsLen + rows.length > table?.tableMaxRows) {
            isMaxLen = true;
            const copyRows = [];
            rows?.forEach((rowObj, rowIdx) => {
              if (table?.tableMaxRows > tableRowsLen + rowIdx) {
                copyRows.push(rowObj);
              }
            });
            rows = copyRows;
          }
          if (isMaxLen) {
            showWarningMessageAlert(`Not allowed more than ${table.tableMaxRows} row(s)`);
          }
          if (rows && rows.length > 0) {
            const returnRows = addTableRowsFun(table, tableName, rows, fieldConfigurations, true, serviceType);
            await bulkTableRowsCreate(tableName, returnRows, fieldConfigurations, txnData, serviceType);
            if (window.updateStateFromUtility) window.updateStateFromUtility(fieldConfigurations[tableName]);
          }
        } else {
          await addTableRowsFun(table, tableName, rows, fieldConfigurations, false, serviceType);
          fieldConfigurations[tableName].isFromScriptLogic = true;
          fieldConfigurations[tableName].isBulkRowsCreate = false;
          if (window.updateStateFromUtility) window.updateStateFromUtility(fieldConfigurations[tableName]);
        }
        break;
      case 'DELETE_ROWS':
        if (isSink && txnData && txnData?.id && fieldConfigurations[tableName]?.tableRows?.length > 0) {
          await bulkTableRowsRemove(tableName, fieldConfigurations, txnData, serviceType);
          if (window.updateStateFromUtility) window.updateStateFromUtility(fieldConfigurations[tableName]);
        } else {
          fieldConfigurations[tableName].tableRows = [];
        }
        fieldConfigurations[tableName].tablesFieldsObj = [];
        fieldConfigurations[tableName].tableRows = [];
        fieldConfigurations[tableName].isFromScriptLogic = false;
        fieldConfigurations[tableName].isBulkRowsCreate = false;
        if (window.updateStateFromUtility) window.updateStateFromUtility(fieldConfigurations[tableName]);
        break;
      case 'REPLACE_ROWS':
        if (isSink && txnData && txnData?.id) {
          const isMaxLen = false;
          if (rows.length > table.tableMaxRows) {
            isMaxLen = true;
            const copyRows = [];
            rows?.forEach((rowObj, rowIdx) => {
              if (table.tableMaxRows > rowIdx) {
                copyRows.push(rowObj);
              }
            });
            rows = copyRows;
          }

          confirm({
            icon: <ExclamationCircleOutlined />,
            title: 'Are you sure?',
            content: `Do you want to replace rows of  ${table.label}`,
            okText: 'CONFIRM',
            okType: 'info',
            cancelText: txnForm?.SUB_FORM?.CANCEL,
            async onOk() {
              try {
                if (isMaxLen) {
                  showMessageAlert(`Not allowed more than ${table?.tableMaxRows} row(s)`);
                }
                await processTableData(tableName, fieldConfigurations, txnData, serviceType, rows);
                if (window.updateStateFromUtility) window.updateStateFromUtility(fieldConfigurations[tableName]);
              } catch (error) {
                // Handle any errors that occur during the txn creation process.
                // TODO
              }
            },
            onCancel() {
              // Do nothing if user cancels
            },
          });
        } else {
          fieldConfigurations[tableName].tableRows = [];
          fieldConfigurations[tableName].tableRowsOrder = [];
          fieldConfigurations[tableName].isFromScriptLogic = true;
          await addTableRowsFun(table, tableName, rows, fieldConfigurations, false, serviceType);
          if (window.updateStateFromUtility) window.updateStateFromUtility(fieldConfigurations[tableName]);
        }
        break;

      case 'GET_ROWS':
        return fieldConfigurations[tableName].tableRows;

      case 'GET_ROW':
        return fieldConfigurations[tableName].tableRows[rows];

      case 'ROWS_HEIGHT':
        // eslint-disable-next-line no-case-declarations
        const singleRowHgt = 70;
        if (rows > 0) {
          const totalHgt = singleRowHgt * rows;
          fieldConfigurations[tableName].tableRowsVisible = `${totalHgt}px`;
        }
        fieldConfigurations[tableName].isFromScriptLogic = false;
        fieldConfigurations[tableName].isBulkRowsCreate = false;
        if (window.updateStateFromUtility) window.updateStateFromUtility(fieldConfigurations[tableName]);
        break;

      case 'UPDATE_COLUMN':
        if (rows && typeof rows === 'object') {
          Object.keys(rows).forEach((fieldName) => {
            const val = rows[fieldName];
            // eslint-disable-next-line no-unneeded-ternary
            const isDisabled = val === 'r' ? true : val === 'rw' ? false : false;
            fieldConfigurations[tableName].fields[fieldName].isReadField = isDisabled;
          });
        }

        fieldConfigurations[tableName]?.tableRows?.forEach((tableObj) => {
          // eslint-disable-next-line no-unused-expressions
          if (rows && typeof rows === 'object') {
            Object.keys(rows).forEach((fieldName) => {
              const val = rows[fieldName];
              // eslint-disable-next-line no-unneeded-ternary
              const isDisabled = val === 'r' ? true : val === 'rw' ? false : false;
              tableObj.fields[fieldName].isReadField = isDisabled;
            });
          }
        });
        fieldConfigurations[tableName].isFromScriptLogic = true;
        fieldConfigurations[tableName].isBulkRowsCreate = false;
        if (window.updateStateFromUtility) window.updateStateFromUtility(fieldConfigurations[tableName]);
        break;
      case 'UPDATE_ROW':
        // eslint-disable-next-line no-case-declarations
        const rowIdx = rows;
        // eslint-disable-next-line no-case-declarations
        const rowObj = fieldConfigurations[tableName]?.tableRows[rowIdx];
        if (rowFields && rowIdx >= 0 && rowObj) {
          const accessId = getPaccessId();
          const postJson = {
            refTableId: rowObj?.refTableId,
            refType: rowObj?.refType,
            pAccId: accessId,
            refId: rowObj?.refId,
            fields: rowFields,
            txnId: rowObj?.txnId,
          };

          // refId, pId, serviceType, txnId, actionName
          const isUpdateRowPermission = handleTableRowActionPermission(
            rowObj.refTableId,
            perspectiveId,
            serviceType,
            txnData?.id,
            'UPDATE_ROW',
          );
          if (!isUpdateRowPermission) {
            showMessageAlert(`You don't have access to update ${fieldConfigurations[tableName]?.label}`);
            return;
          }
          await updateTableRow(tableName, postJson, rowObj, rowIdx, fieldConfigurations);
          fieldConfigurations[tableName].isFromScriptLogic = true;
          fieldConfigurations[tableName].isBulkRowsCreate = false;
          if (window.updateStateFromUtility) window.updateStateFromUtility(fieldConfigurations[tableName]);
        }
        break;
      case 'REMOVE_ROW':
        // eslint-disable-next-line no-case-declarations
        const rowIdxs = rows;
        // eslint-disable-next-line no-case-declarations
        const rowObjs = fieldConfigurations[tableName]?.tableRows[rowIdxs];
        if (rowIdxs >= 0 && rowObjs) {
          const isDelRowPermission = handleTableRowActionPermission(
            rowObjs?.refTableId,
            perspectiveId,
            serviceType,
            txnData?.id,
            'DEL_ROW',
          );
          if (!isDelRowPermission) {
            showMessageAlert(`You don't have access to remove ${fieldConfigurations[tableName]?.label} row`);
            return;
          }
          try {
            const response = await removeTableRow(rowObjs.id);
            if (response?.status === 200) {
              showSuccesMessageAlert(txnForm?.TABLE_FORM?.DELETE_SUCCESS);
              fieldConfigurations[tableName]?.tableRows?.splice(rowIdxs, 1);
              const serviceData = getServiceData(serviceType);
              await scriptLogicForTableRow(
                rowObjs?.fields,
                'ROW_DELETE',
                rowObjs?.refTableId,
                fieldConfigurations[tableName]?.tableRows,
                fieldConfigurations[tableName]?.refId,
                txnData,
                serviceData,
                fieldConfigurations,
                window.scriptLogicWrapper,
              );
              fieldConfigurations[tableName].isFromScriptLogic = true;
              fieldConfigurations[tableName].isBulkRowsCreate = false;
              if (window.updateStateFromUtility) window.updateStateFromUtility(fieldConfigurations[tableName]);
            } else {
              showWarningMessageAlert(response?.data?.error);
            }
          } catch (error) {
            logger.error(error);
          }
        }
        break;
    }
  } catch (error) {
    logger.error('Erro in TABLE SCRIPT LOGIC:', error);
  }
};

// getting the field name
const getFieldName = (fieldRefId, serviceData) => {
  let fieldData = '';
  const fields = serviceData?.fields;

  if (fields !== undefined) {
    Object.keys(fields).forEach((key) => {
      if (fieldRefId !== undefined && fields[key].refId === fieldRefId) {
        fieldData = fields[key];
        fieldData.name = key;
      }
    });
  }
  return fieldData?.name || fieldRefId;
};

// on select of lookup we are storing data
const onSelectLookup = async (
  selectedItem,
  keyName,
  refid,
  action,
  isOnUpdate,
  fieldConfigurations,
  serviceData,
  perspectId,
  txnId,
  businessId,
  scriptLogicWrapper,
) => {
  businessId = getLoginBusinessId();
  keyName = getFieldName(refid, serviceData);
  try {
    const response = selectedItem?.selectedValue && selectedItem?.selectedValue !== '' && await getLookupData(selectedItem?.selectedValue, selectedItem?.lookupType);
    const res = response?.data;
    if (res?.statusCode === 0) {
      if (res?.data) {
        if (action === 'TABLE') {
          // need to write proper code for table
          scriptLogicForTableRow(fieldConfigurations[keyName].fields, selectedItem?.type, refid, fieldConfigurations[keyName].tableRows, selectedItem.refId, res?.data, serviceData, fieldConfigurations, scriptLogicWrapper);
          clearLookupDependsOn(selectedItem.rowObjRefId, fieldConfigurations[keyName].fields);
        } else {
          fieldConfigurations[keyName].data = res.data;
          fieldConfigurations[keyName].selectedValue = selectedItem?.selectedValue;
          const selectedLookupValue = getSelectedLookupFormData();
          fieldConfigurations[keyName].value = selectedLookupValue[selectedItem?.selectedValue] || fieldConfigurations[keyName].value;
          if (isOnUpdate !== 'ON_UPDATE_INIT') {
            if (formlaFieldOnChangeCall) {
              await formlaFieldOnChangeCall(
                fieldConfigurations,
                refid,
                templates.UI_TEMPLATES.LOOKUP_UI_TEMPLATE,
                serviceData,
                res.data,
                scriptLogicWrapper,
              );
              if (serviceData.scripts && serviceData.actionScript && window?.onChangeFunc) {
                serviceData?.scripts?.forEach((scriptL) => {
                  if (scriptL.fid === refid) {
                    const f_name = `${scriptL.fid}_${scriptL.action}`;
                    if (window[f_name]) {
                      logger.info('calling field Logic fun');
                      fieldConfigurations.forEach((fieldKey) => {
                        const fieldObj = fieldConfigurations[fieldKey];
                        // refId, pId, serviceType, txnId, businessId
                        if (
                          fieldObj?.value &&
                          fieldObj?.value != null &&
                          fieldObj.value !== '' &&
                          !hideFieldPermission(fieldObj?.refId, serviceData?.type, perspectId, txnId, businessId)
                        ) {
                          window?.onChangeFunc(fieldKey, fieldObj.value);
                        }
                      });
                    }
                  }
                });
              }
            }
            setTimeout(() => {
              if (window.updateStateFromUtility) window.updateStateFromUtility(fieldConfigurations[keyName]);
            }, 500);
            clearLookupDependsOn(refid, fieldConfigurations);
          }
        }
      }
    } else if (res?.statusMessage) {
      // eslint-disable-next-line no-use-before-define
      showWarningMessageAlert(res?.statusMessage);
    }
    if (!selectedItem?.selectedValue) {
      if (action === 'TABLE') {
        // need to write proper code for table
        scriptLogicForTableRow(fieldConfigurations[keyName].fields, selectedItem?.type, refid, fieldConfigurations[keyName].tableRows, selectedItem.refId, res?.data, serviceData, fieldConfigurations, scriptLogicWrapper);
        clearLookupDependsOn(selectedItem.rowObjRefId, fieldConfigurations[keyName].fields);
      } else if (isOnUpdate !== 'ON_UPDATE_INIT') {
        if (formlaFieldOnChangeCall) {
          await formlaFieldOnChangeCall(
            fieldConfigurations,
            refid,
            templates.UI_TEMPLATES.LOOKUP_UI_TEMPLATE,
            serviceData,
            {},
            scriptLogicWrapper,
          );
          if (serviceData.scripts && serviceData.actionScript && window?.onChangeFunc) {
            serviceData?.scripts?.forEach((scriptL) => {
              if (scriptL.fid === refid) {
                const f_name = `${scriptL.fid}_${scriptL.action}`;
                if (window[f_name]) {
                  logger.info('calling field Logic fun');
                  fieldConfigurations.forEach((fieldKey) => {
                    const fieldObj = fieldConfigurations[fieldKey];
                    if (
                      fieldObj?.value &&
                      fieldObj?.value != null &&
                      fieldObj.value !== '' &&
                      !hideFieldPermission(fieldObj?.refId, serviceData?.type, perspectId, txnId, businessId)
                    ) {
                      window?.onChangeFunc(fieldKey, fieldObj.value);
                    }
                  });
                }
              }
            });
          }
        }
        setTimeout(() => {
          if (window.updateStateFromUtility) window.updateStateFromUtility(fieldConfigurations[keyName]);
        }, 500);
        clearLookupDependsOn(refid, fieldConfigurations);
      }
    }
  } catch (error) {
    // Handle any errors that occur during the process
  }
};

// This function is used to format the user account location status date and time format
const formatUserAcountLocationTimestamp = (timestamp) => {
  if (!timestamp || Number.isNaN(Number(timestamp))) {
    return 'Invalid Date';
  }

  const date = new Date(timestamp);

  if (Number.isNaN(date.getTime())) {
    return 'Invalid Date';
  }

  const options = {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  };

  return new Intl.DateTimeFormat('en-US', options).format(date);
};

const languageLabelTranslate = function (fieldData) {
  const businessId = getLoginBusinessId();
  const bizObj = getSession(`${businessId}_biz_Accocunt_user_obj`, true) || {};
  let accPrefLang = 'en_IN';
  if (bizObj?.prefLang) {
    accPrefLang = bizObj.prefLang;
  }
  if (
    fieldData &&
    fieldData?.languages &&
    Object.keys(fieldData?.languages) &&
    Object.keys(fieldData?.languages)?.length > 0
  ) {
    if (fieldData?.languages[accPrefLang]) {
      return fieldData?.languages[accPrefLang];
    } else {
      if (fieldData?.languages?.en_IN) {
        return fieldData?.languages?.en_IN;
      }
      return fieldData?.label;
    }
  } else {
    return fieldData ? fieldData?.label : '';
  }
};

const redirectToAngular = (bizCode, url, extraParams) => {
  const key = `${bizCode}${SESSION_KEYS.LOGIN_RES}`;
  const sessionData = getSession(key, true);
  sessionData.switchFromReact = true;
  const redirectUrl = `${getAngularURL()}/#/home/${bizCode}/${url}`;

  // Encode the data as a query parameter
  const encodedData = encodeURIComponent(JSON.stringify(sessionData));

  // Append the data to the URL as a query parameter
  let queryParams = `?angData=${encodedData}`;
  if (extraParams?.includes('?')) {
    queryParams = `${extraParams}&angData=${encodedData}`;
  }
  window.location.href = `${redirectUrl}${queryParams}`;
};

// This 'readFieldPermission' function is used to handle the form fields read permissions
const readActionFieldPermission = (fieldData, fieldPermissions) => {
  let permission = false;
  const permissionKey = fieldData?.refId;
  const fieldPermission = fieldPermissions?.[permissionKey];

  if (fieldPermission?.permission === 'WRITE') {
    permission = true; // Set isDisabled to false if permission is WRITE
  } else {
    permission = false; // Set isDisabled to true for other permissions
  }
  return permission;
};

// getting perspective acess id for txn create or update for the security fix.
const getPerspectiveAccessId = (serviceType, perspectiveId) => {
  const businessId = getLoginBusinessId();
  const bizAccountObjPermissions = useBizAccountObjPermissions(businessId);
  let result = '';
  if (bizAccountObjPermissions?.objPermissions[serviceType]) {
    const matchingObject = Object.entries(bizAccountObjPermissions?.objPermissions[serviceType]).find(([key, value]) => {
      return value.perspectiveId === perspectiveId;
    });
    result = matchingObject ? matchingObject[0] : null;
  }
  return result;
};

const assignSelectedLookupDataToTxnData = (lookupData) => {
  const selectedLookupData = {
    "fields": {}
  };
  // Iterate through the original data
  for (const key in lookupData?.value) {
    if (key.startsWith("fields.")) {
      const fieldKey = key.substring("fields.".length);
      selectedLookupData.fields[fieldKey] = {
        "type": lookupData.value[key].type,
        "value": lookupData.value[key].value
      };

      // If it's a mobile number, extract the code
      if (lookupData.value[key].type === "mobileNumberUiTemplate") {
        const mobileValue = lookupData.value[key].value;
        const codeMatch = mobileValue.match(/\+(\d+)/);
        if (codeMatch) {
          // eslint-disable-next-line prefer-destructuring
          selectedLookupData.fields[fieldKey].code = codeMatch[1];
        }
      }
    }
  }

  // this scenario handled from lookup script logic.
  if (lookupData?.isFromLookupScriptLogic) {
    for (const fieldKey in lookupData?.value?.fields) {
      selectedLookupData.fields[fieldKey] = {
        "type": lookupData?.value?.fields[fieldKey]?.type,
        "value": lookupData?.value?.fields[fieldKey]?.value
      };
      // If it's a mobile number, extract the code
      if (lookupData?.value?.fields[fieldKey]?.type === "mobileNumberUiTemplate") {
        const mobileValue = lookupData?.value?.fields[fieldKey]?.value;
        const codeMatch = mobileValue.match(/\+(\d+)/);
        if (codeMatch) {
          // eslint-disable-next-line prefer-destructuring
          selectedLookupData.fields[fieldKey].code = codeMatch[1];
        }
      }
    }
  }
  return selectedLookupData;
}

const checkIsActionFlowExist = (fieldId, svcType) => {
  const serviceData = getServiceData(svcType, undefined);
  if (serviceData && serviceData?.actionFlowFieldIds && serviceData?.actionFlowFieldIds?.includes(fieldId)) {
    return true;
  }

}

// 24 hours format.
const get24HoursFormatTime = (date) => {
  if (date) {
    let time = new Date(date);
    time = time.toLocaleString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' });
    if (time) {
      const t = (time).split(":");
      return `${t[0]}:${t[1]}:${t[2]}`;

    }
  }
}

// get time difference
const getTimeDiffWithSeconds = (startDate, endDate) => {
  const startTime = get24HoursFormatTime(startDate) || "";
  const endTime = get24HoursFormatTime(endDate) || "";
  let totalTime = "";

  if (startTime !== "" && endTime !== "") {
    const startTimeArray = startTime.split(":");
    const endTimeArray = endTime.split(":");
    if (startTimeArray.length > 0 && endTimeArray.length > 0) {
      const startSecondsArray = startTimeArray[2].split(" ");
      const endSecondsArray = endTimeArray[2].split(" ");
      const startDateObj = new Date(0, 0, 0, startTimeArray[0], startTimeArray[1], startSecondsArray[0]);
      const endDateObj = new Date(0, 0, 0, endTimeArray[0], endTimeArray[1], endSecondsArray[0]);

      const diff = endDateObj.getTime() - startDateObj.getTime();
      const days = Math.floor(diff / (60 * 60 * 24 * 1000));
      const hours = Math.floor(diff / (60 * 60 * 1000)) - (days * 24);
      const minutes = Math.floor(diff / (60 * 1000)) - ((days * 24 * 60) + (hours * 60));
      const seconds = Math.floor(diff / 1000) - ((days * 24 * 60 * 60) + (hours * 60 * 60) + (minutes * 60));

      if (days !== 0) {
        totalTime = `${days} day(s)`;
        if (hours !== 0) totalTime += ", ";
      }
      if (hours !== 0) {
        totalTime += `${hours} hour(s)`;
        if (minutes !== 0) totalTime += ", ";
      }
      if (minutes !== 0) {
        totalTime += `${minutes} minute(s)`;
        if (seconds !== 0) totalTime += ", ";
      }
      if (seconds !== 0) {
        totalTime += `${seconds} second(s)`;
      }
    }
  }
  return (totalTime === "") ? "0 second(s)" : totalTime;
}

// date format based on user configured.
const getDateFormatFunction = (dateFormat) => {
  let format = 'DD-MMMM-YYYY';
  if (dateFormat && dateFormat === 'dd-MM-yyyy') {
    format = 'DD-MM-YYYY';
  }
  if (dateFormat && dateFormat === 'dd-MMMM-yyyy') {
    format = 'DD-MMMM-YYYY';
  }
  if (dateFormat && dateFormat === 'dd-MMM-yyyy') {
    format = 'DD-MMM-YYYY';
  }

  if (dateFormat && dateFormat === 'MM-dd-yyyy') {
    format = 'MM-DD-YYYY';
  }
  if (dateFormat && dateFormat === 'MM/dd/yyyy') {
    format = 'MM/DD/YYYY';
  }
  if (dateFormat && dateFormat === 'MMM-dd-yyyy') {
    format = 'MMM-DD-YYYY';
  }

  if (dateFormat && dateFormat === 'yyyy/MM/dd') {
    format = 'YYYY/MM/DD';
  }
  if (dateFormat && dateFormat === 'yyyy-MM-dd') {
    format = 'YYYY-MM-DD';
  }
  if (dateFormat && dateFormat === 'shortDate') {
    format = 'M-D-YYYY';
  }

  return format;
}

// Function to remove duplicates based on a specific key
const removeDuplicatePerspectivesByKey = (arr, key) => {
  const uniqueKeys = new Set();
  let hasDuplicateRemoved = false;
  return arr.filter(obj => {
    const duplicate = uniqueKeys.has(obj[key]);
    if (duplicate && !hasDuplicateRemoved) {
      uniqueKeys.delete(obj[key]);
      hasDuplicateRemoved = true;
      return false;
    }
    uniqueKeys.add(obj[key]);
    return true;
  });
};

// functionality for form diff change in edit or create txn data.
const updateFieldsAndCheckChanges = async (fieldConfigurations, txnId, svcType) => {

  const businessId = getLoginBusinessId();
  const serviceData = await getServiceData(svcType, businessId);
  const data = JSON.parse(JSON.stringify(serviceData));
  logger.info(data);
  const parseSourceData = getSourceTxnData() || {};
  const sourceData = JSON.parse(JSON.stringify(parseSourceData));
  logger.debug("sourceData", sourceData);
  // if (txnId) {
  //   const response = await getTxnDetailsByTxnID(`${txnId}`);
  //   if (response?.data?.statusCode === 0) {
  //     sourceData = response?.data?.data?.fields;
  //   }
  // } else {
  // sourceData = getSourceTxnData();
  // }
  const fieldOrderData = fieldColumnOrderApply(sourceData, data?.fieldsOrder);
  const copySourceFields = JSON.parse(JSON.stringify(fieldOrderData));

  let tableChangeVal = false;
  // const subformDiffVal = !txnId;
  let isObjectChange = false;
  Object.keys(fieldConfigurations).forEach((sourceKey) => {
    const sourceObj = fieldConfigurations[sourceKey];
    if (sourceObj) {
      switch (sourceObj.type) {
        case templates?.UI_TEMPLATES.CHECKBOX_UI_TEMPLATE:
          if (sourceObj && (sourceObj.value == null || sourceObj.value === '')) {
            sourceObj.value = [];
          }
          break;
        case templates?.UI_TEMPLATES.MOBILE_NUMBER_UI_TEMPLATE:
          if (sourceObj) {
            if (fieldConfigurations[sourceKey]?.normalNum !== undefined) {
              sourceObj.value = fieldConfigurations[sourceKey].value;
              sourceObj.normalNum = fieldConfigurations[sourceKey].normalNum;
            }
            if (fieldConfigurations[sourceKey]?.isValid !== undefined) {
              sourceObj.isValid = fieldConfigurations[sourceKey].isValid;
            }
          }
          break;
        case templates.UI_TEMPLATES.SINGLE_CHOICE_UI_TEMPLATE:
        case templates.UI_TEMPLATES.RADIO_BUTTON_UI_TEMPLATE:
        case templates.UI_TEMPLATES.MULTI_SELECT_UI_TEMPLATE:
          if (sourceObj && fieldConfigurations[sourceKey]?.optionLabel !== undefined) {
            sourceObj.optionLabel = fieldConfigurations[sourceKey].optionLabel;
          }
          break;
        case templates.UI_TEMPLATES.LOOKUP_UI_TEMPLATE:
          if (sourceObj && txnId && sourceObj.value === fieldConfigurations[sourceKey]?.selectedValue) {
            if (fieldConfigurations[sourceKey]?.data !== undefined) {
              sourceObj.data = fieldConfigurations[sourceKey].data;
            }
            if (fieldConfigurations[sourceKey]?.selectedValue !== undefined) {
              sourceObj.selectedValue = fieldConfigurations[sourceKey].selectedValue;
            }
            if (fieldConfigurations[sourceKey]?.value !== undefined) {
              sourceObj.value = fieldConfigurations[sourceKey].value;
            }
          }
          break;
        case templates.UI_TEMPLATES.TABLE_UI_TEMPLATE:
          if (sourceObj && !txnId) {
            sourceObj.fields = fieldConfigurations[sourceKey]?.fields;
            sourceObj.sortedColumns = fieldConfigurations[sourceKey]?.sortedColumns;
            // if (copySourceFields[sourceKey]?.tableRows?.length !== fieldConfigurations[sourceKey]?.tableRows?.length) {
            //   tableChangeVal = true;
            // } else {
            fieldConfigurations[sourceKey]?.tableRows?.forEach((tableObj, tableIdx) => {
              tableObj.fields.forEach((tableFObj, tableFKey) => {
                if (tableFObj.type === templates.UI_TEMPLATES.MOBILE_NUMBER_UI_TEMPLATE) {
                  if (fieldConfigurations[sourceKey]?.fields[tableFKey]?.normalNum !== undefined) {
                    tableFObj.value = fieldConfigurations[sourceKey].fields[tableFKey].value;
                    tableFObj.normalNum = fieldConfigurations[sourceKey].fields[tableFKey].normalNum;
                  }
                  if (fieldConfigurations[sourceKey]?.fields[tableFKey]?.isValid !== undefined) {
                    tableFObj.isValid = fieldConfigurations[sourceKey].fields[tableFKey].isValid;
                  }
                }
              });
            });
            const tableDiff = objectDiff.diffOwnProperties(copySourceFields[sourceKey]?.tableRows, fieldConfigurations[sourceKey]?.tableRows);
            logger.debug("TABLE FORM DATA CHANGED *******", tableDiff);
            if (tableDiff && tableDiff.changed === 'object change') {
              tableChangeVal = true;
            }
            // }
          }
          break;
        case templates.UI_TEMPLATES.SUB_FORM_UI_TEMPLATE:
          if (sourceObj && fieldConfigurations[sourceKey]?.fields !== undefined) {
            sourceObj.fields = fieldConfigurations[sourceKey].fields;
          }
          if (sourceObj && fieldConfigurations[sourceKey]?.atLeastOneValue !== undefined) {
            sourceObj.atLeastOneValue = fieldConfigurations[sourceKey].atLeastOneValue;
          }
          if (sourceObj && fieldConfigurations[sourceKey]?.docId !== undefined) {
            sourceObj.docId = fieldConfigurations[sourceKey].docId;
          }
          break;
        default:
          break;
      }
    }
  });

  logger.debug("TXN DATA SOURCE ", copySourceFields);
  logger.debug("ACTUAL DATA ", fieldConfigurations);
  const diff = objectDiff.diffOwnProperties(copySourceFields, fieldConfigurations);
  logger.debug("FORM DATA CHANGED *******", diff);
  if (diff && diff.changed === 'object change' || tableChangeVal) {
    logger.debug("FORM DATA CHANGED *******", diff);
    isObjectChange = true;
  }

  logger.debug("IS FORM DATA CHANGED ", isObjectChange);

  return isObjectChange;
};
// field hide and show logic based on the script logic 
const showHideOnConfirmFunct = () => {
  // eslint-disable-next-line no-restricted-syntax
  const fieldsArray = getHideFieldsArray();
  for (const key in fieldsArray) {
    // Your code to hide the element
    const element = document.getElementById(fieldsArray[key]);
    if (element) {
      element.style.display = 'none'; // This line seems redundant since the element is already hidden
    }
    logger.debug(`element Name ---- ${fieldsArray[key]} --------> `, element);
  }
}

// getting app icon.
const getAppIcon = (currentObj, type, isListLabel, isService) => {
  // Accessing window.firebase.database() globally
  const database = window.firebase.database();
  const businessId = getLoginBusinessId();
  let ref;
  if (type?.includes("SVC")) {
    ref = database.ref(`/business/${businessId}/services/${type}`);
  } else {
    ref = database.ref(`/business/${businessId}/consumers/${type}`);
  }

  const onValue = (snapshot) => {
    const serviceObj = snapshot.val();
    if (serviceObj) {
      if (isListLabel) currentObj.listLabel = serviceObj.listLabel;
      if (isService) currentObj[type] = serviceObj;
      if (serviceObj.iconUrl && serviceObj.iconUrl !== '') {
        currentObj.appIconUrl = serviceObj.iconUrl;
      } else {
        currentObj.appIconUrl = undefined;
      }
    }
  };

  ref.on('value', (snapshot) => onValue(snapshot, currentObj));

  return () => {
    ref.off('value', onValue);
  };
}

// Define a function to get the service data from Firebase
const getFirebaseServiceData = (type) => {
  return new Promise((resolve, reject) => {
    // Accessing window.firebase.database() globally
    const database = window.firebase.database();
    const businessId = getLoginBusinessId();
    let ref;
    if (type?.includes("SVC")) {
      ref = database.ref(`/business/${businessId}/services/${type}`);
    } else {
      ref = database.ref(`/business/${businessId}/consumers/${type}`);
    }

    // Attach a one-time listener for 'value' event
    ref.once('value', (snapshot) => {
      const serviceObj = snapshot.val();
      if (serviceObj) {
        resolve(serviceObj); // Resolve with the service data
      } else {
        reject(new Error('Service data not found')); // Reject if service data is not found
      }
    }, (error) => {
      reject(error); // Reject if there's an error fetching data
    });
  });
}
// location mode enabling
const isLocationModeEnabled = (serviceType, perspectiveId, businessId) => {
  businessId = getLoginBusinessId();
  let permission = false;
  const viewObj = gettingPerspectiveObj(serviceType, perspectiveId, businessId);
  if (viewObj && viewObj?.location) {
    if (viewObj?.location?.state === 'ACTIVE') {
      permission = true;
    }
  }
  return permission;
};

const getFileNameFromUrl = (url) => {
  // Split the URL by '/'
  const parts = url.split('/');
  // Get the last part which contains the file name
  const lastPart = parts[parts.length - 1];
  // Split the last part by '?' to remove any query parameters
  const fileName = lastPart.split('?')[0];
  // Return the file name
  return fileName;
}

const payLoadHideFieldPermission = (refId, pId, serviceType, txnId) => {
  const fields = getPerspectObjFields(pId, serviceType, txnId) || {};
  // checking * permission or not
  if (fields['*'] === '*') {
    return false;
  } else {
    return !!(refId && fields[refId] === 'PD_HIDE');
  }
}

// This function handle the user web login status and format the timestamp to date and time
const getTimeFormatUsingMilliSeconds = (timestamp) => {
  const date = new Date(timestamp);
  // Date Format
  const day = date.getDate().toString().padStart(2, '0');
  const monthFormatter = new Intl.DateTimeFormat('en', { month: 'short' });
  const month = monthFormatter.format(date).toUpperCase();
  const year = date.getFullYear();
  const formattedDate = `${day}-${month}-${year}`;

  // Time Format
  const formattedTime = date.toLocaleString('en', { hour: '2-digit', minute: '2-digit', hour12: true }).toUpperCase();
  return `${formattedDate} ${formattedTime}`;
};

// getting job types
const getUniqueRefJobFunsData = (appsData) => {
  const titlesSet = new Set();
  // Iterate over each object in the input data
  if (appsData === undefined || appsData === null) {
    return [];
  }
  Object.values(appsData)?.forEach(obj => {
    // Extract the refJobFuns array
    const refJobFuns = obj.refJobFun || [];

    // Iterate over each object in the refJobFuns array
    refJobFuns.forEach(jobFun => {
      // Extract the title and add it to the set
      titlesSet.add(jobFun.title);
    });
  });
  // Convert the set to an array
  const uniqueTitles = Array.from(titlesSet);
  // Sort the uniqueTitles array in ascending order
  uniqueTitles.sort((a, b) => a.localeCompare(b));
  return uniqueTitles;
}

const getDatFiltereLabel = (key) => {
  const item = dashboardConstant?.MY_DASHBOARD?.FILTERS?.find(item => item.key === key);
  return item ? item.label : item?.key;
};

// getting the field name
const getFieldData = (fieldRefId, serviceData) => {
  let fieldData = '';
  const fields = serviceData?.fields;

  if (fields !== undefined) {
    Object.keys(fields).forEach((key) => {
      if (fieldRefId !== undefined && fields[key].refId === fieldRefId) {
        fieldData = fields[key];
        fieldData.name = key;
      }
    });
  }
  return fieldData;
};

const getMediaImgSrc = (urlValue, callback) => {
  if (urlValue && urlValue !== '') {
    if (urlValue.includes('https://s3-ap-southeast-1.amazonaws.com/') && urlValue.includes('fname=')) {
      const url = `${getEnvironmentHost()}/media?key=${urlValue}`;
      axios
        .get(url, {
          cache: true,
          headers: {
            'accept': 'image/*',
          },
        })
        .then((response) => {
          callback(response.data.url);
        });
    }
  }
};


// preparing the fields data for post json data
const prepareWorkFlowQuckActionsFieldsData = (fields, perspectiveId, serviceType, txnId, businessId) => {
  for (const key in fields) {
    const obj = fields[key];
    const isFiedHide = obj?.isHide ? obj?.isHide : false;
    if (obj.type === templates.UI_TEMPLATES?.CHECKBOX_UI_TEMPLATE) {
      if (!isFiedHide) {
        if (
          !obj.isSkippable &&
          (obj.value === '' ||
            obj.value === null ||
            obj.value === undefined ||
            (Array.isArray(obj.value) && obj.value.length === 0))
        ) {
          showMessageAlert(`${form.DYNAMIC_FORM.MANDATORY} : ${obj.label}`);
          return;
        }
        obj.value = obj.value === '' || obj.value === null ? [] : obj.value;
      }
    } else if (obj.type === templates.UI_TEMPLATES?.MULTI_SELECT_UI_TEMPLATE && obj.options) {
      if (!isFiedHide) {
        const optionLabel = [];
        for (const i in obj.value) {
          for (let j = 0; j < obj.options.length; j++) {
            if (obj.options[j] === obj.value[i]) optionLabel.push(obj.options[j]);
          }
        }
        obj.optionLabel = optionLabel;
        obj.value = obj.value === '' ? [] : obj.value;
        if (
          !obj.isSkippable &&
          (obj.value === '' ||
            obj.value === null ||
            obj.value === undefined ||
            (Array.isArray(obj.value) && obj.value.length === 0))
        ) {
          showMessageAlert(`${form.DYNAMIC_FORM.MANDATORY} : ${obj.label}`);
          return;
        }
      }
    }
    else if (
      obj.type === templates.UI_TEMPLATES?.SINGLE_CHOICE_UI_TEMPLATE
    ) {
      if (!isFiedHide) {
        if (!obj.isSkippable && !obj?.notShowFieldValues && (obj.value === '' || obj.value === null || obj.value === undefined)) {
          showMessageAlert(`${form.DYNAMIC_FORM.MANDATORY} : ${obj.label}`);
          return;
        }
        if (!obj.isSkippable && obj?.notShowFieldValues && obj?.enableAttachment && (obj?.attachmentList === undefined || obj?.attachmentList?.length === 0)) {
          showMessageAlert(`Please add atleast one attachment to : ${obj.label}`);
          return;
        }
        if (!obj.isSkippable && obj?.notShowFieldValues && obj?.enableComment && (obj?.commentsList === undefined || obj?.commentsList?.length === 0)) {
          showMessageAlert(`Please add atleast one comment to : ${obj.label}`);
          return;
        }
        if (obj?.options) {
          let optionLabel = '';
          for (let i = 0; i < obj.options.length; i++) {
            if (obj.options[i] === obj.value) optionLabel = obj.options[i];
          }
          obj.optionLabel = optionLabel;
        }
      }
    } else if (
      (obj.type === templates.UI_TEMPLATES?.RADIO_BUTTON_UI_TEMPLATE) &&
      obj.options
    ) {
      if (!isFiedHide) {
        if (!obj.isSkippable && (obj.value === '' || obj.value === null || obj.value === undefined)) {
          showMessageAlert(`${form.DYNAMIC_FORM.MANDATORY} : ${obj.label}`);
          return;
        }
        let optionLabel = '';
        for (let i = 0; i < obj.options.length; i++) {
          if (obj.options[i] === obj.value) optionLabel = obj.options[i];
        }
        obj.optionLabel = optionLabel;
      }
    } else if (obj.type === templates.UI_TEMPLATES?.DATE_PICKER_UI_TEMPLATE) {
      if (!isFiedHide) {
        if (!obj.isSkippable && (obj.value === '' || obj.value === null || obj.value === undefined)) {
          showMessageAlert(`${form.DYNAMIC_FORM.MANDATORY} : ${obj.label}`);
          return;
        }
        let dateString = '';
        if (obj?.dateFormat === "dd-MM-yyyy") {
          if (moment(obj?.value, 'YYYY-MM-DD', true).isValid()) {
            dateString = obj?.value;
          } else {
            // Step 1: Parse the date correctly using the 'DD-MM-YYYY' format
            const parsedDate = moment(obj.value, 'DD-MM-YYYY', true);  // Strict mode ensures exact format match
            // Step 2: If the date is valid, convert it to 'YYYY-MM-DD' format
            if (parsedDate.isValid()) {
              dateString = parsedDate.format('YYYY-MM-DD');
              console.log('Formatted Date:', dateString);
            } else {
              console.log('Invalid date format');
            }
          }
        } else {
          dateString = obj.value ? moment(obj.value).format('YYYY-MM-DD') : '';
        }
        obj.value = dateString;
      }
    } else if (obj.type === templates.UI_TEMPLATES?.MOBILE_NUMBER_UI_TEMPLATE) {
      if (!isFiedHide) {
        if (!obj.isSkippable && (obj.value === '' || obj.value === null || obj?.value?.length === 0)) {
          showMessageAlert(`${form.DYNAMIC_FORM.MANDATORY} : ${obj.label}`);
          return;
        }
        const numstr = obj.value ? obj.value.toString() : '';
        obj.value = numstr;
        if (obj.isValid === false) {
          showMessageAlert(`Please enter valid : ${obj.label}`);
          return false;
        }
      }
    } else if (obj.type === templates.UI_TEMPLATES?.LOCATION_UI_TEMPLATE) {
      if (!isFiedHide) {
        if (!obj.isSkippable) {
          if (!hideFieldPermission(obj?.refId, perspectiveId, serviceType, txnId, businessId, businessId)) {
            if (obj.value === '' || obj.value === null || obj.value === undefined || obj.coordinates?.length === 0) {
              showMessageAlert(`Please point a location on the map : ${obj.label}`);
              return false;
            }
          }
        }
      }
    } else if (obj.type === templates.UI_TEMPLATES?.SIGNATURE_UI_TEMPLATE) {
      if (!isFiedHide) {
        if (!obj.isSkippable) {
          if (!obj.value || obj.value === form?.EMPTY_IMAGE || typeof obj.value === 'undefined') {
            showMessageAlert(`Please provide an eSignature : ${obj.label}`);
            return false;
          }
        }
      }
    } else if (
      obj.type === templates.UI_TEMPLATES?.NUMBER_UI_TEMPLATE ||
      obj.type === templates.UI_TEMPLATES?.CURRENCY_UI_TEMPLATE
    ) {
      if (!isFiedHide) {
        if (!obj.isSkippable) {
          if (Number.isNaN(obj.value) || obj.value === '' || obj.value === null || obj.value === undefined) {
            showMessageAlert(`${form.DYNAMIC_FORM.MANDATORY} : ${obj.label}`);
            return false;
          }
          if (obj?.dnaNegative && obj?.dnaNegative && obj?.value && obj?.value < 0) {
            showMessageAlert(`Negative values are not allowed in ${obj.label}`);
            return false;
          }
          if (typeof obj.minDigits !== 'undefined' && obj.value && obj.value.toString().length < obj.minDigits) {
            showMessageAlert(`Value entered should be at least : ${obj.minDigits} digit(s). ${obj.label}`);
            return false;
          }
          // eslint-disable-next-line no-else-return
          else if (typeof obj.maxDigits !== 'undefined' && obj.value && obj.value.toString().length > obj.maxDigits) {
            showMessageAlert(`Value entered should be ${obj.maxDigits} digit(s) : ${obj.label}`);
            return false;
          }
        } else if (typeof obj.value === 'undefined' || obj.value === null) {
          obj.value = 0;
        }
      }
    } else if (obj.type === templates.UI_TEMPLATES?.EDIT_TEXT_UI_TEMPLATE) {
      if (!isFiedHide) {
        if (!obj.isSkippable) {
          if (!obj.isSkippable && (obj.value === '' || obj.value === null || obj.value === undefined)) {
            showMessageAlert(`${form.DYNAMIC_FORM.MANDATORY} : ${obj.label}`);
            return false;
          }
          if (
            typeof obj.minChars !== 'undefined' &&
            typeof obj.value !== 'undefined' &&
            obj.value.length < obj.minChars
          ) {
            showMessageAlert(`Value entered should be at least ${obj.minChars} character(s) : ${obj.label}`);
            return false;
          }
          // eslint-disable-next-line no-else-return
          else if (
            typeof obj.maxChars !== 'undefined' &&
            typeof obj.value !== 'undefined' &&
            obj.value.length > obj.maxChars
          ) {
            showMessageAlert(`Value entered should be of ${obj.maxChars} character(s): ${obj.label}`);
            return false;
          }
        }
      }
    } else if (obj.type === templates.UI_TEMPLATES?.URL_UI_TEMPLATE) {
      if (!isFiedHide) {
        if (!obj.isSkippable && (obj.value === '' || obj.value === null || obj.value === undefined)) {
          showMessageAlert(`${form.DYNAMIC_FORM.MANDATORY} : ${obj.label}`);
          return false;
        }
        if (obj.value) {
          // eslint-disable-next-line no-useless-escape
          const res = obj.value.match(/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/);
          if (res === null) {
            showMessageAlert(`Please enter valid : ${obj.label}`);
            return false;
          }
        }
      }
    } else if (
      obj.type === templates.UI_TEMPLATES?.TEXTAREA_UI_TEMPLATE ||
      obj.type === templates.UI_TEMPLATES?.RATING_UI_TEMPLATE ||
      obj.type === templates.UI_TEMPLATES.LOOKUP_UI_TEMPLATE
    ) {
      if (!isFiedHide) {
        if (!obj.isSkippable && (obj.value === '' || obj.value === null || obj.value === undefined)) {
          showMessageAlert(`${form.DYNAMIC_FORM.MANDATORY} : ${obj.label}`);
          return false;
        }
      }
    } else if (
      obj.type === templates.UI_TEMPLATES?.IMAGE_UPLOAD_UI_TEMPLATE ||
      obj.type === templates?.UI_TEMPLATES?.FILE_UPLOAD_UI_TEMPLATE
    ) {
      if (!isFiedHide) {
        if (!obj.isSkippable && (obj.value === '' || obj.value === null)) {
          showMessageAlert(`${form.DYNAMIC_FORM.MANDATORY} : ${obj.label}`);
          return false;
        }
      }
    } else if (obj.type === templates.UI_TEMPLATES?.FORMULA_UI_TEMPLATE) {
      if (!isFiedHide) {
        if (obj.returnType === 'DATE') {
          const dateString = obj.value ? moment(obj.value).format('YYYY-MM-DD') : '';
          obj.value = dateString;
        }
      }
    } else if (obj.type === templates.UI_TEMPLATES?.EMAIL_TEXT_UI_TEMPLATE && !obj?.allowCsv) {
      if (!isFiedHide) {
        if (!obj.isSkippable && (obj.value === '' || obj.value === null || obj.value === undefined)) {
          showMessageAlert(`${form.DYNAMIC_FORM.MANDATORY} : ${obj.label}`);
          return false;
        }
        if (obj?.value && obj?.value !== null && obj?.value !== '') {
          // Now you can use the match method
          const regExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          const matchResult = regExp.test(obj.value);
          if (!matchResult) {
            showMessageAlert(`Please enter valid email Id : ${obj.label}`);
            return false;
          }
        }
      }
    }
    else if (obj.type === templates.UI_TEMPLATES?.EMAIL_TEXT_UI_TEMPLATE && obj?.allowCsv) {
      if (!isFiedHide) {
        if (!obj.isSkippable && (obj.value === '' || obj.value === null || obj.value === undefined)) {
          showMessageAlert(`${form.DYNAMIC_FORM.MANDATORY} : ${obj.label}`);
          return false;
        }
        if (obj?.value && obj?.value !== null && obj?.value !== '') {
          // Now you can use the match method
          const regExp = /^(\s?[^\s,]+@[^\s,]+\.[^\s,]+\s?,)*(\s?[^\s,]+@[^\s,]+\.[^\s,]+)$/;
          const matchResult = regExp.test(obj.value);
          if (!matchResult) {
            showMessageAlert(`Please enter valid email Id(s) : ${obj.label}`);
            return false;
          }
        }
      }
    } else if (
      obj.type === templates.UI_TEMPLATES?.BAR_CODE_UI_TEMPLATE ||
      obj.type === templates.UI_TEMPLATES?.QR_CODE_UI_TEMPLATE
    ) {
      if (!isFiedHide) {
      if (!obj.isSkippable) {
        if (!obj.isSkippable && (obj.value === '' || obj.value === null || obj.value === undefined)) {
          showMessageAlert(`${form.DYNAMIC_FORM.MANDATORY} : ${obj.label}`);
          return false;
        }
        if (
          typeof obj.maxChars !== 'undefined' &&
          typeof obj.value !== 'undefined' &&
          obj.value.length > obj.maxChars
        ) {
          showMessageAlert(`Value entered should be of ${obj.maxChars} character(s) : ${obj.label}`);
          return false;
        }
      }
    }
    }
    // Add more validations for other field types as required
    fields[key] = obj;
  }
  return fields;
};

// getting perspective obj
const getPerspectiveObj = (serviceType, perspectiveId, businessId) => {
  businessId = getLoginBusinessId();
  const bizAccountObjPermissions = useBizAccountObjPermissions(businessId);
  let obj = {};
  if (bizAccountObjPermissions?.objPermissions[serviceType]) {
    obj =
      Object.values(bizAccountObjPermissions?.objPermissions[serviceType]).find((accessObj) => {
        if (accessObj.perspectiveId === perspectiveId) {
          return accessObj;
        }
      }) || {};
  }

  return obj;
};

// getting the field name
const getFieldDataByFieldName = (serviceData, fieldLable) => {
  let fieldData = '';
  const fields = serviceData?.fields;

  if (fields !== undefined) {
    Object.keys(fields).forEach((key) => {
      if (fieldLable !== undefined && fields[key].label === fieldLable) {
        fieldData = fields[key];
        fieldData.name = key;
      }
    });
  }
  return fieldData;
};

// getting the currency data
const getCurrencyData = (currencyFiledData) => {
  let currency = 0;
  if (currencyFiledData) {
    if (currencyFiledData?.value) {
      currency = currencyFiledData?.value;
    }
  }
  const currencyValue = currency?.toFixed(currencyFiledData?.decimalPositions);
  return currencyValue
}

// getting the encrypted field disabled or not based on the txnId
const isEncryptedFieldDisbaled = (txnId) => {
  let isDisabled = false;
  if (txnId !== undefined && txnId !== null && txnId !== '') {
    isDisabled = true;
  }
  return isDisabled;
}

// getting the difference in days
const getDifferenceInDays = (date1, date2) => {
  const fromDate = moment(date1, 'YYYY-MM-DD');
  const toDate = moment(date2, 'YYYY-MM-DD');
  const differenceInDays = toDate.diff(fromDate, 'days');
  return differenceInDays;
}

// getting the team access permission 
const handleGetTeamAccessArrByPerspectiveId = (transactionSelectedUserRole, svcType) => {
  const teamAssignedArr = [];
  const businessId = getLoginBusinessId();
  const userAccountObjStorage = getSession(`${businessId}_biz_Accocunt_user_obj`, true);
  const currentObj = userAccountObjStorage?.objPermissions[svcType];
  if (currentObj) {
    Object.values(currentObj)?.forEach((accessObj) => {
      if (accessObj && accessObj.perspectiveId === transactionSelectedUserRole?.perspectiveId && accessObj.view) {
        userAccountObjStorage?.memberOf?.forEach((memberObj) => {
          if (memberObj.teamId === accessObj.teamId && memberObj.type === 'PRIMARY') {
            teamAssignedArr.push(accessObj);
          }
        });
      }
    });
  }
  return teamAssignedArr;
};

// getting the user permission
const handleCheckUserPermission = (transactionSelectedUserRole, svcType) => {
  let permission = false;
  const businessId = getLoginBusinessId();
  const userAccountObjStorage = getSession(`${businessId}_biz_Accocunt_user_obj`, true);
  const data = userAccountObjStorage?.objPermissions?.[svcType];;
  if (data) {
    const perspectiveObj = transactionSelectedUserRole?.id ? data?.[transactionSelectedUserRole?.id] : Object.values(data)?.filter((elem) => elem.perspectiveId === transactionSelectedUserRole?.perspectiveId)[0];
    if (perspectiveObj?.type === 'SYSTEM') {
      permission = true;
    } else if (
      perspectiveObj?.assignedFor === 'ACCOUNT' &&
      (perspectiveObj?.assignedAcctIds || perspectiveObj?.assignedTeamIds)
    ) {
      permission = true;
    } else {
      const teamAssigned = handleGetTeamAccessArrByPerspectiveId(transactionSelectedUserRole, svcType);
      if (teamAssigned && teamAssigned?.length > 0) {
        permission = true;
      }
    }
  }
  logger.info('permission', permission);
  return permission;
};

// getting the tags data from the service data.
const getTagsData = (serviceType, perspectiveId, type) => {
  const businessId = getLoginBusinessId();
  const serviceData = getServiceData(serviceType, businessId);
  const serviceBundle = serviceData?.bundles || [];
  let tagsArrayData = [];
  if (type === 'COMMENTS') {
    tagsArrayData = _.filter(serviceBundle, (item) => item.key === `COMMENT/${perspectiveId}`);
  } else if (type === 'ASSERTS') {
    tagsArrayData = _.filter(serviceBundle, (item) => item.key === `IMAGE/${perspectiveId}`);
  }
  else if (type === 'DOCUMENT') {
    tagsArrayData = _.filter(serviceBundle, (item) => item.key === `DOCUMENT/${perspectiveId}`);
  }
  const tagsDataArray = [];
  let tagsData = [];
  if (tagsArrayData?.length > 0) {
    for (const i in tagsArrayData) {
      for (const tagKey in tagsArrayData[i].tags) {
        tagsDataArray.push(tagsArrayData[i].tags[tagKey])
      }
    }
  }
  if (tagsDataArray?.length > 0) {
    tagsData = JSON.parse(JSON.stringify(tagsDataArray));
  }
  return tagsData;
};


function areArraysDifferent(arr1, arr2) {
  // Check if both are arrays
  if (!Array.isArray(arr1) || !Array.isArray(arr2)) {
    throw new Error('Both inputs must be arrays');
  }

  // Check if they have different lengths
  if (arr1.length !== arr2.length) {
    return true;
  }

  // Check if any element differs
  for (let i = 0; i < arr1.length; i++) {
    if (Array.isArray(arr1[i]) && Array.isArray(arr2[i])) {
      // Recursive check for nested arrays
      if (areArraysDifferent(arr1[i], arr2[i])) {
        return true;
      }
    } else if (arr1[i] !== arr2[i]) {
      return true;
    }
  }

  // No differences found
  return false;
}


function tableDiff(originalData, updatedData) {
  for (const key in updatedData) {
    // Handle LOOKUP_UI_TEMPLATE
    if (updatedData[key]?.type === templates.UI_TEMPLATES.LOOKUP_UI_TEMPLATE) {
      if (updatedData[key]?.value?.id && updatedData[key]?.value?.id !== originalData[key]?.value) {
        return true; // Difference found
      }
    }
    // For other types, compare the 'value' field directly
    else if (updatedData[key]?.value !== originalData[key]?.value) {
      logger.info("key ------ > ", key);
      logger.info("updatedData[key]?.value ------ > ", updatedData[key]);
      logger.info("originalData[key]?.value ------ > ", originalData[key]);
      if (updatedData[key]?.type === templates.UI_TEMPLATES.MULTI_SELECT_UI_TEMPLATE || updatedData[key]?.type === templates.UI_TEMPLATES.CHECKBOX_UI_TEMPLATE) {
        if (areArraysDifferent(updatedData[key]?.value, originalData[key]?.value)) {
          return true; // Difference found
        }
      } else {
        return true; // Difference found
      }
    }
  }
  return false; // No differences found
}

// edit row data.
function prepareTableDataForAddOrUpdateTableRows(originalData, updatedData) {
  const updateRowsArray = [];
  const addRowsArray = [];

  updatedData?.forEach((updatedItem) => {
    const originalItem = originalData?.find(
      (item) => item.id === updatedItem.id
    );

    // Helper function to normalize mobile numbers
    const normalizeMobileNumber = (field) => {
      if (field.type === templates.UI_TEMPLATES.MOBILE_NUMBER_UI_TEMPLATE && field.code) {
        // Extract the country code (e.g., +91) and the actual number
        const countryCodeRegex = new RegExp(`\\+${field.code}\\s*`);
        const normalizedValue = field.value.replace(countryCodeRegex, '').trim();
        return {
          type: field?.type,   // Return the field's type or an empty string if not present
          value: normalizedValue.replace(/\s+/g, '')
        };
      }
      return {
        type: field?.type,   // Return the field's type or an empty string if not present
        value: field?.value === undefined ? null : field?.value // Return the field's value or an empty string if not present
      };
    };

    // Extract only the "value" properties from fields for comparison
    const updatedValues = Object.fromEntries(
      Object.entries(updatedItem.fields).map(([key, field]) => [key, normalizeMobileNumber(field)])
    );

    const originalValues = originalItem
      ? Object.fromEntries(
        Object.entries(originalItem.fields).map(([key, field]) => [key, normalizeMobileNumber(field)])
      )
      : {};

    if (updatedItem?.refId) {
      const isObjectChange = tableDiff(originalValues, updatedValues);
      logger.info("COMPARISON ------ > ", isObjectChange);
      // Compare the value properties
      if (!originalItem || isObjectChange) {
        if (updatedItem?.id && updatedItem?.refId) {
          updateRowsArray.push(updatedItem);
        } else {
          // If no id, add to addRowsArray
          addRowsArray.push(updatedItem);
        }
      }
    } else {
      // If no id, add to addRowsArray
      addRowsArray.push(updatedItem);
    }
  });

  return { updateRowsArray, addRowsArray };
}

// i need to work on to do code.
function txnFormDiff(fieldConfigurations) {
  const updatedFieldsData = fieldConfigurations;
  const sourceData = JSON.parse(JSON.stringify(getSourceTxnData() || {}));
  logger.info("updatedFieldsData ------ > ", updatedFieldsData);
  logger.info("sourceData ------ > ", sourceData);

  // Helper function to normalize mobile numbers
  const normalizeMobileNumber = (field) => {
    if (field.type === templates.UI_TEMPLATES.MOBILE_NUMBER_UI_TEMPLATE && field.code) {
      const countryCodeRegex = new RegExp(`\\+${field.code}\\s*`);
      return field.value.replace(countryCodeRegex, '').replace(/\s+/g, '');
    }
    return field.value;
  };

  // Helper function to extract and normalize field values
  const extractNormalizedValues = (data) =>
    Object.fromEntries(
      Object.entries(data || {}).map(([key, field]) => [key, normalizeMobileNumber(field)])
    );

  const updatedValues = extractNormalizedValues(updatedFieldsData);
  const originalValues = extractNormalizedValues(sourceData);

  logger.info("updatedValues ------ > ", updatedValues);
  logger.info("originalValues ------ > ", originalValues);

  // Check if values have changed
  const isObjectChange = JSON.stringify(updatedValues) !== JSON.stringify(originalValues);
  logger.info("isObjectChange ------ > ", isObjectChange);
  return isObjectChange;
}

// getting the field name
const getTableFieldName = (fieldRefId, fields) => {
  let fieldData = '';
  if (fields !== undefined) {
    Object.keys(fields).forEach((key) => {
      if (fieldRefId !== undefined && fields[key].refId === fieldRefId) {
        fieldData = fields[key];
        fieldData.name = key;
      }
    });
  }
  return fieldData?.name || null;
};

// field logic for the public formrs
const publicFormsActionScriptExecute = (fields, data) => {
  logger.info('Entered in Public form action script execute');
  const hideFieldsArray = [];
  if (data && data?.actionScript) {
    try {
      // eslint-disable-next-line no-eval
      window.eval(data?.actionScript);
      // eslint-disable-next-line no-eval
      if (typeof window.onLoadFunc === 'function' && typeof window.onChangeFunc === 'function') {
        const { onLoadFunc } = window;
        const { onChangeFunc } = window;
        logger.debug('onLoadFunc', onLoadFunc);
        logger.debug('onChangeFunc', onChangeFunc);
        if (typeof fields === 'object' && fields !== null) {
          Object.keys(fields)?.forEach((key) => {
            onLoadFunc(key);
          });
          Object.keys(fields)?.forEach((key) => {
            const obj = fields[key];
            if (
              obj &&
              obj.value !== null &&
              obj.value !== ''
            ) {
              const element = document.getElementById(key);
              if (element && window.getComputedStyle(element).display === 'none') {
                logger.info(`FIELD KEY 1111 ${key}`, window.getComputedStyle(element).display === 'none');
                logger.info(element?.style.display);
                hideFieldsArray.push(key);
              }
              onChangeFunc(key, obj.value);
            }
          });
          setHideFieldsArray(hideFieldsArray);
        }
      }
    } catch (error) {
      logger.error('Error executing actionScript:', error);
    }
  }
};

// public form data preparation



// preparing the fields data for post json data
const preparePublicFormFieldsData = (fields, serviceType) => {
  for (const key in fields) {
    const obj = fields[key];
    if (obj.type === templates.UI_TEMPLATES?.CHECKBOX_UI_TEMPLATE) {
      const element = document.getElementById(key);
      if (
        element &&
        window.getComputedStyle(element).display === 'block'
      ) {
        if (
          !obj.isSkippable &&
          (obj.value === '' ||
            obj.value === null ||
            obj.value === undefined ||
            (Array.isArray(obj.value) && obj.value.length === 0))
        ) {
          showMessageAlert(`${form.DYNAMIC_FORM.MANDATORY} : ${obj.label}`);
          return;
        }
        obj.value = obj.value === '' || obj.value === null ? [] : obj.value;
      }
    } else if (obj.type === templates.UI_TEMPLATES?.MULTI_SELECT_UI_TEMPLATE && obj.options) {
      const element = document.getElementById(key);
      if (
        element &&
        window.getComputedStyle(element).display === 'block'
      ) {
        const optionLabel = [];
        for (const i in obj.value) {
          for (let j = 0; j < obj.options.length; j++) {
            if (obj.options[j] === obj.value[i]) optionLabel.push(obj.options[j]);
          }
        }
        obj.optionLabel = optionLabel;
        obj.value = obj.value === '' ? [] : obj.value;
        if (
          !obj.isSkippable &&
          (obj.value === '' ||
            obj.value === null ||
            obj.value === undefined ||
            (Array.isArray(obj.value) && obj.value.length === 0))
        ) {
          showMessageAlert(`${form.DYNAMIC_FORM.MANDATORY} : ${obj.label}`);
          return;
        }
      }
    }
    else if (
      obj.type === templates.UI_TEMPLATES?.SINGLE_CHOICE_UI_TEMPLATE
    ) {
      const element = document.getElementById(key);
      if (
        element &&
        window.getComputedStyle(element).display === 'block'
      ) {
        if (!obj.isSkippable && !obj?.notShowFieldValues && (obj.value === '' || obj.value === null || obj.value === undefined)) {
          showMessageAlert(`${form.DYNAMIC_FORM.MANDATORY} : ${obj.label}`);
          return;
        }
        if (!obj.isSkippable && obj?.notShowFieldValues && obj?.enableAttachment && (obj?.attachmentList === undefined || obj?.attachmentList?.length === 0)) {
          showMessageAlert(`Please add atleast one attachment to : ${obj.label}`);
          return;
        }
        if (!obj.isSkippable && obj?.notShowFieldValues && obj?.enableComment && (obj?.commentsList === undefined || obj?.commentsList?.length === 0)) {
          showMessageAlert(`Please add atleast one comment to : ${obj.label}`);
          return;
        }
        if (obj?.options) {
          let optionLabel = '';
          for (let i = 0; i < obj.options.length; i++) {
            if (obj.options[i] === obj.value) optionLabel = obj.options[i];
          }
          obj.optionLabel = optionLabel;
        }
      }
    } else if (
      (obj.type === templates.UI_TEMPLATES?.RADIO_BUTTON_UI_TEMPLATE) &&
      obj.options
    ) {
      const element = document.getElementById(key);
      if (
        element &&
        window.getComputedStyle(element).display === 'block'
      ) {
        if (!obj.isSkippable && (obj.value === '' || obj.value === null || obj.value === undefined)) {
          showMessageAlert(`${form.DYNAMIC_FORM.MANDATORY} : ${obj.label}`);
          return;
        }
        let optionLabel = '';
        for (let i = 0; i < obj.options.length; i++) {
          if (obj.options[i] === obj.value) optionLabel = obj.options[i];
        }
        obj.optionLabel = optionLabel;
      }
    } else if (obj.type === templates.UI_TEMPLATES?.DATE_PICKER_UI_TEMPLATE) {
      const element = document.getElementById(key);
      if (
        element &&
        window.getComputedStyle(element).display === 'block'
      ) {
        if (!obj.isSkippable && (obj.value === '' || obj.value === null || obj.value === undefined)) {
          showMessageAlert(`${form.DYNAMIC_FORM.MANDATORY} : ${obj.label}`);
          return;
        }
        let dateString = '';
        if (obj?.dateFormat === "dd-MM-yyyy") {
          if (moment(obj?.value, 'YYYY-MM-DD', true).isValid()) {
            dateString = obj?.value;
          } else {
            // Step 1: Parse the date correctly using the 'DD-MM-YYYY' format
            const parsedDate = moment(obj.value, 'DD-MM-YYYY', true);  // Strict mode ensures exact format match
            // Step 2: If the date is valid, convert it to 'YYYY-MM-DD' format
            if (parsedDate.isValid()) {
              dateString = parsedDate.format('YYYY-MM-DD');
              console.log('Formatted Date:', dateString);
            } else {
              console.log('Invalid date format');
            }
          }
        } else {
          dateString = obj.value ? moment(obj.value).format('YYYY-MM-DD') : '';
        }
        obj.value = dateString;
      }
    } else if (obj.type === templates.UI_TEMPLATES?.MOBILE_NUMBER_UI_TEMPLATE) {
      const element = document.getElementById(key);
      if (
        element &&
        window.getComputedStyle(element).display === 'block'
      ) {
        if (!obj.isSkippable && (obj.value === '' || obj.value === null || obj?.value?.length === 0 || obj.value === undefined)) {
          showMessageAlert(`${form.DYNAMIC_FORM.MANDATORY} : ${obj.label}`);
          return;
        }
        const numstr = obj.value ? obj.value.toString() : '';
        obj.value = numstr;
        if (obj.isValid === false) {
          showMessageAlert(`Please enter valid : ${obj.label}`);
          return false;
        }
      }
    } else if (obj.type === templates.UI_TEMPLATES?.LOCATION_UI_TEMPLATE) {
      const element = document.getElementById(key);
      if (
        element &&
        window.getComputedStyle(element).display === 'block'
      ) {
        if (!obj.isSkippable) {
          if (obj.value === '' || obj.value === null || obj.value === undefined || obj.coordinates?.length === 0) {
            showMessageAlert(`Please point a location on the map : ${obj.label}`);
            return false;
          }
        }
      }
    } else if (obj.type === templates.UI_TEMPLATES?.SIGNATURE_UI_TEMPLATE) {
      if (!obj.isSkippable) {
        const element = document.getElementById(key);
        if (
          element &&
          window.getComputedStyle(element).display === 'block'
        ) {
          if (!obj.value || obj.value === form?.EMPTY_IMAGE || typeof obj.value === 'undefined') {
            showMessageAlert(`Please provide an eSignature : ${obj.label}`);
            return false;
          }
        }
      }
    } else if (
      obj.type === templates.UI_TEMPLATES?.NUMBER_UI_TEMPLATE ||
      obj.type === templates.UI_TEMPLATES?.CURRENCY_UI_TEMPLATE
    ) {
      if (!obj.isSkippable) {
        const element = document.getElementById(key);
        if (
          element &&
          window.getComputedStyle(element).display === 'block'
        ) {
          if (Number.isNaN(obj.value) || obj.value === '' || obj.value === null || obj.value === undefined) {
            showMessageAlert(`${form.DYNAMIC_FORM.MANDATORY} : ${obj.label}`);
            return false;
          }
          if (typeof obj.minDigits !== 'undefined' && obj.value && obj.value.toString().length < obj.minDigits) {
            showMessageAlert(`Value entered should be at least : ${obj.minDigits} digit(s). ${obj.label}`);
            return false;
          }
          // eslint-disable-next-line no-else-return
          if (typeof obj.maxDigits !== 'undefined' && obj.value && obj.value.toString().length > obj.maxDigits) {
            showMessageAlert(`Value entered should be ${obj.maxDigits} digit(s) : ${obj.label}`);
            return false;
          }
          if (typeof obj.value === 'undefined' || obj.value === null) {
            obj.value = 0;
          }
        }
      }
      if (obj?.dnaNegative && obj?.dnaNegative && obj?.value && obj?.value < 0) {
        showMessageAlert(`Negative values are not allowed in ${obj.label}`);
        return false;
      }

    } else if (obj.type === templates.UI_TEMPLATES?.EDIT_TEXT_UI_TEMPLATE) {
      if (!obj.isSkippable) {
        const element = document.getElementById(key);
        if (
          element &&
          window.getComputedStyle(element).display === 'block'
        ) {
          if (!obj.isSkippable) {
            if (obj.value === '' || obj.value === null || obj.value === undefined) {
              showMessageAlert(`${form.DYNAMIC_FORM.MANDATORY} : ${obj.label}`);
              return false;
            }
            if (
              typeof obj.minChars !== 'undefined' &&
              typeof obj.value !== 'undefined' &&
              obj.value.length < obj.minChars
            ) {
              showMessageAlert(`Value entered should be at least ${obj.minChars} character(s) : ${obj.label}`);
              return false;
            }
            // eslint-disable-next-line no-else-return
            else if (
              typeof obj.maxChars !== 'undefined' &&
              typeof obj.value !== 'undefined' &&
              obj.value.length > obj.maxChars
            ) {
              showMessageAlert(`Value entered should be of ${obj.maxChars} character(s): ${obj.label}`);
              return false;
            }
          }
        }
      }

    } else if (obj.type === templates.UI_TEMPLATES?.URL_UI_TEMPLATE) {
      const element = document.getElementById(key);
      if (
        element &&
        window.getComputedStyle(element).display === 'block'
      ) {
        if (!obj.isSkippable && (obj.value === '' || obj.value === null || obj.value === undefined)) {
          showMessageAlert(`${form.DYNAMIC_FORM.MANDATORY} : ${obj.label}`);
          return false;
        }
        if (obj.value) {
          // eslint-disable-next-line no-useless-escape
          const res = obj.value.match(/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/);
          if (res === null) {
            showMessageAlert(`Please enter valid : ${obj.label}`);
            return false;
          }
        }
      }
    } else if (obj.type === templates.UI_TEMPLATES?.TEXTAREA_UI_TEMPLATE) {
      const element = document.getElementById(key);
      if (
        element &&
        window.getComputedStyle(element).display === 'block'
      ) {
        if (!obj.isSkippable && (obj.value === '' || obj.value === null || obj.value === undefined)) {
          showMessageAlert(`${form.DYNAMIC_FORM.MANDATORY} : ${obj.label}`);
          return false;
        }
      }
    } else if (
      obj.type === templates.UI_TEMPLATES?.RATING_UI_TEMPLATE
    ) {
      const element = document.getElementById(key);
      if (
        element &&
        window.getComputedStyle(element).display === 'block'
      ) {
        if (!obj.isSkippable && (obj.value === '' || obj.value === null || obj.value === undefined)) {
          showMessageAlert(`${form.DYNAMIC_FORM.MANDATORY} : ${obj.label}`);
          return false;
        }
      }
    } else if (
      obj.type === templates.UI_TEMPLATES?.IMAGE_UPLOAD_UI_TEMPLATE ||
      obj.type === templates?.UI_TEMPLATES?.FILE_UPLOAD_UI_TEMPLATE
    ) {
      const element = document.getElementById(key);
      if (
        element && window.getComputedStyle(element).display === 'block'
      ) {
        if (!obj.isSkippable && (obj.value === '' || obj.value === null)) {
          showMessageAlert(`${form.DYNAMIC_FORM.MANDATORY} : ${obj.label}`);
          return false;
        }
      }
    } else if (obj.type === templates.UI_TEMPLATES?.EMAIL_TEXT_UI_TEMPLATE && !obj.allowCsv) {
      const element = document.getElementById(key);
      if (
        element &&
        window.getComputedStyle(element).display === 'block'
      ) {
        if (!obj.isSkippable && (obj.value === '' || obj.value === null || obj.value === undefined)) {
          showMessageAlert(`${form.DYNAMIC_FORM.MANDATORY} : ${obj.label}`);
          return false;
        }
        if (obj?.value && obj?.value !== null && obj?.value !== '') {
          // Now you can use the match method
          const regExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          const matchResult = regExp.test(obj.value);
          if (!matchResult) {
            showMessageAlert(`Please enter valid email Id : ${obj.label}`);
            return false;
          }
        }
      }
    }
    else if (obj.type === templates.UI_TEMPLATES?.EMAIL_TEXT_UI_TEMPLATE && obj.allowCsv) {
      const element = document.getElementById(key);
      if (
        element &&
        window.getComputedStyle(element).display === 'block'
      ) {
        if (!obj.isSkippable && (obj.value === '' || obj.value === null || obj.value === undefined)) {
          showMessageAlert(`${form.DYNAMIC_FORM.MANDATORY} : ${obj.label}`);
          return false;
        }
        if (obj?.value && obj?.value !== null && obj?.value !== '') {
          // Now you can use the match method
          const regExp = /^(\s?[^\s,]+@[^\s,]+\.[^\s,]+\s?,)*(\s?[^\s,]+@[^\s,]+\.[^\s,]+)$/;
          const matchResult = regExp.test(obj.value);
          if (!matchResult) {
            showMessageAlert(`Please enter valid email Id(s) : ${obj.label}`);
            return false;
          }
        }
      }
    } else if (
      obj.type === templates.UI_TEMPLATES?.BAR_CODE_UI_TEMPLATE ||
      obj.type === templates.UI_TEMPLATES?.QR_CODE_UI_TEMPLATE
    ) {
      if (!obj.isSkippable) {
        const element = document.getElementById(key);
        if (
          element &&
          window.getComputedStyle(element).display === 'block'
        ) {
          if (!obj.isSkippable) {
            if (obj.value === '' || obj.value === null || obj.value === undefined) {
              showMessageAlert(`${form.DYNAMIC_FORM.MANDATORY} : ${obj.label}`);
              return false;
            }
            if (
              typeof obj.maxChars !== 'undefined' &&
              typeof obj.value !== 'undefined' &&
              obj.value.length > obj.maxChars
            ) {
              showMessageAlert(`Value entered should be of ${obj.maxChars} character(s) : ${obj.label}`);
              return false;
            }
          }
        }
      }

    }
    // Add more validations for other field types as required
    fields[key] = obj;
  }
  return fields;
};
// getting the field col width dynamically.
const getPublicFormFieldStyle = (fieldData) => {
  const deviceType = getSession('DEVICE_TYPE');
  let columnWidth = fieldData?.columnWidth;

  if (fieldData.hasOwnProperty('profileSize')) {
    columnWidth = fieldData?.profileSize;
  }

  // let columnSpan = "auto/span 1";
  // let rowSpan = "auto/span 1";
  let rowWidth = "100%";

  if (columnWidth === 'col-3 col-sm-3') {
    // columnSpan = "span 1";
    rowWidth = "25%";
  }
  if (columnWidth === 'col-4 col-sm-4') {
    // columnSpan = "span 2";
    rowWidth = "33.33333333%";
  }
  if (columnWidth === 'col-6 col-sm-6') {
    // columnSpan = "span 3";
    rowWidth = "50%";
  }
  if (columnWidth === 'col-8 col-sm-8') {
    // columnSpan = "span 4";
    rowWidth = "66.66666666%";
  }
  if (columnWidth === 'col-9 col-sm-9') {
    // columnSpan = "span 5";
    rowWidth = "75%";
  }
  if (columnWidth === 'col-12 col-sm-12') {
    // columnSpan = "1/-1";
    rowWidth = "100%";
  }

  if (fieldData?.type === "sectionUiTemplate") {
    rowWidth = "100%";
  }
  const style = {
    width: deviceType === 'MOBILE' ? '100%' : (deviceType === 'TABLET' ? '50%' : rowWidth)
  }

  return style;
};

const getLookupDataforCopyTransacton = async (txnData, lookupField) =>{
  const businessId = getLoginBusinessId();
  const id = lookupField.value;
  const lookupValue = txnData.lookup[id];
  const {lookupType} = lookupField;
  const str = [];
  const obj = {};
  let imgUrl = null;
  const numberDisplayFields = [];
  const currencySymbol = getSession(`${businessId}_biz_currency_symbol`);
  const lookuptypeService = await getServiceData(lookupType, businessId);

  lookupField.displayFields.forEach((fieldKey) => {
    let preparedValue = '';
    let resObj = null;

    if (fieldKey.includes('fields.')) {
      resObj = lookupValue.fields[fieldKey.replace('fields.', '')];

      if (resObj && resObj.type === templates.UI_TEMPLATES.MOBILE_NUMBER_UI_TEMPLATE) {
        preparedValue = `+${resObj.code} ${resObj.value}`;
      } else if (resObj && resObj.type === templates.UI_TEMPLATES.DATE_PICKER_UI_TEMPLATE) {
        preparedValue = moment(resObj.value).format('MMM DD, YYYY');
      } else if (resObj && resObj.type === templates.UI_TEMPLATES.CURRENCY_UI_TEMPLATE) {
        const fieldName = fieldKey.replace('fields.', '');
        const precision = lookuptypeService.fields?.[fieldName]?.decimalPositions;
        preparedValue =
          currencySymbol === '₹'
            ? `₹ ${resObj.value.toFixed(precision)}`
            : `${currencySymbol} ${resObj.value.toFixed(precision)}`;
      } else {
        preparedValue = resObj ? resObj.value : '';
      }

      if (
        resObj &&
        resObj.type !== templates.UI_TEMPLATES.IMAGE_UPLOAD_UI_TEMPLATE &&
        preparedValue &&
        preparedValue !== ''
      ) {
        str.push(preparedValue);
      }

      if (
        resObj &&
        resObj.type === templates.UI_TEMPLATES.IMAGE_UPLOAD_UI_TEMPLATE &&
        preparedValue &&
        preparedValue !== ''
      ) {
        imgUrl = preparedValue;
      }

      if (
        resObj &&
        (resObj.type === templates.UI_TEMPLATES?.CURRENCY_UI_TEMPLATE ||
          resObj.type === templates.UI_TEMPLATES?.NUMBER_UI_TEMPLATE)
      ) {
        numberDisplayFields.push(fieldKey);
      }
    } else {
      preparedValue = lookupValue[fieldKey];
      str.push(preparedValue);
    }

    obj[fieldKey] = {
      value: preparedValue,
      type: resObj ? resObj.type : '',
    };
  });

  obj.id = id;
  obj.valueArr = str;
  obj.value = str?.join('');
  obj.lookupType = lookupType;
  obj.imgUrl = imgUrl;
  obj.appIconUrl = lookuptypeService?.iconUrl || "";
  return obj;
};

// isKioskModeEnabled then we will show that apps only.
const isKioskModeEnabledFunc = (serviceObjPermissionObj) => {
  for (const accessId in serviceObjPermissionObj) {
    const accessObj = serviceObjPermissionObj[accessId];
    if (accessObj?.enableKioskMode) {
      return true;
    }
  }
  return false;
};

// isKioskModeEnabled then we will show that apps only.
const getKioskModeLabelsFunc = (serviceObjPermissionObj) => {
  for (const accessId in serviceObjPermissionObj) {
    const accessObj = serviceObjPermissionObj[accessId];
    if (accessObj?.enableKioskMode) {
      return accessObj;
    }
  }
};

// show data mode and dashboard filters based on the data mode and dashboard mode.
const showDataModeFiltersFun = (isDataMode, isDashboardMode) => {
  if (isDataMode) {
    return true;
  }
  if (isDashboardMode) {
    return true;
  }
  return false;
}


export {
  ellipsis,
  dispatchAction,
  dispatchBizData,
  getFontSizeValue,
  getTextFieldValidationRules,
  getNumberFieldValidationRules,
  getTextAreaFieldValidationRules,
  readFieldPermission,
  getEmailFieldValidationRules,
  getCurrencySymbol,
  randomColor,
  convertToObj,
  processLookupOptions,
  gotoLoginPage,
  formatDate,
  getgoogleMapsEmbedURL,
  getDisplayFields,
  getServiceData,
  processOptions,
  getFieldWidth,
  getFieldStyle,
  handleActivityImage,
  debounce,
  handleTags,
  getDefaultDateRange,
  dateFormat,
  indexOfDates,
  getCategoryWiseServices,
  DataWithLimitAndSortByTitle,
  hideFieldPermission,
  gettingPerspectiveObj,
  isCheckServiceTxnCreatePermission,
  prepareFieldsData,
  prepareSubformData,
  validateMobileNumber,
  showMessageAlert,
  showSuccesMessageAlert,
  validateSubform,
  getBizAccountObjPermissionsList,
  basePath,
  getDefaultValue,
  prepareFieldsConfigValObj,
  setLookupValue,
  getLookupDisplayFieldsValueArray,
  formatCurrency,
  getFileExtension,
  isCheckServiceTxnReadonlyPermission,
  getColorCodeValue,
  openUrlWindow,
  getFileImage,
  actionScriptExecute,
  fieldActionScriptExecute,
  formlaFieldOnChangeCall,
  initializeScriptWrapperServiceFields,
  formulaActionScriptExecute,
  showWarningMessageAlert,
  showInfoMessageAlert,
  tokenHasExpired,
  isCheckServiceTxnEditPermission,
  getColSpan,
  getStatusFieldColors,
  getCommentslength,
  getXtraFieldsData,
  getAttachmentslength,
  checkIsAttachmentsExist,
  filedOrderApply,
  fetchSubformPreviewFieldsData,
  getPerspectiveIds,
  getIsHiddenModeVal,
  setAllFieldsAttachmentsData,
  getSubformXtraFieldsData,
  checkAccountUserPermission,
  getDependsOnOpts,
  preparingLookupFilterData,
  checkIsCustomFilterMode,
  getPerspectiveObjWithId,
  clearLookupDependsOn,
  indexOfYear,
  getFavRefdashboardIds,
  downloadImagesAsZip,
  showFieldGraphData,
  handleTableRowActionPermission,
  getFieldClassName,
  clearTableFieldsValues,
  prepareTableFormData,
  prepareTableFieldsData,
  scriptLogicForTableRow,
  getCommentAndAttachmentsCount,
  exportTableData,
  parseCSV,
  fieldColumnOrderApply,
  numberFieldValidations,
  textFieldValidations,
  emailFieldValidations,
  subFormFormulaActionScriptFun,
  subFormScriptLogicExecute,
  subFormFormlaFieldOnChangeCall,
  subFormScriptLogicOnChangeFun,
  initializeScriptWrapperFun,
  callFunFromScriptWrapper,
  replaceUnderscoresWithSpaces,
  onSelectLookup,
  getFieldName,
  subFormFieldLogicScriptExecute,
  formatUserAcountLocationTimestamp,
  languageLabelTranslate,
  redirectToAngular,
  getBizCodeFromUtill,
  readActionFieldPermission,
  getPerspectiveAccessId,
  assignSelectedLookupDataToTxnData,
  checkIsActionFlowExist,
  get24HoursFormatTime,
  getTimeDiffWithSeconds,
  getDateFormatFunction,
  removeDuplicatePerspectivesByKey,
  getTableDependsOnOpts,
  updateFieldsAndCheckChanges,
  showHideOnConfirmFunct,
  getAppIcon,
  getFirebaseServiceData,
  isLocationModeEnabled,
  getFileNameFromUrl,
  payLoadHideFieldPermission,
  getTimeFormatUsingMilliSeconds,
  getUniqueRefJobFunsData,
  getCategoryWiseServicesWithJobsFun,
  getDatFiltereLabel,
  cloneFields,
  updateTxnFormData,
  getFieldData,
  getMediaImgSrc,
  prepareWorkFlowQuckActionsFieldsData,
  getTableColSize,
  getPerspectiveObj,
  getFieldDataByFieldName,
  getCurrencyData,
  isEncryptedFieldDisbaled,
  getDifferenceInDays,
  handleCheckUserPermission,
  getTagsData,
  prepareTableDataForAddOrUpdateTableRows,
  txnFormDiff,
  showMessageAlertWithCloseButton,
  getTableFieldName,
  publicFormsActionScriptExecute,
  preparePublicFormFieldsData,
  getPublicFormFieldStyle,
  getLookupDataforCopyTransacton,
  isKioskModeEnabledFunc,
  getKioskModeLabelsFunc,
  showDataModeFiltersFun,
  getSelectedLookupArr
};
